const translations = {
  en: {
    // ── App ──────────────────────────────────────────────────────────────────
    app_name:        "Pinpoint",
    logout:          "Logout",
    save_changes:    "Save Changes",
    saving:          "Saving...",
    cancel:          "Cancel",
    close:           "Close",
    edit:            "Edit",
    delete:          "Delete",
    create:          "Create",
    search:          "Search",
    loading:         "Loading...",
    yes_delete:      "Yes, Delete",
    deleting:        "Deleting...",
    uploading:       "Uploading...",
    add:             "Add",
    select:          "Select",
    select_all:      "Select All",
    confirm:         "Confirm",
    back:            "Back",
    actions:         "Actions",
    no_data:         "No data yet",
    read_only:       "Read-only",
    coming_soon:     "Coming soon",

    // ── Roles ────────────────────────────────────────────────────────────────
    role_admin:      "Admin",
    role_supervisor: "Supervisor",
    role_operator:   "Operator",
    role_vendor:     "Vendor",

    // ── Status ───────────────────────────────────────────────────────────────
    active:          "Active",
    inactive:        "Inactive",
    disabled:        "Disabled",
    online:          "Online",
    offline:         "Offline",
    enabled:         "Enabled",

    // ── Nav items ────────────────────────────────────────────────────────────
    nav_overview:       "Overview",
    nav_live_map:       "Live Map",
    nav_users:          "Users",
    nav_supervisors:    "Supervisors",
    nav_operators:      "Operators",
    nav_vendors:        "Vendors",
    nav_sections:       "Sections",
    nav_clients:        "Clients",
    nav_reports:        "Reports",
    nav_statistics:     "Statistics",
    nav_notifications:  "Notifications",
    nav_notes:          "Notes Inbox",
    nav_stock:           "Stock Manager",
    nav_competitor_map:  "Coverage Map",
    nav_api_access:      "API Access",
    nav_settings:        "Settings",
    nav_events:          "Events",
    nav_profile:         "Profile",
    nav_companies:       "Companies",

    // ── Overview ─────────────────────────────────────────────────────────────
    overview_title:         "Overview",
    overview_active_vendors:"Active Vendors",
    overview_total_clients: "Total Clients",
    overview_events_today:  "Events Today",
    overview_alerts_today:  "Alerts Today",
    overview_recent_activity: "Recent Activity",
    overview_no_events:     "No events yet in your zones.",
    overview_my_zones:      "My Assigned Zones",
    overview_my_vendors:    "My Vendors",
    overview_my_clients:    "My Clients",
    overview_total_visits:  "Total Visits",
    overview_zone_alerts:   "Zone Alerts",
    overview_loading:        "Loading overview...",
    overview_total_users:    "Total Users",
    overview_zones:          "Zones",
    overview_active_today:   "Active Today",
    overview_registered_vendors: "registered vendors",
    overview_in_database:    "in database",
    overview_geofences:      "geofences defined",
    overview_vendors_on_field:"vendors on field",
    overview_clients_visited_today: "Clients Visited Today",
    overview_visits_this_week: "Visits This Week",
    overview_last_10_events: "Last 10 events",
    overview_no_activity:    "No activity yet",
    overview_unknown_vendor: "Unknown Vendor",
    overview_visited:        "visited",
    overview_checked_in_at:  "checked in at",
    overview_triggered_alert:"triggered alert in",
    overview_started_session:"started their session",
    overview_ended_session:  "ended their session",
    overview_entered_zone:   "entered",
    overview_exited_zone:    "exited",
    overview_unauth_zone:    "entered unauthorized zone",

    // ── Live Map ─────────────────────────────────────────────────────────────
    map_title:          "Live Map",
    map_show_clients:   "Show Clients",
    map_satellite:      "Satellite",
    map_roadmap:        "Map",
    map_legend_online:  "Online vendor",
    map_legend_offline: "Offline vendor",
    map_legend_client:  "Client",
    map_legend_zones:   "Shaded areas = your zones",
    map_vendor_status:  "Vendor Status",
    map_loading:        "Loading map...",
    map_last_seen:      "Last seen",
    map_speed:          "Speed",
    map_plate:          "Plate",

    // ── Users ─────────────────────────────────────────────────────────────────
    users_title:        "Users",
    users_total:        "total user(s)",
    users_add:          "+ Add User",
    users_new:          "New User",
    users_create:       "Create User",
    users_creating:     "Creating...",
    users_no_users:     "No users yet",
    users_no_users_sub: "Create your first user to get started",
    users_firebase_hint:"A Firebase login account will be automatically created with the email and password you provide.",
    users_delete_title: "Delete User",
    users_delete_msg:   "Their login account will also be removed. This cannot be undone.",
    users_bulk_delete:  "Delete Multiple Users",
    users_bulk_msg:     "Their login accounts will also be removed. This cannot be undone.",
    users_admins_hint:  "(admins cannot be selected)",

    // ── Supervisors ───────────────────────────────────────────────────────────
    sup_title:          "Supervisors",
    sup_add:            "+ Add Supervisor",
    sup_new:            "New Supervisor",
    sup_create:         "Create Supervisor",
    sup_access_hint:    "Supervisors have a read-only dashboard showing only their assigned zones' clients, vendors, live map, and delivery history. They cannot edit or delete anything.",
    sup_no_zones:       "No zones assigned",
    sup_no_vendors:     "No vendors assigned",
    sup_assigned_zones: "Assigned Zones",
    sup_zones_hint:     "Supervisor sees only clients and events in these zones",
    sup_assigned_vendors:"Assigned Vendors",
    sup_vendors_hint:   "Supervisor monitors these vendors on the live map",
    sup_search_vendors: "Search vendors by name, plate, or email...",
    sup_no_zones_defined:"No zones defined yet. Create zones in Sections first.",
    sup_no_vendors_exist:"No vendors exist yet. Create vendors first.",
    sup_delete_title:   "Delete Supervisor",
    sup_delete_msg:     "Their login account will also be removed. This cannot be undone.",
    sup_bulk_delete:    "Delete Multiple Supervisors",
    sup_notes:          "Notes",
    sup_notes_ph:       "Optional notes about this supervisor...",
    sup_my_zones:       "My Zones",

    // ── Vendors ───────────────────────────────────────────────────────────────
    vendors_title:      "Vendors",
    vendors_add:        "+ Add Vendor",
    vendors_new:        "New Vendor",
    vendors_no_vendors: "No vendors yet",
    vendors_delete_title:"Delete Vendor",
    vendors_delete_msg: "This will permanently remove the vendor. This cannot be undone.",
    vendors_bulk_delete:"Delete Multiple Vendors",
    vendors_plate:      "Vehicle Plate",
    vendors_vehicle:    "Vehicle Type",

    // ── Clients ───────────────────────────────────────────────────────────────
    clients_title:      "Clients",
    clients_add:        "+ Add Client",
    clients_new:        "New Client",
    clients_no_clients: "No clients yet",
    clients_delete_title:"Delete Client",
    clients_delete_msg: "This will permanently remove the client. This cannot be undone.",
    clients_bulk_delete:"Delete Multiple Clients",
    clients_zone:       "Zone",
    clients_all_zones:  "All Zones",
    clients_in_zones:   "clients in your zones",
    clients_import:     "Import",
    clients_export:     "Export",

    // ── Sections ──────────────────────────────────────────────────────────────
    sections_title:     "Sections / Zones",
    sections_add:       "+ Add Section",
    sections_new:       "New Section",
    sections_no_sections:"No sections yet",
    sections_delete_msg:"This will permanently remove the section. This cannot be undone.",
    sections_draw_hint: "Draw a polygon on the map to define this zone",
    sections_zone_name: "Zone Name",
    sections_zone_color:"Zone Color",

    // ── Events ────────────────────────────────────────────────────────────────
    events_title:       "Events & History",
    events_total:       "total events in your zones",
    events_all:         "All",
    events_visits:      "Visits",
    events_zone_enter:  "Zone Enter",
    events_zone_exit:   "Zone Exit",
    events_session_start:"Session Start",
    events_session_end: "Session End",
    events_no_events:   "No events match your filters.",
    events_all_vendors: "All Vendors",
    events_search_ph:   "Search by vendor or client name...",

    // ── Clients Manager extra keys ────────────────────────────────────────────
    clients_loading:         "Loading clients...",
    clients_select:          "Select",
    clients_cancel:          "✕ Cancel",
    clients_select_for_bulk: "Select clients to perform bulk actions",
    clients_selected_count:  "client(s) selected",
    clients_delete_selected: "Delete selected",
    clients_search_ph:       "Search by name, phone or address...",
    clients_no_results:      "No results found",
    clients_try_search:      "Try a different search term",
    clients_add_manually:    "Add a client manually",
    clients_showing:         "Showing",
    clients_of:              "of",
    clients_previous:        "Previous",
    clients_next:            "Next",
    clients_page:            "Page",
    clients_zone_auto:       "Zone",
    clients_auto_from_gps:   "(auto from GPS)",
    clients_auto_detect:     "Auto-detect from GPS",
    clients_type_category:   "Type / Category",
    clients_latitude:        "Latitude",
    clients_longitude:       "Longitude",
    clients_notes_ph:        "Notes for drivers...",
    clients_status:          "Status:",
    clients_zone_hint:       "🎯 Zone auto-detected from GPS if inside a defined zone.",
    clients_created_by:      "Created by",
    clients_cannot_undo_full: "This action cannot be undone. The client will be permanently removed.",

    // ── Vendors Manager extra keys ────────────────────────────────────────────
    vendors_loading:         "Loading vendors...",
    vendors_total:           "total",
    vendors_active:          "active",
    vendors_online:          "online",
    vendors_select:          "Select",
    vendors_cancel:          "✕ Cancel",
    vendors_live_map:        "Live Map",
    vendors_select_for_bulk: "Select vendors for bulk actions",
    vendors_selected_count:  "vendor(s) selected",
    vendors_auto_account:    "Auto Account Setup",
    vendors_auto_account_msg:"When you create a vendor, a login account is automatically created with their email and password.",
    vendors_locations:       "Vendor Locations",
    vendors_with_location:   "vendor(s) with known location",
    vendors_online_10min:    "Online (last 10 min)",
    vendors_search_ph:       "Search by name, phone, IMEI, or plate...",
    vendors_imei:            "IMEI",
    vendors_imei_hint:       "GPS tracker device ID",
    vendors_assigned_zones:  "Assigned Zones",
    vendors_no_zones:        "No zones defined yet.",
    vendors_days_off:        "Days Off",
    vendors_days_off_hint:   "Selected days will be excluded from \"no visits\" alerts",
    vendors_status:          "Status:",
    vendors_cannot_undo_full:"Their login accounts will also be removed. This cannot be undone.",
    vendors_create_vendor:   "Create Vendor",
    vendors_save_changes:    "Save Changes",

    // ── Users Manager extra keys ──────────────────────────────────────────────
    users_loading:           "Loading users...",
    users_select:            "Select",
    users_cancel:            "✕ Cancel",
    users_select_for_bulk:   "Select users to perform bulk actions",
    users_selected_count:    "user(s) selected",
    users_filter_all:        "All",
    users_filter_admins:     "Admins",
    users_filter_supervisors:"Supervisors",
    users_filter_operators:  "Operators",
    users_filter_vendors:    "Vendors",
    users_active:            "Active",
    users_disabled:          "Disabled",
    users_admin_badge:       "👑 Admin",
    users_role_supervisor_desc: "Supervisor — can view all vendors and clients in assigned zones",
    users_role_operator_desc:   "Operator — can manage clients and view delivery status",
    users_role_vendor_desc:     "Vendor — mobile app user who performs deliveries",
    users_delete_selected:   "Delete selected",

    // ── Sections Manager extra keys ───────────────────────────────────────────
    sections_loading:        "Loading...",
    sections_map_loading:    "Loading map...",
    sections_geofences:      "Sections & Geofences",
    sections_satellite:      "Satellite",
    sections_map:            "Map",
    sections_importing:      "Importing...",
    sections_import:         "Import",
    sections_export:         "Export",
    sections_draw_new_zone:  "+ Draw New Zone",
    sections_cancel_drawing: "Cancel Drawing",
    sections_draw_hint_msg:  "Click to add points · Double-click to complete zone",
    sections_edit_zone:      "Edit Zone",
    sections_new_zone:       "New Zone",
    sections_zone_name_label:"Zone Name *",
    sections_color_label:    "Color",
    sections_custom_color:   "custom",
    sections_description:    "Description",
    sections_optional:       "Optional",
    sections_save_changes:   "Save Changes",
    sections_create_zone:    "Create Zone",
    sections_zones_label:    "Zones",
    sections_search_zones:   "Search zones...",
    sections_no_zones:       "No zones yet",
    sections_draw_first:     "Draw your first zone on the map",
    sections_draw_first_btn: "Draw First Zone",
    sections_pts:            "pts",
    sections_zones_total:    "zones total",
    sections_delete_zone:    "Delete Zone",
    sections_delete_confirm: "Are you sure you want to delete this zone? This cannot be undone.",

    // ── Supervisors Manager extra keys ────────────────────────────────────────
    sup_loading:             "Loading supervisors...",
    sup_select:              "Select",
    sup_cancel:              "✕ Cancel",
    sup_supervisor_access:   "Supervisor Access",
    sup_select_for_bulk:     "Select supervisors for bulk actions",
    sup_selected_count:      "supervisor(s) selected",
    sup_active:              "active",
    sup_no_supervisors:      "No supervisors yet",
    sup_create_assign_hint:  "Create a supervisor and assign them zones and vendors to monitor",
    sup_zones_label:         "Zones:",
    sup_vendors_label:       "Vendors:",
    sup_supervisor_badge:    "🔭 supervisor",
    sup_basic_info:          "Basic Info",
    sup_login_auto:          "A login account will be automatically created for this supervisor.",
    sup_new_supervisor:      "New Supervisor",
    sup_assigned_zones_label:"Assigned Zones",
    sup_assigned_vendors_label:"Assigned Vendors",
    sup_status_label:        "Status:",

    // ── Operators Manager extra keys ──────────────────────────────────────────
    op_select_for_bulk:      "Select operators for bulk actions",
    op_selected_count:       "operator(s) selected",
    op_no_match:             "No operators match your search.",
    op_active:               "active",

    // ── Notifications Page ────────────────────────────────────────────────────
    notif_loading:           "Loading notifications...",
    notif_filter_all:        "All",
    notif_filter_alerts:     "Alerts",
    notif_filter_visits:     "Visits",
    notif_filter_sessions:   "Sessions",
    notif_clear_all:         "Clear All",
    notif_confirm_clear:     "Clear All Notifications",
    notif_confirm_clear_msg: "This will permanently delete all notifications. This cannot be undone.",
    notif_clearing:          "Clearing...",
    notif_cleared:           "✅ All notifications cleared.",
    notif_empty:             "No notifications",
    notif_speed:             "Speeding",
    notif_long_stop:         "Long Stop",
    notif_no_visits:         "No Visits",
    notif_outside_hours:     "Outside Hours",
    notif_wrong_zone:        "Wrong Zone",
    notif_checkin:           "Check-in",
    notif_visit:             "Visit",

    // ── Reports Page ─────────────────────────────────────────────────────────
    reports_loading:         "Generating report...",
    reports_select_type:     "Select a report type",
    reports_select_hint:     "Choose a report type from the left to get started",
    reports_date_from:       "Date From",
    reports_date_to:         "Date To",
    reports_time_from:       "Time From",
    reports_time_to:         "Time To",
    reports_all_vendors:     "All Vendors",
    reports_all_zones:       "All Zones",
    reports_generate_btn:    "Generate Report",
    reports_download_pdf:    "Download PDF",
    reports_no_data:         "No data for this period",
    reports_client_visits:   "Client Visits",
    reports_zone_coverage:   "Zone Coverage",
    reports_vendor_activity: "Vendor Activity",
    reports_out_of_zone:     "Out-of-Zone History",
    reports_unauth_zone:     "Unauthorized Zone",
    reports_zone_geofence:   "Zone / Geofence",
    reports_daily_summary:   "Daily Summary",
    reports_client_creation: "Client Creation",
    reports_custom:          "Custom Report",

    // ── Statistics Page ───────────────────────────────────────────────────────
    stats_analytics:         "Statistics & Analytics",
    stats_track_hint:        "Track visits, alerts, and vendor performance over time",

    // ── Stock Manager ─────────────────────────────────────────────────────────
    stock_title:             "Stock Manager",
    stock_desc:              "Manage product catalog, vendor stock, sales and movements",
    stock_tab_catalog:       "Products Catalog",
    stock_tab_vendor:        "Vendor Stock",
    stock_tab_sales:         "Sales History",
    stock_tab_movements:     "Stock Movements",
    stock_tab_requests:      "Restock Requests",

    // ── Reports ───────────────────────────────────────────────────────────────
    reports_title:      "Reports",
    reports_generate:   "Generate Report",
    reports_download:   "Download",

    // ── Statistics ────────────────────────────────────────────────────────────
    stats_title:        "Statistics",

    // ── Notifications ─────────────────────────────────────────────────────────
    notif_title:        "Notifications",
    notif_no_notif:     "No notifications yet",
    notif_mark_read:    "Mark all as read",

    // ── Settings ─────────────────────────────────────────────────────────────
    settings_title:     "Company Settings",
    settings_subtitle:  "Configure your company preferences",
    settings_general:   "General",
    settings_tracking:  "Tracking",
    settings_hours:     "Working Hours",
    settings_alerts:    "Alerts",
    settings_appearance:"Appearance",
    settings_saved:     "✅ Settings saved successfully!",
    settings_timezone:  "Timezone",
    settings_language:  "Language",
    settings_date_format:"Date Format",
    settings_nearby_dist:"Nearby Distance (meters)",
    settings_nearby_hint:"Distance to detect driver arrival at client",
    settings_gps_interval:"GPS Update Interval (seconds)",
    settings_gps_hint:  "How often the vendor app sends location updates",
    settings_max_speed: "Max Speed Alert (km/h)",
    settings_max_speed_hint:"Set to 0 to disable speed alerts",
    settings_auto_checkin:"Auto Check-in",
    settings_auto_checkin_desc:"Automatically record a visit when a vendor arrives at a client location",
    settings_manual_checkin:"Allow Manual Check-in",
    settings_manual_checkin_desc:"Vendors can manually mark a visit from the mobile app",
    settings_require_notes:"Require Notes on Visit",
    settings_require_notes_desc:"Vendors must add a note when recording a visit",
    settings_notif_sound:"Notification Sound",
    settings_notif_sound_desc:"Play a sound when new alerts arrive",
    settings_work_start:"Start Time",
    settings_work_end:  "End Time",
    settings_track_outside:"Track Outside Working Hours",
    settings_track_outside_desc:"Continue recording GPS positions and events after working hours end",
    settings_working_days:"Working Days",
    settings_working_days_hint:"Select which days vendors are expected to work",
    settings_out_of_zone:"Out-of-Zone Alerts",
    settings_out_of_zone_desc:"Send an alert when a vendor leaves their assigned zone",
    settings_cooldown:  "Alert Cooldown (minutes)",
    settings_cooldown_hint:"Minimum time between repeated alerts for the same vendor",
    settings_missed_visit:"Alert on Missed Visit",
    settings_missed_visit_desc:"Notify when a scheduled client was not visited by end of day",
    settings_long_stop: "Alert on Long Stop",
    settings_long_stop_desc:"Notify when a vendor stays at one location for too long",
    settings_long_stop_min:"Long Stop Threshold (minutes)",
    settings_long_stop_hint:"Alert if vendor stays at same GPS point longer than this",
    settings_company_name:"Company Name",
    settings_company_ph:"Your company name",
    settings_phone:     "Phone",
    settings_email:     "Email",
    settings_address:   "Address",
    settings_logo:      "Company Logo",
    settings_logo_change:"Change Logo",
    settings_logo_upload:"Upload Logo",
    settings_logo_remove:"Remove",
    settings_logo_hint: "PNG, JPG up to 2MB",
    settings_color:     "Primary Color",
    settings_color_hint:"Used for branding in reports and exports",

    // ── Forms ─────────────────────────────────────────────────────────────────
    form_first_name:    "First Name",
    form_last_name:     "Last Name",
    form_email:         "Email",
    form_email_login:   "(login)",
    form_phone:         "Phone",
    form_password:      "Password",
    form_password_keep: "(leave blank to keep)",
    form_password_min:  "Min 6 characters",
    form_role:          "Role",
    form_status:        "Status",
    form_show:          "Show",
    form_hide:          "Hide",
    form_required:      "required",
    form_notes:         "Notes",
    form_name:          "Name",
    form_address:       "Address",

    // ── Delete modal shared ───────────────────────────────────────────────────
    delete_cannot_undo: "This cannot be undone.",
    delete_selected:    "selected",
    delete_all:         "Delete All",

    // ── Company (super admin) ─────────────────────────────────────────────────
    company_id:         "Company",
    super_admin_badge:  "Super Admin",
    // ── Operator Dashboard ───────────────────────────────────────────────────
    op_dash_my_clients:   "My Clients",
    op_dash_statistics:   "Statistics",
    op_dash_profile:      "Profile",

    // ── Operator — Add/Edit Client ───────────────────────────────────────────
    op_client_title:      "Add Client",
    op_client_edit_title: "Edit Client",
    op_client_first_name: "First Name",
    op_client_last_name:  "Last Name",
    op_client_phone:      "Phone",
    op_client_address:    "Address",
    op_client_notes:      "Notes",
    op_client_notes_ph:   "Any additional notes...",
    op_client_pin_title:  "Pin Location",
    op_client_pin_hint:   "Tap the map or drag the pin",
    op_client_use_gps:    "Use My Location",
    op_client_locating:   "Locating...",
    op_client_gps_error:  "Could not get location",
    op_client_save:       "Save Client",
    op_client_update:     "Update Client",
    op_client_saving:     "Saving...",
    op_client_updating:   "Updating...",
    op_client_saved:      "Client saved successfully",
    op_client_delete_title: "Delete Client",
    op_client_delete_msg:   "Are you sure you want to delete this client?",

    // ── Operator — My Clients ────────────────────────────────────────────────
    op_my_clients_title:  "My Clients",
    op_my_clients_empty:  "No clients added yet",
    op_my_clients_search: "Search clients...",
    op_my_clients_date:   "Added",

    // ── Operator — Statistics ────────────────────────────────────────────────
    op_stats_title:        "My Statistics",
    op_stats_total:        "Total Clients",
    op_stats_today:        "Added Today",
    op_stats_week:         "This Week",
    op_stats_deleted:      "Deleted",
    op_stats_daily_chart:  "Last 7 Days",
    op_stats_weekly_chart: "Last 4 Weeks",
    op_stats_week_label:   "Week",
    op_stats_count:        "Clients",

    // ── Operator — Profile ───────────────────────────────────────────────────
    op_profile_title:      "My Profile",
    op_profile_change_pw:  "Change Password",
    op_profile_current_pw: "Current Password",
    op_profile_new_pw:     "New Password",
    op_profile_confirm_pw: "Confirm Password",
    op_profile_pw_mismatch:"Passwords do not match",
    op_profile_pw_updated: "Password updated successfully",
    op_profile_updating:   "Updating...",

    // ── Operators Manager ────────────────────────────────────────────────────
    op_title:           "Operators",
    op_add:             "+ Add Operator",
    op_new:             "New Operator",
    op_create:          "Create Operator",
    op_edit:            "Edit Operator",
    op_access_hint:     "Operators can add clients from the mobile app",
    op_clients_count:   "clients",
    op_bulk_delete:     "Delete Selected",
    op_delete_title:    "Delete Operator",
    op_delete_msg:      "Are you sure you want to delete this operator?",
    op_no_operators:    "No operators yet",
    op_search_ph:       "Search by name or email...",
    op_notes:           "Notes",
    op_notes_ph:        "Internal notes about this operator...",
    op_new_password:    "New Password",
    op_new_password_ph: "Leave blank to keep current password",

    // ── Login page ───────────────────────────────────────────────────────────
    login_email:        "Email Address",
    login_password:     "Password",
    login_submit:       "Sign In",
    login_signing_in:           "Signing in...",
    login_welcome:              "Sign in to",
    login_subtitle:             "Enter your credentials to access your dashboard.",
    login_eyebrow:              "Field Operations Platform",
    login_tagline:              "Field Operations, Delivered.",
    login_tagline_sub:          "Real-time visibility over your vendors, clients, and delivery zones — all in one platform.",
    login_feature_tracking:     "Live Vendor Tracking",
    login_feature_tracking_sub: "See every vendor's real-time position across your zones.",
    login_feature_visits:       "Client Visit Management",
    login_feature_visits_sub:   "Track check-ins, coverage rates, and visit history.",
    login_feature_coverage:     "Zone Coverage Analytics",
    login_feature_coverage_sub: "Monitor delivery performance across all your territories.",
    login_suspended_msg:        "Your company account has been suspended due to a payment issue or subscription expiry.",
    login_suspended_contact:    "Need help? Contact support at:",
    login_suspended_back:       "Back to login",
    login_error_disabled:       "Your account has been disabled. Contact your administrator.",
    login_error_generic:        "Incorrect email or password. Please try again.",

    // ── SuperAdmin ───────────────────────────────────────────────────────────
    nav_all_companies:       "All Companies",
    nav_create_company:      "Create Company",
    nav_global_settings:     "Global Settings",
    nav_health:              "Platform Health",
    nav_sa_settings:         "My Settings",

    tab_overview:            "Overview",
    tab_edit:                "Edit",
    tab_subscription:        "Subscription",
    tab_vendors:             "Vendors",
    tab_clients:             "Clients",
    tab_zones:               "Zones",
    tab_reset_checkins:      "Reset Check-ins",
    tab_analytics:           "Analytics",
    tab_sessions:            "Sessions",

    btn_refresh:             "Refresh",
    btn_login_as_admin:      "Login as Admin",
    btn_view_details:        "View Details",
    btn_disable:             "Disable",
    btn_enable:              "Enable",
    btn_yes_disable:         "Yes, Disable",
    btn_yes_enable:          "Yes, Enable",
    btn_yes_delete_all:      "Yes, Delete All",

    lbl_company_name:        "Company Name",
    lbl_billing_plan:        "Plan",
    lbl_balance:             "Balance",
    lbl_status:              "Status",
    lbl_suspended:           "Suspended",
    lbl_total_companies:     "Total Companies",
    lbl_total_vendors:       "Total Vendors",
    lbl_total_clients:       "Total Clients",
    lbl_visits_today:        "Visits Today",
    lbl_last_activity:       "Last Activity",
    lbl_expiring_soon:       "Expiring in 7 days",
    lbl_gps_live:            "Live",
    lbl_language:            "Language",
    lbl_appearance:          "Appearance",
    lbl_dark_mode:           "Dark Mode",
    lbl_dark_mode_hint:      "Switch to dark theme",
    lbl_change_password:     "Change Password",
    lbl_current_password:    "Current Password",
    lbl_new_password:        "New Password",
    lbl_confirm_password:    "Confirm New Password",
    lbl_feature_controls:    "Feature Controls",
    lbl_usage_limits:        "Usage Limits",

    sa_viewing:              "Viewing:",
    sa_back_all:             "← Back to all",
    sa_back:                 "← Back",
    sa_settings_sub:         "Language, appearance, and account security",
    sa_dark_mode_hint:       "Switch to dark theme",
    sa_platform_health_sub:  "Live overview of all companies and activity",
    sa_login_blocked:        "Login blocked",
    sa_getting_access:       "Getting access...",
    sa_company_disabled:     "Company Disabled",
    sa_disable_company:      "Disable Company",
    sa_enable_company:       "Enable Company",
    sa_delete_company:       "Delete Company",
    sa_usage_limits:         "Usage Limits",
    sa_platform_visits:      "Platform Visits — Last 7 Days",
    sa_global_settings:      "Global Default Settings",
    sa_global_settings_sub:  "Defaults applied to all new companies.",
    sa_changing_password:    "Changing...",
    sa_super_admin_badge:    "SUPER ADMIN",
    sa_updated:              "Updated",
    sa_admins:               "Admins",
    sa_supervisors:          "Supervisors",
    sa_vendors_count:        "vendors",
    sa_clients_count:        "clients",
    sa_zones_count:          "zones",
    sa_events_count:         "events",
    sa_expires:              "Expires:",
    sa_company_gps_warning:  "Companies — No GPS Activity for 7+ Days",
    sa_gps_warning_sub:      "These companies may need follow-up. Their vendors may have stopped using the platform.",
    sa_all_companies_count:  "All Companies",
    sa_platform_visits_7d:   "Platform Visits — Last 7 Days",
    sa_loading_health:       "Loading platform health data...",
    sa_retry:                "Retry",
    sa_view:                 "View",
    sa_last_activity:        "Last activity:",
    sa_no_activity:          "No activity",
    sa_today:                "Today",
    sa_yesterday:            "Yesterday",
    sa_days_ago:             "days ago",
    sa_loading:              "Loading...",
    sa_expired:              "Expired",
    sa_balance_zero:         "Balance 0",

    // ── GlobalSettings ───────────────────────────────────────────────────────
    lbl_working_hours:         "Working Hours",
    lbl_wh_start:              "Start",
    lbl_wh_end:                "End",
    lbl_new_company_defaults:  "New Company Defaults",
    lbl_default_max_vendors:   "Default Max Vendors",
    lbl_default_max_clients:   "Default Max Clients",
    lbl_default_ooz_alerts:    "Default Out-of-Zone Alerts",
    lbl_tracking:              "Tracking",
    lbl_nearby_distance_m:     "Nearby Distance (m)",
    lbl_min_distance_m:        "Min Allowed Distance (m)",
    lbl_alert_cooldown_min:    "Alert Cooldown (min)",
    lbl_max_speed_kmh:         "Max Speed Alert (km/h, 0=off)",
    lbl_offline_threshold_min: "Offline threshold (minutes)",
    lbl_offline_threshold_hint:"A vendor is marked offline if no GPS data is received for this many minutes",
    lbl_auto_checkin:          "Auto Check-in:",
    lbl_regional:              "Regional",
    lbl_date_format:           "Date Format",
    btn_save_global_settings:  "Save Global Settings",
    lbl_saving:                "Saving...",
    lbl_resetting:             "Resetting...",

    // ── CreateCompany ────────────────────────────────────────────────────────
    create_company_title:      "Create New Company",
    create_company_desc:       "Creates the company + admin account automatically.",
    lbl_company_info:          "Company Info",
    lbl_admin_account_section: "Company Admin Account",
    lbl_tier:                  "Tier",
    lbl_out_of_zone_alerts:    "Out-of-Zone Alerts",
    lbl_max_vendors:           "Max Vendors",
    lbl_max_clients:           "Max Clients",
    lbl_first_name:            "First Name",
    lbl_last_name:             "Last Name",
    lbl_admin_email:           "Admin Email",
    lbl_admin_password:        "Admin Password",
    btn_create_company:        "Create Company",
    lbl_creating:              "Creating...",

    // ── EditTab ──────────────────────────────────────────────────────────────
    lbl_company_details:       "Company Details",
    lbl_company_logo:          "Company Logo",
    lbl_choose_image:          "Choose Image",
    lbl_upload_logo:           "Upload Logo",
    btn_save_details:          "Save Details",
    btn_save_feature_settings: "Save Feature Settings",
    lbl_change_admin_email:    "Change Admin Email",
    lbl_change_email_desc:     "Changes the login email for this company's admin account.",
    lbl_current_email:         "Current email:",
    btn_change_email:          "Change Email",
    lbl_reset_admin_password:  "Reset Admin Password",
    lbl_reset_password_desc:   "Changes the login password for this company's admin account.",
    btn_reset_password:        "Reset",
    lbl_feature_controls_desc: "Enable or disable features for this company. Changes take effect immediately.",
    lbl_stock_pos:             "Stock & POS System",
    lbl_stock_pos_desc:        "Vendors can manage stock and sell items to clients",
    lbl_route_optimization:    "Route Optimization",
    lbl_route_optimization_desc:"Vendors can optimize their daily route automatically",
    lbl_route_basic:           "Basic (Free)",
    lbl_route_google:          "Google Routes (Premium)",
    lbl_anomaly_detection:     "Anomaly Detection",
    lbl_anomaly_detection_desc:"Auto-detect suspicious patterns: speeding, long stops, no visits, outside hours",
    lbl_api_access:            "API Access",
    lbl_api_access_desc:       "Company admin can generate API keys to integrate with external systems",

    // ── SubscriptionTab ──────────────────────────────────────────────────────
    lbl_account_suspended:     "Account Suspended",
    lbl_balance_zero_suspended:"Balance reached 0. Add a deposit to re-activate.",
    lbl_company_disabled_msg:  "This company is disabled. Re-enable it manually.",
    lbl_plan_settings:         "Plan & Settings",
    lbl_add_deposit_tab:       "Add Deposit",
    lbl_deposit_history:       "Deposit History",
    lbl_subscription_plan:     "Subscription Plan",
    lbl_monthly_billing:       "Monthly Billing",
    lbl_monthly_billing_desc:  "Client pays a deposit. System deducts monthly fee ÷ 30 daily. Account blocked when balance reaches 0.",
    lbl_active_forever:        "Active Forever",
    lbl_active_forever_desc:   "No payment tracking. Account stays active until you manually disable or delete it.",
    lbl_expiry_by_date:        "Expiry by Date",
    lbl_expiry_by_date_desc:   "Account is active until a set date. Automatically disabled when date passes.",
    lbl_initial_deposit_aed:   "Initial Deposit (AED)",
    lbl_monthly_fee_aed:       "Monthly Fee (AED)",
    lbl_current_balance_aed:   "Current Balance (AED)",
    lbl_months_remaining:      "Months remaining:",
    lbl_notes:                 "Notes",
    lbl_expiry_date_req:       "Expiry Date *",
    btn_save_plan:             "Save Plan",
    lbl_current_status:        "Current Status",
    lbl_plan_type_label:       "Plan Type",
    lbl_monthly_fee_label:     "Monthly Fee",
    lbl_current_balance_display:"Current Balance:",
    lbl_deposit_amount_aed:    "Deposit Amount (AED) *",
    lbl_note_optional:         "Note (optional)",
    lbl_new_balance_after:     "New balance after deposit:",
    btn_add_deposit:           "Add Deposit",
    lbl_adding:                "Adding...",
    lbl_no_deposits:           "No deposits recorded yet",
    th_date:                   "Date",
    th_amount:                 "Amount",
    th_balance_after:          "Balance After",
    th_type:                   "Type",
    th_note:                   "Note",
    lbl_monthly_charge:        "Monthly charge",
    lbl_deposit_label:         "Deposit",
    lbl_days_remaining_label:  "Days Remaining",
    lbl_daily_rate:            "Daily Rate",
    lbl_per_day:               "/ day",
    // ── Subscription Panel (admin overview — read-only) ──────────────────────
    lbl_subscription_billing:       "Subscription & Billing",
    lbl_last_deduction:             "Last Deduction",
    lbl_not_yet:                    "Not yet",
    lbl_days_remaining_approx:      "days remaining",
    lbl_active_forever_billing_msg: "This account is active forever — no balance or expiry tracking.",
    lbl_active_until:               "Active until",
    lbl_subscription_expired_title: "Subscription Expired",
    lbl_low_balance_warning:        "Low balance — your subscription will be suspended in approximately {days} day(s). Please contact your administrator to add funds.",
    lbl_suspended_balance_warning:  "Your subscription has been suspended due to insufficient balance. Please contact your administrator.",
    lbl_h_ago:                      "{n}h ago",
    lbl_d_ago:                      "{n}d ago",

    // ── VendorsTab ───────────────────────────────────────────────────────────
    lbl_no_vendors_yet:        "No vendors yet",

    // ── ClientsTab ───────────────────────────────────────────────────────────
    lbl_with_gps:              "With GPS",
    lbl_assigned_zone:         "Assigned to Zone",
    lbl_visited_stat:          "Visited",
    lbl_client_import_info:    "Client details are managed from the company's Admin Dashboard. Super Admin can see counts and statistics here only.",
    lbl_import_export_clients: "Import / Export Clients",
    btn_import_clients:        "Import Clients",
    btn_download_all:          "Download All",
    btn_delete_all_clients:    "Delete All Clients",
    lbl_will_be_uploaded:      "Will be uploaded",
    lbl_duplicates_skipped:    "Duplicates skipped",
    lbl_no_coordinates:        "No coordinates",
    lbl_all_duplicates_msg:    "All clients in this file already exist — nothing to upload",
    lbl_delete_all_clients_title:"Delete All Clients",

    // ── ResetCheckinsTab ─────────────────────────────────────────────────────
    lbl_select_scope:          "Select Scope",
    lbl_all_zones_company:     "All Zones (entire company)",
    lbl_loading_checked_in:    "Loading checked-in clients...",
    lbl_currently_checked_in:  "clients currently checked in",
    lbl_visited_badge:         "● Visited",
    lbl_confirm_reset_title:   "Confirm Reset",
    btn_confirm_reset:         "Confirm Reset",
    lbl_reset_complete_msg:    "Reset complete",
    lbl_tab_reset_desc:        "Clears visited status so vendors can check in again today",

    // ── ZonesTab ─────────────────────────────────────────────────────────────
    btn_import:                "Import",
    btn_export:                "Export",
    lbl_no_zones_yet:          "No zones defined yet. Import a GeoJSON or KML file to add zones.",
    lbl_polygon_points:        "polygon points",
    lbl_no_polygon_defined:    "No polygon defined",

    // ── CompanyAnalytics ─────────────────────────────────────────────────────
    lbl_usage_analytics:       "Usage Analytics",
    lbl_7_days:                "7 Days",
    lbl_30_days:               "30 Days",
    lbl_90_days:               "90 Days",
    lbl_total_checkins:        "Total Check-ins",
    lbl_avg_visits_day:        "Avg Visits / Day",
    lbl_active_vendors_stat:   "Active Vendors",
    lbl_total_alerts_stat:     "Total Alerts",
    lbl_speed_alerts_stat:     "Speed Alerts",
    lbl_long_stop_alerts_stat: "Long Stop Alerts",
    lbl_clients_visited:       "Clients Visited",
    lbl_total_events:          "Total Events",
    lbl_daily_activity:        "Daily Activity — Last",
    lbl_days:                  "Days",
    lbl_top_vendors_visits:    "Top Vendors by Visits",
    lbl_most_visited_clients:  "Most Visited Clients",
    lbl_alert_breakdown:       "Alert Breakdown",
    lbl_no_visits_recorded:    "No visits recorded",
    lbl_no_alerts_period:      "No alerts in this period — great performance!",
    lbl_loading_analytics:     "Loading analytics...",
    lbl_zone_alerts:           "Zone Alerts",
    lbl_outside_hours_alerts:  "Outside Hours Alerts",

    // SuperAdmin My Settings — 2FA
    lbl_two_factor_auth:       "Two-Factor Authentication",
    lbl_2fa_enabled:           "2FA is enabled",
    lbl_2fa_disabled:          "2FA is disabled",
    btn_enable_2fa:            "Enable 2FA",
    btn_disable_2fa:           "Disable 2FA",
    lbl_2fa_scan_qr:           "Scan this QR code with Google Authenticator or Authy:",
    lbl_2fa_enter_code:        "After scanning, enter the 6-digit code from your app:",
    lbl_2fa_enter_to_disable:  "Enter the code to disable 2FA:",
    btn_verify_enable:         "Verify & Enable",
    btn_confirm_disable:       "Confirm Disable",
    lbl_verifying:             "Verifying...",
    lbl_disabling:             "Disabling...",
    err_2fa_code_length:       "Please enter the 6-digit code.",

    // SuperAdmin My Settings — Change Email
    lbl_change_email:          "Change Email",
    lbl_new_email:             "New Email",
    lbl_confirm_with_password: "Confirm with Current Password",
    btn_update_email:          "Update Email",
    lbl_updating:              "Updating...",
    err_email_required:        "Please enter a new email address.",
    err_email_invalid:         "Please enter a valid email address.",
    err_email_same:            "New email is same as current.",
    err_password_required:     "Please enter your password.",
    err_wrong_password:        "Password is incorrect.",
    err_email_in_use:          "Email already in use.",
    err_reauth_required:       "Please log out and log back in first.",
    success_email_updated:     "Email updated successfully.",

    // Login — 2FA verification step
    lbl_2fa_verification:      "Two-Factor Verification",
    lbl_2fa_open_app:          "Open your authenticator app and enter the 6-digit code.",
    btn_verify:                "Verify",
    btn_back_to_login:         "Back to Login",
    err_2fa_invalid:           "Invalid or expired code. Try again.",

    // SuperAdmin My Settings — Active Sessions
    lbl_active_sessions:             "Active Sessions",
    lbl_no_sessions:                 "No active sessions found",
    lbl_current_session:             "Current",
    lbl_logged_in:                   "Logged in",
    lbl_last_active:                 "Last active",
    lbl_revoking:                    "Revoking...",
    btn_revoke:                      "Revoke",
    lbl_multiple_sessions_warning:   "Multiple active sessions detected. Revoke any sessions you do not recognize.",
    lbl_ip_address:                  "IP Address",
    lbl_connection_history:          "Connection History",
    lbl_from_date:                   "From",
    lbl_to_date:                     "To",
    btn_load_history:                "Load",
    lbl_select_dates:                "Select a date range and click Load.",
    lbl_no_history:                  "No sessions found for this period.",
    lbl_session_ended:               "Ended",
    lbl_session_revoked:             "Revoked",
    lbl_active:                      "Active",
    lbl_device:                      "Device",
    lbl_default_timezone:            "Default Timezone",
    lbl_default_timezone_desc:       "Used for your reports, platform health timestamps, and analytics date grouping.",
    btn_save_timezone:               "Save Timezone",
    success_saved:                   "Saved successfully.",
    lbl_never:                       "Never",
    lbl_platform_branding:           "Platform Branding",
    lbl_platform_name:               "Platform Name",
    lbl_platform_name_desc:          "Shown on login page, reports, and browser tab.",
    lbl_primary_color:               "Primary Color",
    lbl_primary_color_desc:          "Affects buttons, sidebar highlights, and active states.",
    lbl_platform_logo:               "Platform Logo",
    lbl_logo_desc:                   "PNG or JPG, max 2MB. Recommended: 200x200px",
    btn_upload_logo:                 "Upload Logo",
    btn_remove_logo:                 "Remove",
    btn_save_branding:               "Save Branding",
    lbl_preview_button:              "Preview Button",
    lbl_preview_badge:               "Preview Badge",
    success_branding_saved:          "Branding saved. Changes apply immediately.",
    err_logo_type:                   "Please select an image file.",
    err_logo_size:                   "Logo must be under 2MB.",

    btn_save:                        "Save",

    // ── Data & Maintenance ───────────────────────────────────────────────────
    lbl_data_maintenance:            "Data & Maintenance",
    lbl_auto_backup:                 "Auto Backup",
    lbl_enable_backup:               "Enable Automatic Backup",
    lbl_backup_desc:                 "Export Firestore data to Google Cloud Storage on schedule",
    lbl_backup_frequency:            "Backup Frequency",
    opt_daily:                       "Every Day",
    opt_weekly:                      "Every Week",
    opt_every_10:                    "Every 10 Days",
    opt_monthly:                     "Every Month",
    opt_custom_days:                 "Custom (every N days)",
    lbl_every_n_days:                "Every how many days?",
    lbl_backup_time:                 "Run backup at (hour)",
    lbl_retain_backups:              "Keep backups for (days)",
    opt_7_days:                      "7 days",
    opt_14_days:                     "14 days",
    opt_30_days:                     "30 days",
    opt_60_days:                     "60 days",
    opt_90_days:                     "90 days",
    opt_1_year:                      "1 year",
    lbl_recent_backups:              "Recent Backups",
    btn_backup_now:                  "Run Backup Now",
    lbl_backup_running:              "Running backup...",
    success_backup_started:          "Backup started. Check logs in a few minutes.",
    lbl_data_retention:              "Data Retention",
    lbl_data_retention_desc:         "Old GPS events are automatically deleted. Client data and sales are never deleted.",
    lbl_keep_events_for:             "Keep events and alerts for",
    opt_keep_forever:                "Keep forever (no deletion)",
    opt_3_months:                    "3 months",
    opt_6_months:                    "6 months",
    opt_12_months:                   "12 months (recommended)",
    opt_24_months:                   "24 months",
    opt_36_months:                   "36 months",
    lbl_retention_warning:           "Events older than the selected period will be permanently deleted on the 1st of each month.",
    lbl_api_rate_limit:              "API Rate Limit (requests per minute)",
    opt_per_minute:                  "requests / minute",
    opt_unlimited:                   "Unlimited",
    lbl_rate_limit_desc:             "Maximum API requests per minute. Excess requests return 429 error.",

    // ── Reports Page ─────────────────────────────────────────────────────────
    reports_title:                   "Reports",
    reports_subtitle:                "Generate and export reports for any time period",
    reports_step1:                   "Step 1 — Select Report Type",
    reports_step2:                   "Step 2 — Set Filters",
    reports_type_visits:             "Client Visits",
    reports_type_visits_desc:        "Clients visited, when, by whom",
    reports_type_zone_coverage:      "Zone Coverage",
    reports_type_zone_coverage_desc: "Visited vs unvisited clients per zone",
    reports_type_activity:           "Vendor Activity",
    reports_type_activity_desc:      "Online/offline times and hours",
    reports_type_alerts:             "Out-of-Zone History",
    reports_type_alerts_desc:        "Every alert: who, which zone, time",
    reports_type_unauth_zone:        "Unauthorized Zone",
    reports_type_unauth_zone_desc:   "Vendors who entered zones not assigned to them",
    reports_type_zone:               "Zone / Geofence",
    reports_type_zone_desc:          "Which vendors entered each zone",
    reports_type_daily:              "Daily Summary",
    reports_type_daily_desc:         "Full day: vendors, visits, alerts",
    reports_type_client_creation:    "Client Creation",
    reports_type_client_creation_desc:"Clients added by each operator",
    reports_type_custom:             "Custom Report",
    reports_type_custom_desc:        "Pick any combination of filters",
    reports_period_today:            "Today",
    reports_period_week:             "This Week",
    reports_period_month:            "This Month",
    reports_period_last_month:       "Last Month",
    reports_period_custom:           "Custom",
    reports_period_yesterday:        "Yesterday",
    reports_period_this_week:        "This Week",
    reports_period_this_month:       "This Month",
    reports_from_date:               "From Date",
    reports_from_time:               "From Time",
    reports_to_date:                 "To Date",
    reports_to_time:                 "To Time",
    reports_vendor_filter:           "Vendor",
    reports_all_vendors:             "All Vendors",
    reports_zone_filter:             "Zone / Section",
    reports_all_zones:               "All Zones",
    reports_search_vendors:          "Search vendors...",
    reports_search_zones:            "Search zones...",
    reports_no_vendors_found:        "No vendors found",
    reports_no_zones_found:          "No zones found",
    reports_event_types:             "Event Types to Include",
    reports_group_by:                "Group results by",
    reports_group_vendor:            "Vendor",
    reports_group_zone:              "Zone",
    reports_group_day:               "Day",
    reports_group_client:            "Client",
    reports_select_event_type:       "Select at least one event type.",
    reports_generating:              "Generating...",
    reports_generate:                "Generate Report",
    reports_report_label:            "Report",
    reports_zones_count:             "zone(s)",
    reports_events_count:            "event(s)",
    reports_vendors_count:           "vendor(s)",
    reports_export_excel:            "Excel",
    reports_export_csv:              "CSV",
    reports_export_pdf:              "PDF",
    reports_no_events:               "No events found",
    reports_no_events_sub:           "Try a different date range or filters",
    reports_no_clients_zone:         "No clients found in any zone",
    reports_no_clients_zone_sub:     "Add clients and assign them to zones first",
    reports_no_zone_visits:          "No zone visits found",
    reports_no_zone_visits_sub:      "Try a different date range or filters",
    reports_no_unauth:               "No unauthorized zone entries found",
    reports_no_unauth_sub:           "No vendors entered unassigned zones in this period",
    reports_anomaly_disabled:        "Out-of-zone alerts are currently disabled for this company. Enable anomaly detection in Company Settings to start recording zone violations.",
    reports_overall_coverage:        "Overall Coverage",
    reports_visited:                 "Visited",
    reports_not_visited:             "Not Visited",
    reports_none_visited:            "None visited",
    reports_all_visited:             "All visited!",
    reports_covered:                 "covered",
    reports_clients_count:           "clients",
    reports_col_vendor:              "Vendor",
    reports_col_total_visits:        "Total Visits",
    reports_col_unique_clients:      "Unique Clients",
    reports_col_last_visit:          "Last Visit",
    reports_col_check_ins:           "Check-ins",
    reports_col_clients_visited:     "Clients Visited",
    reports_col_type:                "Type",
    reports_col_client_zone:         "Client / Zone",
    reports_col_timestamp:           "Timestamp",
    reports_col_duration:            "Duration",
    reports_col_zone:                "Zone",
    reports_col_total_clients:       "Total Clients",
    reports_col_coverage:            "Coverage %",
    reports_speed_alerts:            "Speed Alerts",
    reports_zone_alerts:             "Zone Alerts",
    reports_long_stop_alerts:        "Long Stop Alerts",
    reports_check_ins:               "Check-ins",
    reports_op_step2:                "Step 2 — Set Filters",
    reports_op_from:                 "From",
    reports_op_to:                   "To",
    reports_op_operator:             "Operator",
    reports_op_search:               "Search operators...",
    reports_op_all_operators:        "All Operators",
    reports_op_loading:              "Loading operators...",
    reports_op_generate:             "Generate Report",
    reports_op_generating:           "Generating...",
    reports_op_report_title:         "Client Creation Report",
    reports_op_export:               "Export to Excel",
    reports_op_by_operator:          "By Operator",
    reports_op_no_operators:         "No operators found.",
    reports_op_today:                "Today",
    reports_op_this_week:            "This Week",
    reports_op_this_month:           "This Month",
    reports_op_in_period:            "In Period",
    reports_op_total_all_time:       "Total All Time",
    reports_op_all_clients:          "All Clients in Period",
    reports_op_search_clients:       "Search by name, phone, or operator...",
    reports_op_no_clients:           "No clients found for this period.",
    reports_op_col_name:             "Name",
    reports_op_col_phone:            "Phone",
    reports_op_col_created_by:       "Created By",
    reports_op_col_date_added:       "Date Added",
    reports_custom_checkins:         "Check-ins (GPS + Manual)",
    reports_custom_zone_alert:       "Zone Alerts",
    reports_custom_speed_alert:      "Speed Alerts",
    reports_custom_long_stop:        "Long Stop Alerts",
    reports_custom_outside_hours:    "Outside Hours Alerts",
    reports_custom_no_visits:        "No Visits Alerts",

    // ── Statistics Page ───────────────────────────────────────────────────────
    stats_title:                     "Statistics & Analytics",
    stats_subtitle:                  "Track visits, alerts, and vendor performance over time",

    // ── Company Settings ──────────────────────────────────────────────────────
    cs_title:                        "Company Settings",
    cs_subtitle:                     "Configure your company preferences",
    cs_saving:                       "Saving...",
    cs_uploading:                    "Uploading...",
    cs_save_changes:                 "Save Changes",
    cs_loading:                      "Loading settings...",
    cs_load_error:                   "Failed to load settings. Please refresh.",
    cs_tab_general:                  "General",
    cs_tab_tracking:                 "Tracking",
    cs_tab_hours:                    "Working Hours",
    cs_tab_alerts:                   "Alerts",
    cs_tab_appearance:               "Appearance",
    cs_tab_client_types:             "Client Types",
    cs_regional:                     "Regional Settings",
    cs_timezone:                     "Timezone",
    cs_language:                     "Language",
    cs_date_format:                  "Date Format",
    cs_behaviour:                    "Behaviour",
    cs_auto_checkin:                 "Auto Check-in",
    cs_auto_checkin_desc:            "Automatically record a visit when a vendor arrives at a client location",
    cs_manual_checkin:               "Allow Manual Check-in",
    cs_manual_checkin_desc:          "Vendors can manually mark a visit from the mobile app",
    cs_require_notes:                "Require Notes on Visit",
    cs_require_notes_desc:           "Vendors must add a note when recording a visit",
    cs_notif_sound:                  "Notification Sound",
    cs_notif_sound_desc:             "Play a sound when new alerts arrive",
    cs_gps_tracking:                 "GPS & Arrival Detection",
    cs_nearby_distance:              "Nearby Distance (meters)",
    cs_nearby_hint:                  "How close the vendor must be to register an arrival",
    cs_gps_interval:                 "GPS Update Interval (seconds)",
    cs_gps_interval_hint:            "How often the vendor app sends location updates",
    cs_min_arrival:                  "Min Arrival Distance (m)",
    cs_max_arrival:                  "Max Arrival Distance (m)",
    cs_visit_reset:                  "Visit Reset (days)",
    cs_visit_reset_hint:             "After how many days a visited client becomes unvisited again",
    cs_working_hours:                "Working Hours",
    cs_hours_start:                  "Work Start Time",
    cs_hours_end:                    "Work End Time",
    cs_track_outside:                "Track Outside Hours",
    cs_track_outside_desc:           "Record GPS events sent outside working hours",
    cs_alerts_section:               "Alerts & Notifications",
    cs_out_of_zone:                  "Out-of-Zone Alerts",
    cs_out_of_zone_desc:             "Alert when a vendor visits a client outside their assigned zone",
    cs_unauth_zone:                  "Unauthorized Zone Alerts",
    cs_unauth_zone_desc:             "Alert when a vendor enters a zone not assigned to them",
    cs_cooldown:                     "Alert Cooldown (minutes)",
    cs_cooldown_hint:                "Minimum time between two alerts for the same vendor",
    cs_max_speed:                    "Max Speed Alert (km/h)",
    cs_max_speed_hint:               "Alert when vendor exceeds this speed. 0 = disabled",
    cs_appearance:                   "Appearance",
    cs_company_name:                 "Company Name",
    cs_company_phone:                "Phone",
    cs_company_email:                "Email",
    cs_company_address:              "Address",
    cs_primary_color:                "Primary Color",
    cs_logo:                         "Company Logo",
    cs_logo_hint:                    "PNG or JPG, max 2MB",
    cs_choose_logo:                  "Choose Logo",
    cs_client_types:                 "Client Types",
    cs_client_types_hint:            "Define the types of clients for your company",
    cs_add_type:                     "Add Type",
    cs_new_type_ph:                  "New type name...",
    cs_no_types:                     "No client types defined yet",
    cs_success:                      "Settings saved successfully!",
    cs_logo_type_err:                "Please select an image file.",
    cs_logo_size_err:                "Logo must be under 2MB.",
    cs_notif_checkin:                "Show Check-in Notifications",
    cs_notif_checkin_desc:           "Display vendor check-ins (GPS and manual) in the Notifications page",
    cs_visit_alerts:                 "Visit Alerts",
    cs_missed_visit:                 "Alert on Missed Visit",
    cs_missed_visit_desc:            "Notify when a vendor has not made any visit within the reset period",
    cs_long_stop:                    "Alert on Long Stop",
    cs_long_stop_desc:               "Notify when a vendor stays at one location for too long",
    cs_long_stop_min:                "Long Stop Threshold (minutes)",
    cs_long_stop_hint:               "Alert if vendor stays at same location longer than this during working hours",

    // ── Stock Manager ─────────────────────────────────────────────────────────
    stock_title:                     "Stock Manager",
    stock_subtitle:                  "Manage product catalog, vendor stock, sales and movements",
    stock_tab_catalog:               "Products Catalog",
    stock_tab_vendor:                "Vendor Stock",
    stock_tab_sales:                 "Sales History",
    stock_tab_movements:             "Stock Movements",
    stock_tab_requests:              "Restock Requests",
    stock_search_products:           "Search products...",
    stock_all_categories:            "All Categories",
    stock_add_product:               "+ Add Product",
    stock_refresh:                   "Refresh",
    stock_export_excel:              "Excel",
    stock_no_products:               "No products found",
    stock_col_product:               "Product",
    stock_col_sku:                   "SKU",
    stock_col_category:              "Category",
    stock_col_unit:                  "Unit",
    stock_col_sell_price:            "Sell Price",
    stock_col_cost:                  "Cost",
    stock_col_total_stock:           "Total Stock",
    stock_col_status:                "Status",
    stock_col_actions:               "Actions",
    stock_low:                       "Low",
    stock_active:                    "Active",
    stock_inactive:                  "Inactive",
    stock_edit_product:              "Edit Product",
    stock_add_product_modal:         "Add Product",
    stock_product_name:              "Product Name",
    stock_sku_label:                 "SKU",
    stock_sku_hint:                  "(auto if empty)",
    stock_category:                  "Category",
    stock_unit:                      "Unit",
    stock_initial_qty:               "Initial Quantity",
    stock_low_threshold:             "Low Stock Threshold",
    stock_sell_price:                "Selling Price",
    stock_cost_price:                "Cost Price",
    stock_active_visible:            "Active (visible to vendors)",
    stock_save_changes:              "Save Changes",
    stock_create_product:            "Create Product",
    stock_saving:                    "Saving...",
    stock_cancel:                    "Cancel",
    stock_delete_product:            "Delete Product",
    stock_delete_confirm:            "This cannot be undone.",
    stock_deleting:                  "Deleting...",
    stock_name_required:             "Item name is required.",
    stock_product_updated:           "Product updated.",
    stock_product_created:           "Product created.",

    // ── Notes Inbox ───────────────────────────────────────────────────────────
    notes_title:                     "Notes Inbox",
    notes_subtitle:                  "Notes sent by field staff about clients",
    notes_refresh:                   "Refresh",
    notes_loading:                   "Loading notes...",
    notes_date_label:                "Date:",
    notes_all_time:                  "All Time",
    notes_today:                     "Today",
    notes_yesterday:                 "Yesterday",
    notes_this_week:                 "This Week",
    notes_this_month:                "This Month",
    notes_custom:                    "Custom",
    notes_from:                      "From:",
    notes_to:                        "To:",
    notes_priority_label:            "Priority:",
    notes_all_notes:                 "All Notes",
    notes_urgent:                    "Urgent",
    notes_normal:                    "Normal",
    notes_sender_label:              "Sender:",
    notes_all_senders:               "All Senders",
    notes_vendors:                   "Vendors",
    notes_operators:                 "Operators",
    notes_supervisors:               "Supervisors",
    notes_showing:                   "Showing",
    notes_of:                        "of",
    notes_loaded:                    "loaded notes",
    notes_empty:                     "No notes yet",
    notes_no_match:                  "No notes match the selected filters",
    notes_badge_urgent:              "Urgent",
    notes_badge_normal:              "Normal",
    notes_badge_unread:              "Unread",
    notes_badge_read:                "Read",
    notes_badge_replied:             "Replied",
    notes_show_map:                  "Show on Map",
    notes_admin_reply:               "Admin Reply",
    notes_reply_ph:                  "Write your reply...",
    notes_cancel_reply:              "Cancel",
    notes_send:                      "Send",
    notes_sending:                   "Sending...",
    notes_mark_read:                 "Mark as Read",
    notes_reply_btn:                 "Reply",
    notes_edit_reply:                "Edit Reply",
    notes_print_restock:             "Print Restock Form",
    notes_load_more:                 "Load More",
    notes_role_operator:             "Operator",
    notes_role_vendor:               "Vendor",
    notes_role_supervisor:           "Supervisor",
    notes_role_staff:                "Staff",
    notes_all_loaded:                "All notes loaded",
    notes_load_more_btn:             "Load More Notes",
    notes_loading_more:              "Loading...",

    // ── Coverage Map (CompetitorMap) ──────────────────────────────────────────
    cmap_title:                      "Coverage Map",
    cmap_heat_map:                   "Heat Map",
    cmap_client_pins:                "Client Pins",
    cmap_coverage:                   "Coverage",
    cmap_show_zones:                 "Show Zones",
    cmap_show_vendors:               "Show Vendors",
    cmap_clients_on_map:             "Clients on Map",
    cmap_with_zone:                  "With Zone",
    cmap_no_zone:                    "No Zone",
    cmap_visited:                    "Visited",
    cmap_coverage_pct:               "Coverage",
    cmap_clients_by_zone:            "Clients by Zone",
    cmap_no_zones_defined:           "No zones defined",
    cmap_vendors:                    "Vendors",
    cmap_search_vendor:              "Search vendor...",
    cmap_visit_coverage:             "Visit Coverage by Zone",
    cmap_loading_map:                "Loading map...",
    cmap_loading_data:               "Loading map data...",
    cmap_retry:                      "Retry",
    cmap_total:                      "Total",
    cmap_remaining:                  "Remaining",
    cmap_progress:                   "Progress",
    cmap_close:                      "Close",
    cmap_last_visit:                 "Last visit:",
    cmap_never_visited:              "Never visited",
    cmap_no_data:                    "No data",
    cmap_live:                       "Live",
    cmap_online:                     "Online",
    cmap_idle:                       "Idle",
    cmap_offline:                    "Offline",

    // ── Supervisor Dashboard ──────────────────────────────────────────────────
    sup_dash_my_vendors:             "My Vendors",
    sup_dash_my_clients:             "My Clients",
    sup_dash_clients_today:          "Clients Visited Today",
    sup_dash_zone_alerts:            "Zone Alerts",
    sup_dash_assigned_zones:         "My Assigned Zones",
    sup_dash_recent_activity:        "Recent Activity",
    sup_dash_no_events:              "No events yet in your zones.",
    sup_dash_live_map:               "Live Map",
    sup_dash_online:                 "online",
    sup_dash_show_clients:           "Show Clients",
    sup_dash_satellite:              "Satellite",
    sup_dash_map:                    "Map",
    sup_dash_send_note:              "Send Note",
    sup_dash_vendor_page:            "Vendors",
    sup_dash_client_page:            "Clients",
    sup_dash_search_clients:         "Search clients...",
    sup_dash_no_clients:             "No clients in your zones.",
    sup_dash_section:                "Section",
    sup_dash_last_visit:             "Last Visit",
    sup_dash_never:                  "Never",
    sup_dash_status:                 "Status",
    sup_dash_search_vendors:         "Search vendors...",
    sup_dash_no_vendors:             "No vendors in your zones.",
    sup_dash_last_seen:              "Last seen",
    sup_dash_events:                 "Events",
    sup_dash_search_events:          "Search events...",
    sup_dash_no_events_found:        "No events found.",
    sup_dash_event_vendor:           "Vendor",
    sup_dash_event_client:           "Client",
    sup_dash_event_type:             "Type",
    sup_dash_event_time:             "Time",
    sup_dash_profile:                "My Profile",
    sup_dash_dark_mode:              "Dark Mode",
    sup_dash_change_pw:              "Change Password",
    sup_dash_current_pw:             "Current Password",
    sup_dash_new_pw:                 "New Password",
    sup_dash_confirm_pw:             "Confirm New Password",
    sup_dash_pw_saved:               "Password changed successfully.",
    sup_dash_pw_mismatch:            "Passwords do not match.",
    sup_dash_pw_short:               "Password must be at least 6 characters.",
    sup_dash_pw_wrong:               "Current password is incorrect.",
    sup_dash_saving_pw:              "Saving...",
    sup_dash_save_pw:                "Save Password",
    sup_dash_note_message:           "Message",
    sup_dash_note_priority:          "Priority",
    sup_dash_note_normal:            "Normal",
    sup_dash_note_urgent:            "Urgent",
    sup_dash_note_send:              "Send Note",
    sup_dash_note_sending:           "Sending...",
    sup_dash_note_sent:              "Note sent to admin.",
    sup_dash_note_error:             "Please enter a message.",
    sup_dash_plate:                  "Plate:",
    sup_dash_speed:                  "km/h",
    sup_dash_loading_too_long:       "Loading took too long. Please refresh the page.",

    // ── Operator Dashboard ────────────────────────────────────────────────────
    op_dash_my_clients:              "My Clients",
    op_dash_statistics:              "Statistics",
    op_dash_profile:                 "Profile",
    op_dash_map:                     "Map",
    op_dash_add_client:              "Add Client",
    op_dash_edit_client:             "Edit Client",
    op_dash_first_name:              "First Name",
    op_dash_last_name:               "Last Name",
    op_dash_phone:                   "Phone",
    op_dash_address:                 "Address",
    op_dash_client_type:             "Client Type",
    op_dash_notes_label:             "Notes",
    op_dash_save:                    "Save",
    op_dash_saving:                  "Saving...",
    op_dash_cancel:                  "Cancel",
    op_dash_use_my_location:         "Use My Location",
    op_dash_locating:                "Locating...",
    op_dash_pin_map:                 "Tap map to place pin",
    op_dash_search_clients:          "Search clients...",
    op_dash_no_clients:              "No clients yet. Add your first client!",
    op_dash_total_clients:           "Total Clients",
    op_dash_visited_today:           "Visited Today",
    op_dash_pending:                 "Pending",
    op_dash_dark_mode:               "Dark Mode",
    op_dash_change_pw:               "Change Password",
    op_dash_current_pw:              "Current Password",
    op_dash_new_pw:                  "New Password",
    op_dash_confirm_pw:              "Confirm Password",
    op_dash_pw_saved:                "Password changed successfully.",
    op_dash_pw_mismatch:             "Passwords do not match.",
    op_dash_pw_short:                "Password must be at least 6 characters.",
    op_dash_pw_wrong:                "Current password is incorrect.",
    op_dash_saving_pw:               "Saving...",
    op_dash_save_pw:                 "Save Password",
    op_dash_send_note:               "Send Note",
    op_dash_note_message:            "Message",
    op_dash_note_priority:           "Priority",
    op_dash_note_normal:             "Normal",
    op_dash_note_urgent:             "Urgent",
    op_dash_note_send:               "Send Note",
    op_dash_note_sending:            "Sending...",
    op_dash_note_sent:               "Note sent to admin.",
    op_dash_note_error:              "Please enter a message.",
    op_dash_navigate:                "Navigate",
    op_dash_edit:                    "Edit",
    op_dash_delete:                  "Delete",
    op_dash_delete_confirm:          "Are you sure you want to delete this client?",
    op_dash_deleting:                "Deleting...",
    op_dash_gps_error:               "Could not get your location.",
    op_dash_stats_title:             "Statistics",
    op_dash_stats_subtitle:          "Your performance overview",
    op_dash_today:                   "Today",
    op_dash_this_week:               "This Week",
    op_dash_this_month:              "This Month",

    // ── Vendor Dashboard ──────────────────────────────────────────────────────
    vendor_badge:                    "Vendor",
    vendor_offline_banner:           "You are offline — check-ins and notes will sync when you reconnect.",
    vendor_pending_sync:             "waiting to sync.",
    vendor_sync_now:                 "Sync Now",
    vendor_syncing:                  "Syncing...",
    vendor_route:                    "Route",
    vendor_map:                      "Map",
    vendor_stats:                    "Stats",
    vendor_stock:                    "Stock",
    vendor_profile:                  "Profile",
    vendor_note_enter_msg:           "Please enter a message.",
    vendor_note_saved_offline:       "Note saved offline — will sync when connected.",
    vendor_note_sent:                "Note sent.",
    vendor_send_note_title:          "Send Note to Admin",
    vendor_general_note:             "General Note",
    vendor_note_message:             "Message",
    vendor_note_priority:            "Priority",
    vendor_note_normal:              "Normal",
    vendor_note_urgent:              "Urgent",
    vendor_note_cancel:              "Cancel",
    vendor_note_sending:             "Sending...",
    vendor_note_send:                "Send",
    vendor_route_total:              "Total",
    vendor_route_visited:            "Visited",
    vendor_route_remaining:          "Remaining",
    vendor_route_getting_location:   "Getting your location...",
    vendor_route_showing_clients:    "Showing clients",
    vendor_route_away:               "away",
    vendor_route_found:              "found",
    vendor_route_refresh:            "Refresh",
    vendor_route_locating:           "Locating...",
    vendor_route_no_zone:            "No zone assigned. Contact your administrator to get a zone assigned to your account.",
    vendor_route_no_nearby:          "No clients nearby — move closer to your route",
    vendor_route_no_clients:         "No clients to show",
    vendor_route_navigate:           "Navigate",
    vendor_route_check_in:           "Check In",
    vendor_route_auto_only:          "Auto check-in only",
    vendor_route_note:               "Note",
    vendor_route_sell:               "Sell Item",
    vendor_route_receipt:            "View Receipt",
    vendor_route_loading_receipt:    "Loading...",
    vendor_route_no_receipt:         "No receipt found for this client.",
    vendor_route_pending:            "Pending",
    vendor_route_visited_label:      "Visited",
    vendor_route_from_prev:          "from previous stop",
    vendor_route_no_zone_label:      "No Zone",
    vendor_route_all:                "All",
    vendor_route_search_ph:          "Search clients...",
    vendor_route_optimized:          "Route Optimized",
    vendor_route_optimization:       "Route Optimization",
    vendor_route_optimizing:         "Optimizing...",
    vendor_route_reset_order:        "Reset Order",
    vendor_route_optimize:           "Optimize Route",
    vendor_route_saves:              "saves",
    vendor_route_km:                 "km",
    vendor_route_min:                "min",
    vendor_route_checkin_note_title: "Note Required",
    vendor_route_checkin_note_hint:  "Add a visit note before checking in at",
    vendor_route_checkin_note_ph:    "What happened at this visit?",
    vendor_route_checkin_note_error: "Please add a note before checking in.",
    vendor_route_confirm_checkin:    "Confirm Check-in",
    vendor_map_view:                 "Map view",
    vendor_map_satellite:            "Satellite",
    vendor_stats_title:              "My Statistics",
    vendor_stats_today:              "Today",
    vendor_stats_week:               "This Week",
    vendor_stats_total:              "Total Visits",
    vendor_stats_avg:                "Avg / Day",
    vendor_stats_breakdown:          "Visit Breakdown",
    vendor_stats_manual:             "Manual:",
    vendor_stats_auto:               "Auto GPS:",
    vendor_stats_last7:              "Last 7 Days",
    vendor_stats_last4w:             "Last 4 Weeks",
    vendor_stats_recent:             "Recent Check-ins",
    vendor_stats_no_checkins:        "No check-ins yet",
    vendor_stats_away:               "away",
    vendor_stock_products:           "Products",
    vendor_stock_units:              "total units",
    vendor_stock_sales_today:        "Sales Today",
    vendor_stock_this_week:          "this week",
    vendor_stock_current:            "Current Stock",
    vendor_stock_request_restock:    "Request Restock",
    vendor_stock_no_items:           "No stock items assigned yet",
    vendor_stock_low:                "Low",
    vendor_stock_recent_sales:       "Recent Sales",
    vendor_stock_today_revenue:      "Today:",
    vendor_stock_no_sales:           "No sales yet",
    vendor_stock_pending_sync:       "Pending sync",
    vendor_stock_print:              "Print",
    vendor_profile_appearance:       "Appearance",
    vendor_profile_dark_mode:        "Dark Mode",
    vendor_profile_dark_hint:        "Switch to dark theme",
    vendor_profile_send_note:        "Send General Note",
    vendor_profile_sync_status:      "Sync Status",
    vendor_profile_online:           "Online",
    vendor_profile_offline_msg:      "Offline — data cached locally",
    vendor_profile_last_sync:        "Last sync:",
    vendor_profile_never:            "Never",
    vendor_profile_pending:          "pending",
    vendor_profile_change_pw:        "Change Password",
    vendor_profile_current_pw:       "Current Password",
    vendor_profile_new_pw:           "New Password",
    vendor_profile_confirm_pw:       "Confirm New Password",
    vendor_profile_pw_mismatch:      "New passwords do not match.",
    vendor_profile_pw_short:         "Password must be at least 6 characters.",
    vendor_profile_pw_wrong:         "Current password is incorrect.",
    vendor_profile_pw_saved:         "Password updated successfully.",
    vendor_profile_updating:         "Updating...",
    vendor_profile_update_pw:        "Update Password",
    vendor_note_describe_ph:         "Describe the issue or observation...",
    // Supervisor dashboard sub-components
    sup_dash_appearance:             "Appearance",
    sup_dash_dark_mode:              "Dark Mode",
    sup_dash_dark_hint:              "Switch to dark theme",
    sup_dash_send_note_title:        "Send Note to Admin",
    sup_dash_note_describe_ph:       "Describe the issue or observation...",
    sup_dash_cancel:                 "Cancel",
    sup_dash_online_vendor:          "Online vendor",
    sup_dash_offline_vendor:         "Offline vendor",
    sup_dash_client_label:           "Client",
    sup_dash_zones_legend:           "Shaded areas = your zones",
    sup_dash_total_clients:          "Total Clients",
    sup_dash_read_only:              "Read-only",
    sup_dash_all_zones:              "All Zones",
    sup_dash_no_clients_found:       "No clients found.",
    sup_dash_no_vendors_yet:         "No vendors assigned yet.",
    sup_dash_events_history:         "Events & History",
    sup_dash_events_zones:           "total events in your zones",
    sup_dash_all:                    "All",
    sup_dash_visits:                 "Visits",
    sup_dash_zone_enter:             "Zone Enter",
    sup_dash_zone_exit:              "Zone Exit",
    sup_dash_session_start:          "Session Start",
    sup_dash_session_end:            "Session End",
    sup_dash_all_vendors:            "All Vendors",
    sup_dash_no_events_filter:       "No events match your filters.",
    sup_dash_clients_in_zones:       "clients in your zones",
    sup_dash_vendors_assigned:       "vendor(s) assigned to you",

    // ── SuperAdmin Dashboard ──────────────────────────────────────────────────
    sa_super_admin_badge:            "SUPER ADMIN",
    nav_all_companies:               "All Companies",
    nav_create_company:              "Create Company",
    nav_global_settings:             "Global Settings",
    nav_health:                      "Platform Health",
    nav_sa_settings:                 "My Settings",
    sa_viewing:                      "Viewing:",
    sa_back_all:                     "← Back to all",
    sa_companies_count:              "companies",
    sa_active_companies:             "Active",
    sa_total_vendors:                "Total Vendors",
    sa_total_clients:                "Total Clients",
    sa_expired_subs:                 "Expired Subscriptions",
    sa_search_companies:             "Search companies...",
    sa_no_companies:                 "No companies found.",
    sa_last_activity:                "Last activity",
    sa_vendors:                      "vendors",
    sa_clients:                      "clients",
    sa_zones:                        "zones",
    sa_events:                       "events",
    sa_status_paid:                  "paid",
    sa_status_trial:                 "trial",
    sa_status_unpaid:                "unpaid",
    sa_status_expired:               "expired",
    sa_view_details:                 "View Details",
    sa_disable:                      "Disable",
    sa_enable:                       "Enable",
    sa_delete:                       "Delete",
    sa_confirm_disable:              "Disable Company",
    sa_confirm_enable:               "Enable Company",
    sa_confirm_delete:               "Delete Company",
    sa_disable_msg:                  "This will prevent all users of this company from logging in.",
    sa_enable_msg:                   "This will restore access for all users of this company.",
    sa_delete_msg:                   "All users, clients, vendors, zones, and events will be permanently deleted. This cannot be undone.",
    sa_deleting:                     "Deleting...",
  },

  // ══════════════════════════════════════════════════════════════════════════
  // FRENCH
  // ══════════════════════════════════════════════════════════════════════════
  fr: {
    app_name:        "Pinpoint",
    logout:          "Déconnexion",
    save_changes:    "Enregistrer",
    saving:          "Enregistrement...",
    cancel:          "Annuler",
    close:           "Fermer",
    edit:            "Modifier",
    delete:          "Supprimer",
    create:          "Créer",
    search:          "Rechercher",
    loading:         "Chargement...",
    yes_delete:      "Oui, Supprimer",
    deleting:        "Suppression...",
    uploading:       "Téléchargement...",
    add:             "Ajouter",
    select:          "Sélectionner",
    select_all:      "Tout sélectionner",
    confirm:         "Confirmer",
    back:            "Retour",
    actions:         "Actions",
    no_data:         "Aucune donnée",
    read_only:       "Lecture seule",
    coming_soon:     "Bientôt disponible",

    role_admin:      "Admin",
    role_supervisor: "Superviseur",
    role_operator:   "Opérateur",
    role_vendor:     "Livreur",

    active:          "Actif",
    inactive:        "Inactif",
    disabled:        "Désactivé",
    online:          "En ligne",
    offline:         "Hors ligne",
    enabled:         "Activé",

    nav_overview:       "Vue d'ensemble",
    nav_live_map:       "Carte en direct",
    nav_users:          "Utilisateurs",
    nav_supervisors:    "Superviseurs",
    nav_operators:      "Opérateurs",
    nav_vendors:        "Livreurs",
    nav_sections:       "Sections",
    nav_clients:        "Clients",
    nav_reports:        "Rapports",
    nav_statistics:     "Statistiques",
    nav_notifications:  "Notifications",
    nav_notes:          "Boîte de notes",
    nav_stock:          "Gestion du stock",
    nav_competitor_map: "Carte de Couverture",
    nav_api_access:     "Accès API",
    nav_settings:       "Paramètres",
    nav_events:         "Événements",
    nav_profile:        "Profil",
    nav_companies:      "Entreprises",

    overview_title:         "Vue d'ensemble",
    overview_active_vendors:"Livreurs actifs",
    overview_total_clients: "Total clients",
    overview_events_today:  "Événements aujourd'hui",
    overview_alerts_today:  "Alertes aujourd'hui",
    overview_recent_activity:"Activité récente",
    overview_no_events:     "Aucun événement dans vos zones.",
    overview_my_zones:      "Mes zones assignées",
    overview_my_vendors:    "Mes livreurs",
    overview_my_clients:    "Mes clients",
    overview_total_visits:  "Total visites",
    overview_zone_alerts:   "Alertes de zone",
    overview_loading:        "Chargement de la vue d'ensemble...",
    overview_total_users:    "Utilisateurs totaux",
    overview_zones:          "Zones",
    overview_active_today:   "Actifs aujourd'hui",
    overview_registered_vendors: "livreurs enregistrés",
    overview_in_database:    "dans la base de données",
    overview_geofences:      "géofences définis",
    overview_vendors_on_field:"livreurs sur le terrain",
    overview_clients_visited_today: "Clients visités aujourd'hui",
    overview_visits_this_week: "Visites cette semaine",
    overview_last_10_events: "10 derniers événements",
    overview_no_activity:    "Aucune activité",
    overview_unknown_vendor: "Livreur inconnu",
    overview_visited:        "a visité",
    overview_checked_in_at:  "a pointé à",
    overview_triggered_alert:"a déclenché une alerte dans",
    overview_started_session:"a démarré sa session",
    overview_ended_session:  "a terminé sa session",
    overview_entered_zone:   "est entré dans",
    overview_exited_zone:    "a quitté",
    overview_unauth_zone:    "est entré dans une zone non autorisée",

    map_title:          "Carte en direct",
    map_show_clients:   "Afficher les clients",
    map_satellite:      "Satellite",
    map_roadmap:        "Carte",
    map_legend_online:  "Livreur en ligne",
    map_legend_offline: "Livreur hors ligne",
    map_legend_client:  "Client",
    map_legend_zones:   "Zones ombrées = vos zones",
    map_vendor_status:  "Statut des livreurs",
    map_loading:        "Chargement de la carte...",
    map_last_seen:      "Dernière vue",
    map_speed:          "Vitesse",
    map_plate:          "Plaque",

    users_title:        "Utilisateurs",
    users_total:        "utilisateur(s) au total",
    users_add:          "+ Ajouter",
    users_new:          "Nouvel utilisateur",
    users_create:       "Créer l'utilisateur",
    users_creating:     "Création...",
    users_no_users:     "Aucun utilisateur",
    users_no_users_sub: "Créez votre premier utilisateur pour commencer",
    users_firebase_hint:"Un compte de connexion Firebase sera automatiquement créé.",
    users_delete_title: "Supprimer l'utilisateur",
    users_delete_msg:   "Leur compte de connexion sera également supprimé. Cette action est irréversible.",
    users_bulk_delete:  "Supprimer plusieurs utilisateurs",
    users_bulk_msg:     "Leurs comptes seront supprimés. Cette action est irréversible.",
    users_admins_hint:  "(les admins ne peuvent pas être sélectionnés)",

    sup_title:          "Superviseurs",
    sup_add:            "+ Ajouter un superviseur",
    sup_new:            "Nouveau superviseur",
    sup_create:         "Créer le superviseur",
    sup_access_hint:    "Les superviseurs ont un tableau de bord en lecture seule limité à leurs zones assignées.",
    sup_no_zones:       "Aucune zone assignée",
    sup_no_vendors:     "Aucun livreur assigné",
    sup_assigned_zones: "Zones assignées",
    sup_zones_hint:     "Le superviseur voit uniquement les clients et événements de ces zones",
    sup_assigned_vendors:"Livreurs assignés",
    sup_vendors_hint:   "Le superviseur surveille ces livreurs sur la carte",
    sup_search_vendors: "Rechercher par nom, plaque ou email...",
    sup_no_zones_defined:"Aucune zone définie. Créez des zones dans Sections d'abord.",
    sup_no_vendors_exist:"Aucun livreur. Créez des livreurs d'abord.",
    sup_delete_title:   "Supprimer le superviseur",
    sup_delete_msg:     "Leur compte sera supprimé. Cette action est irréversible.",
    sup_bulk_delete:    "Supprimer plusieurs superviseurs",
    sup_notes:          "Notes",
    sup_notes_ph:       "Notes optionnelles sur ce superviseur...",
    sup_my_zones:       "Mes zones",

    vendors_title:      "Livreurs",
    vendors_add:        "+ Ajouter un livreur",
    vendors_new:        "Nouveau livreur",
    vendors_no_vendors: "Aucun livreur",
    vendors_delete_title:"Supprimer le livreur",
    vendors_delete_msg: "Ce livreur sera définitivement supprimé.",
    vendors_bulk_delete:"Supprimer plusieurs livreurs",
    vendors_plate:      "Plaque d'immatriculation",
    vendors_vehicle:    "Type de véhicule",

    clients_title:      "Clients",
    clients_add:        "+ Ajouter un client",
    clients_new:        "Nouveau client",
    clients_no_clients: "Aucun client",
    clients_delete_title:"Supprimer le client",
    clients_delete_msg: "Ce client sera définitivement supprimé.",
    clients_bulk_delete:"Supprimer plusieurs clients",
    clients_zone:       "Zone",
    clients_all_zones:  "Toutes les zones",
    clients_in_zones:   "clients dans vos zones",
    clients_import:     "Importer",
    clients_export:     "Exporter",

    sections_title:     "Sections / Zones",
    sections_add:       "+ Ajouter une section",
    sections_new:       "Nouvelle section",
    sections_no_sections:"Aucune section",
    sections_delete_msg:"Cette section sera définitivement supprimée.",
    sections_draw_hint: "Dessinez un polygone sur la carte pour définir cette zone",
    sections_zone_name: "Nom de la zone",
    sections_zone_color:"Couleur de la zone",

    events_title:       "Événements & Historique",
    events_total:       "événements au total dans vos zones",
    events_all:         "Tous",
    events_visits:      "Visites",
    events_zone_enter:  "Entrée de zone",
    events_zone_exit:   "Sortie de zone",
    events_session_start:"Début de session",
    events_session_end: "Fin de session",
    events_no_events:   "Aucun événement ne correspond à vos filtres.",
    events_all_vendors: "Tous les livreurs",
    events_search_ph:   "Rechercher par livreur ou client...",

    // ── Clients Manager extra keys (FR) ───────────────────────────────────────
    clients_loading:         "Chargement des clients...",
    clients_select:          "Sélectionner",
    clients_cancel:          "✕ Annuler",
    clients_select_for_bulk: "Sélectionner des clients pour les actions groupées",
    clients_selected_count:  "client(s) sélectionné(s)",
    clients_delete_selected: "Supprimer la sélection",
    clients_search_ph:       "Rechercher par nom, téléphone ou adresse...",
    clients_no_results:      "Aucun résultat",
    clients_try_search:      "Essayez un autre terme de recherche",
    clients_add_manually:    "Ajouter un client manuellement",
    clients_showing:         "Affichage",
    clients_of:              "sur",
    clients_previous:        "Précédent",
    clients_next:            "Suivant",
    clients_page:            "Page",
    clients_zone_auto:       "Zone",
    clients_auto_from_gps:   "(auto depuis GPS)",
    clients_auto_detect:     "Détection automatique depuis GPS",
    clients_type_category:   "Type / Catégorie",
    clients_latitude:        "Latitude",
    clients_longitude:       "Longitude",
    clients_notes_ph:        "Notes pour les livreurs...",
    clients_status:          "Statut :",
    clients_zone_hint:       "🎯 Zone détectée automatiquement depuis GPS si dans une zone définie.",
    clients_created_by:      "Créé par",
    clients_cannot_undo_full: "Cette action est irréversible. Le client sera définitivement supprimé.",

    // ── Vendors Manager extra keys (FR) ───────────────────────────────────────
    vendors_loading:         "Chargement des livreurs...",
    vendors_total:           "total",
    vendors_active:          "actif",
    vendors_online:          "en ligne",
    vendors_select:          "Sélectionner",
    vendors_cancel:          "✕ Annuler",
    vendors_live_map:        "Carte en direct",
    vendors_select_for_bulk: "Sélectionner des livreurs pour les actions groupées",
    vendors_selected_count:  "livreur(s) sélectionné(s)",
    vendors_auto_account:    "Configuration automatique du compte",
    vendors_auto_account_msg:"Quand vous créez un livreur, un compte de connexion est automatiquement créé.",
    vendors_locations:       "Positions des livreurs",
    vendors_with_location:   "livreur(s) avec position connue",
    vendors_online_10min:    "En ligne (10 dernières min)",
    vendors_search_ph:       "Rechercher par nom, téléphone, IMEI ou plaque...",
    vendors_imei:            "IMEI",
    vendors_imei_hint:       "ID du traceur GPS",
    vendors_assigned_zones:  "Zones assignées",
    vendors_no_zones:        "Aucune zone définie.",
    vendors_days_off:        "Jours de repos",
    vendors_days_off_hint:   "Les jours sélectionnés seront exclus des alertes de non-visite",
    vendors_status:          "Statut :",
    vendors_cannot_undo_full:"Leurs comptes seront supprimés. Cette action est irréversible.",
    vendors_create_vendor:   "Créer le livreur",
    vendors_save_changes:    "Enregistrer",

    // ── Users Manager extra keys (FR) ─────────────────────────────────────────
    users_loading:           "Chargement des utilisateurs...",
    users_select:            "Sélectionner",
    users_cancel:            "✕ Annuler",
    users_select_for_bulk:   "Sélectionner des utilisateurs pour les actions groupées",
    users_selected_count:    "utilisateur(s) sélectionné(s)",
    users_filter_all:        "Tous",
    users_filter_admins:     "Admins",
    users_filter_supervisors:"Superviseurs",
    users_filter_operators:  "Opérateurs",
    users_filter_vendors:    "Livreurs",
    users_active:            "Actif",
    users_disabled:          "Désactivé",
    users_admin_badge:       "👑 Admin",
    users_role_supervisor_desc: "Superviseur — peut voir tous les livreurs et clients dans les zones assignées",
    users_role_operator_desc:   "Opérateur — peut gérer les clients et voir le statut de livraison",
    users_role_vendor_desc:     "Livreur — utilisateur de l'application mobile qui effectue les livraisons",
    users_delete_selected:   "Supprimer la sélection",

    // ── Sections Manager extra keys (FR) ──────────────────────────────────────
    sections_loading:        "Chargement...",
    sections_map_loading:    "Chargement de la carte...",
    sections_geofences:      "Sections et Géofences",
    sections_satellite:      "Satellite",
    sections_map:            "Carte",
    sections_importing:      "Importation...",
    sections_import:         "Importer",
    sections_export:         "Exporter",
    sections_draw_new_zone:  "+ Dessiner une nouvelle zone",
    sections_cancel_drawing: "Annuler le dessin",
    sections_draw_hint_msg:  "Cliquez pour ajouter des points · Double-cliquez pour terminer la zone",
    sections_edit_zone:      "Modifier la zone",
    sections_new_zone:       "Nouvelle zone",
    sections_zone_name_label:"Nom de la zone *",
    sections_color_label:    "Couleur",
    sections_custom_color:   "personnalisé",
    sections_description:    "Description",
    sections_optional:       "Optionnel",
    sections_save_changes:   "Enregistrer",
    sections_create_zone:    "Créer la zone",
    sections_zones_label:    "Zones",
    sections_search_zones:   "Rechercher des zones...",
    sections_no_zones:       "Aucune zone",
    sections_draw_first:     "Dessinez votre première zone sur la carte",
    sections_draw_first_btn: "Dessiner la première zone",
    sections_pts:            "pts",
    sections_zones_total:    "zones au total",
    sections_delete_zone:    "Supprimer la zone",
    sections_delete_confirm: "Êtes-vous sûr de vouloir supprimer cette zone ? Cette action est irréversible.",

    // ── Supervisors Manager extra keys (FR) ───────────────────────────────────
    sup_loading:             "Chargement des superviseurs...",
    sup_select:              "Sélectionner",
    sup_cancel:              "✕ Annuler",
    sup_supervisor_access:   "Accès superviseur",
    sup_select_for_bulk:     "Sélectionner des superviseurs pour les actions groupées",
    sup_selected_count:      "superviseur(s) sélectionné(s)",
    sup_active:              "actif",
    sup_no_supervisors:      "Aucun superviseur",
    sup_create_assign_hint:  "Créez un superviseur et assignez-lui des zones et des livreurs à surveiller",
    sup_zones_label:         "Zones :",
    sup_vendors_label:       "Livreurs :",
    sup_supervisor_badge:    "🔭 superviseur",
    sup_basic_info:          "Informations de base",
    sup_login_auto:          "Un compte de connexion sera automatiquement créé pour ce superviseur.",
    sup_new_supervisor:      "Nouveau superviseur",
    sup_assigned_zones_label:"Zones assignées",
    sup_assigned_vendors_label:"Livreurs assignés",
    sup_status_label:        "Statut :",

    // ── Operators Manager extra keys (FR) ─────────────────────────────────────
    op_select_for_bulk:      "Sélectionner des opérateurs pour les actions groupées",
    op_selected_count:       "opérateur(s) sélectionné(s)",
    op_no_match:             "Aucun opérateur ne correspond à votre recherche.",
    op_active:               "actif",

    // ── Notifications Page (FR) ───────────────────────────────────────────────
    notif_loading:           "Chargement des notifications...",
    notif_filter_all:        "Tout",
    notif_filter_alerts:     "Alertes",
    notif_filter_visits:     "Visites",
    notif_filter_sessions:   "Sessions",
    notif_clear_all:         "Tout effacer",
    notif_confirm_clear:     "Effacer toutes les notifications",
    notif_confirm_clear_msg: "Cela supprimera définitivement toutes les notifications. Cette action est irréversible.",
    notif_clearing:          "Suppression...",
    notif_cleared:           "✅ Toutes les notifications effacées.",
    notif_empty:             "Aucune notification",
    notif_speed:             "Excès de vitesse",
    notif_long_stop:         "Arrêt prolongé",
    notif_no_visits:         "Pas de visites",
    notif_outside_hours:     "Hors horaires",
    notif_wrong_zone:        "Mauvaise zone",
    notif_checkin:           "Pointage",
    notif_visit:             "Visite",

    // ── Reports Page (FR) ────────────────────────────────────────────────────
    reports_loading:         "Génération du rapport...",
    reports_select_type:     "Sélectionner un type de rapport",
    reports_select_hint:     "Choisissez un type de rapport à gauche pour commencer",
    reports_date_from:       "Date de début",
    reports_date_to:         "Date de fin",
    reports_time_from:       "Heure de début",
    reports_time_to:         "Heure de fin",
    reports_all_vendors:     "Tous les livreurs",
    reports_all_zones:       "Toutes les zones",
    reports_generate_btn:    "Générer le rapport",
    reports_download_pdf:    "Télécharger PDF",
    reports_no_data:         "Aucune donnée pour cette période",
    reports_client_visits:   "Visites clients",
    reports_zone_coverage:   "Couverture de zone",
    reports_vendor_activity: "Activité des livreurs",
    reports_out_of_zone:     "Historique hors zone",
    reports_unauth_zone:     "Zone non autorisée",
    reports_zone_geofence:   "Zone / Géofence",
    reports_daily_summary:   "Résumé quotidien",
    reports_client_creation: "Création de clients",
    reports_custom:          "Rapport personnalisé",

    // ── Statistics Page (FR) ─────────────────────────────────────────────────
    stats_analytics:         "Statistiques et Analytiques",
    stats_track_hint:        "Suivez les visites, les alertes et les performances des livreurs",

    // ── Stock Manager (FR) ───────────────────────────────────────────────────
    stock_title:             "Gestion du stock",
    stock_desc:              "Gérez le catalogue de produits, le stock des livreurs, les ventes et les mouvements",
    stock_tab_catalog:       "Catalogue de produits",
    stock_tab_vendor:        "Stock livreur",
    stock_tab_sales:         "Historique des ventes",
    stock_tab_movements:     "Mouvements de stock",
    stock_tab_requests:      "Demandes de réapprovisionnement",

    reports_title:      "Rapports",
    reports_generate:   "Générer un rapport",
    reports_download:   "Télécharger",

    stats_title:        "Statistiques",

    notif_title:        "Notifications",
    notif_no_notif:     "Aucune notification",
    notif_mark_read:    "Tout marquer comme lu",

    settings_title:     "Paramètres de l'entreprise",
    settings_subtitle:  "Configurez les préférences de votre entreprise",
    settings_general:   "Général",
    settings_tracking:  "Suivi",
    settings_hours:     "Heures de travail",
    settings_alerts:    "Alertes",
    settings_appearance:"Apparence",
    settings_saved:     "✅ Paramètres enregistrés !",
    settings_timezone:  "Fuseau horaire",
    settings_language:  "Langue",
    settings_date_format:"Format de date",
    settings_nearby_dist:"Distance de proximité (mètres)",
    settings_nearby_hint:"Distance pour détecter l'arrivée du livreur chez le client",
    settings_gps_interval:"Intervalle GPS (secondes)",
    settings_gps_hint:  "Fréquence d'envoi des mises à jour de position",
    settings_max_speed: "Alerte vitesse max (km/h)",
    settings_max_speed_hint:"Mettre à 0 pour désactiver les alertes de vitesse",
    settings_auto_checkin:"Enregistrement automatique",
    settings_auto_checkin_desc:"Enregistrer automatiquement une visite à l'arrivée du livreur",
    settings_manual_checkin:"Autoriser l'enregistrement manuel",
    settings_manual_checkin_desc:"Les livreurs peuvent marquer une visite manuellement",
    settings_require_notes:"Notes obligatoires",
    settings_require_notes_desc:"Les livreurs doivent ajouter une note lors d'une visite",
    settings_notif_sound:"Son de notification",
    settings_notif_sound_desc:"Jouer un son lors de nouvelles alertes",
    settings_work_start:"Heure de début",
    settings_work_end:  "Heure de fin",
    settings_track_outside:"Suivre hors des heures de travail",
    settings_track_outside_desc:"Continuer à enregistrer les positions GPS après les heures de travail",
    settings_working_days:"Jours de travail",
    settings_working_days_hint:"Sélectionnez les jours de travail des livreurs",
    settings_out_of_zone:"Alertes hors zone",
    settings_out_of_zone_desc:"Envoyer une alerte quand un livreur quitte sa zone",
    settings_cooldown:  "Délai entre alertes (minutes)",
    settings_cooldown_hint:"Temps minimum entre deux alertes pour le même livreur",
    settings_missed_visit:"Alerte visite manquée",
    settings_missed_visit_desc:"Notifier si un client n'a pas été visité en fin de journée",
    settings_long_stop: "Alerte arrêt prolongé",
    settings_long_stop_desc:"Notifier si un livreur reste trop longtemps au même endroit",
    settings_long_stop_min:"Seuil d'arrêt prolongé (minutes)",
    settings_long_stop_hint:"Alerter si le livreur reste immobile plus longtemps que cela",
    settings_company_name:"Nom de l'entreprise",
    settings_company_ph:"Nom de votre entreprise",
    settings_phone:     "Téléphone",
    settings_email:     "Email",
    settings_address:   "Adresse",
    settings_logo:      "Logo de l'entreprise",
    settings_logo_change:"Changer le logo",
    settings_logo_upload:"Télécharger le logo",
    settings_logo_remove:"Supprimer",
    settings_logo_hint: "PNG, JPG jusqu'à 2 Mo",
    settings_color:     "Couleur principale",
    settings_color_hint:"Utilisée pour les rapports et exports",

    form_first_name:    "Prénom",
    form_last_name:     "Nom",
    form_email:         "Email",
    form_email_login:   "(connexion)",
    form_phone:         "Téléphone",
    form_password:      "Mot de passe",
    form_password_keep: "(laisser vide pour conserver)",
    form_password_min:  "Min 6 caractères",
    form_role:          "Rôle",
    form_status:        "Statut",
    form_show:          "Afficher",
    form_hide:          "Masquer",
    form_required:      "obligatoire",
    form_notes:         "Notes",
    form_name:          "Nom",
    form_address:       "Adresse",

    delete_cannot_undo: "Cette action est irréversible.",
    delete_selected:    "sélectionné(s)",
    delete_all:         "Tout supprimer",

    company_id:         "Entreprise",
    super_admin_badge:  "Super Admin",
    // ── Operator Dashboard ───────────────────────────────────────────────────
    op_dash_my_clients:   "Mes clients",
    op_dash_statistics:   "Statistiques",
    op_dash_profile:      "Profil",

    // ── Operator — Add/Edit Client ───────────────────────────────────────────
    op_client_title:      "Ajouter un client",
    op_client_edit_title: "Modifier le client",
    op_client_first_name: "Prénom",
    op_client_last_name:  "Nom",
    op_client_phone:      "Téléphone",
    op_client_address:    "Adresse",
    op_client_notes:      "Notes",
    op_client_notes_ph:   "Notes supplémentaires...",
    op_client_pin_title:  "Épingler la position",
    op_client_pin_hint:   "Appuyez sur la carte ou déplacez l'épingle",
    op_client_use_gps:    "Ma position",
    op_client_locating:   "Localisation...",
    op_client_gps_error:  "Impossible d'obtenir la position",
    op_client_save:       "Enregistrer le client",
    op_client_update:     "Mettre à jour",
    op_client_saving:     "Enregistrement...",
    op_client_updating:   "Mise à jour...",
    op_client_saved:      "Client enregistré avec succès",
    op_client_delete_title: "Supprimer le client",
    op_client_delete_msg:   "Êtes-vous sûr de vouloir supprimer ce client ?",

    // ── Operator — My Clients ────────────────────────────────────────────────
    op_my_clients_title:  "Mes clients",
    op_my_clients_empty:  "Aucun client ajouté",
    op_my_clients_search: "Rechercher...",
    op_my_clients_date:   "Ajouté le",

    // ── Operator — Statistics ────────────────────────────────────────────────
    op_stats_title:        "Mes statistiques",
    op_stats_total:        "Total clients",
    op_stats_today:        "Ajoutés aujourd'hui",
    op_stats_week:         "Cette semaine",
    op_stats_deleted:      "Supprimés",
    op_stats_daily_chart:  "7 derniers jours",
    op_stats_weekly_chart: "4 dernières semaines",
    op_stats_week_label:   "Semaine",
    op_stats_count:        "Clients",

    // ── Operator — Profile ───────────────────────────────────────────────────
    op_profile_title:      "Mon profil",
    op_profile_change_pw:  "Changer le mot de passe",
    op_profile_current_pw: "Mot de passe actuel",
    op_profile_new_pw:     "Nouveau mot de passe",
    op_profile_confirm_pw: "Confirmer le mot de passe",
    op_profile_pw_mismatch:"Les mots de passe ne correspondent pas",
    op_profile_pw_updated: "Mot de passe mis à jour",
    op_profile_updating:   "Mise à jour...",

    // ── Operators Manager ────────────────────────────────────────────────────
    op_title:           "Opérateurs",
    op_add:             "+ Ajouter un opérateur",
    op_new:             "Nouvel opérateur",
    op_create:          "Créer l'opérateur",
    op_edit:            "Modifier l'opérateur",
    op_access_hint:     "Les opérateurs peuvent ajouter des clients depuis l'application mobile",
    op_clients_count:   "clients",
    op_bulk_delete:     "Supprimer la sélection",
    op_delete_title:    "Supprimer l'opérateur",
    op_delete_msg:      "Êtes-vous sûr de vouloir supprimer cet opérateur ?",
    op_no_operators:    "Aucun opérateur pour l'instant",
    op_search_ph:       "Rechercher par nom ou e-mail...",
    op_notes:           "Notes",
    op_notes_ph:        "Notes internes sur cet opérateur...",
    op_new_password:    "Nouveau mot de passe",
    op_new_password_ph: "Laisser vide pour conserver le mot de passe actuel",

    // ── Login page ───────────────────────────────────────────────────────────
    login_email:        "Adresse e-mail",
    login_password:     "Mot de passe",
    login_submit:       "Se connecter",
    login_signing_in:           "Connexion en cours...",
    login_welcome:              "Connexion à",
    login_subtitle:             "Entrez vos identifiants pour accéder à votre tableau de bord.",
    login_eyebrow:              "Plateforme de gestion terrain",
    login_tagline:              "Opérations terrain, maîtrisées.",
    login_tagline_sub:          "Visibilité en temps réel sur vos livreurs, clients et zones de couverture — en une seule plateforme.",
    login_feature_tracking:     "Suivi des livreurs en direct",
    login_feature_tracking_sub: "Visualisez la position de chaque livreur en temps réel dans vos zones.",
    login_feature_visits:       "Gestion des visites clients",
    login_feature_visits_sub:   "Suivez les pointages, les taux de couverture et l'historique des visites.",
    login_feature_coverage:     "Analytique de couverture par zone",
    login_feature_coverage_sub: "Analysez les performances de livraison sur tous vos territoires.",
    login_suspended_msg:        "Le compte de votre entreprise a été suspendu en raison d'un problème de paiement ou d'une expiration d'abonnement.",
    login_suspended_contact:    "Besoin d'aide ? Contactez le support :",
    login_suspended_back:       "Retour à la connexion",
    login_error_disabled:       "Votre compte a été désactivé. Contactez votre administrateur.",
    login_error_generic:        "Email ou mot de passe incorrect. Veuillez réessayer.",

    // ── SuperAdmin ───────────────────────────────────────────────────────────
    nav_all_companies:       "Toutes les sociétés",
    nav_create_company:      "Créer une société",
    nav_global_settings:     "Paramètres globaux",
    nav_health:              "Santé de la plateforme",
    nav_sa_settings:         "Mes paramètres",

    tab_overview:            "Aperçu",
    tab_edit:                "Modifier",
    tab_subscription:        "Abonnement",
    tab_vendors:             "Livreurs",
    tab_clients:             "Clients",
    tab_zones:               "Zones",
    tab_reset_checkins:      "Réinitialiser",
    tab_analytics:           "Analytiques",
    tab_sessions:            "Sessions",

    btn_refresh:             "Actualiser",
    btn_login_as_admin:      "Connexion admin",
    btn_view_details:        "Voir les détails",
    btn_disable:             "Désactiver",
    btn_enable:              "Activer",
    btn_yes_disable:         "Oui, désactiver",
    btn_yes_enable:          "Oui, activer",
    btn_yes_delete_all:      "Oui, tout supprimer",

    lbl_company_name:        "Nom de la société",
    lbl_billing_plan:        "Plan",
    lbl_balance:             "Solde",
    lbl_status:              "Statut",
    lbl_suspended:           "Suspendu",
    lbl_total_companies:     "Total sociétés",
    lbl_total_vendors:       "Total livreurs",
    lbl_total_clients:       "Total clients",
    lbl_visits_today:        "Visites aujourd'hui",
    lbl_last_activity:       "Dernière activité",
    lbl_expiring_soon:       "Expire dans 7 jours",
    lbl_gps_live:            "En direct",
    lbl_language:            "Langue",
    lbl_appearance:          "Apparence",
    lbl_dark_mode:           "Mode sombre",
    lbl_dark_mode_hint:      "Passer au thème sombre",
    lbl_change_password:     "Changer le mot de passe",
    lbl_current_password:    "Mot de passe actuel",
    lbl_new_password:        "Nouveau mot de passe",
    lbl_confirm_password:    "Confirmer le mot de passe",
    lbl_feature_controls:    "Contrôles des fonctionnalités",
    lbl_usage_limits:        "Limites d'utilisation",

    sa_viewing:              "Voir :",
    sa_back_all:             "← Retour à tous",
    sa_back:                 "← Retour",
    sa_settings_sub:         "Langue, apparence et sécurité du compte",
    sa_dark_mode_hint:       "Passer au thème sombre",
    sa_platform_health_sub:  "Vue d'ensemble en direct de toutes les sociétés",
    sa_login_blocked:        "Connexion bloquée",
    sa_getting_access:       "Obtenir l'accès...",
    sa_company_disabled:     "Société désactivée",
    sa_disable_company:      "Désactiver la société",
    sa_enable_company:       "Activer la société",
    sa_delete_company:       "Supprimer la société",
    sa_usage_limits:         "Limites d'utilisation",
    sa_platform_visits:      "Visites — 7 derniers jours",
    sa_global_settings:      "Paramètres par défaut globaux",
    sa_global_settings_sub:  "Paramètres par défaut pour toutes les nouvelles sociétés.",
    sa_changing_password:    "Modification...",
    sa_super_admin_badge:    "SUPER ADMIN",
    sa_updated:              "Mis à jour",
    sa_admins:               "Admins",
    sa_supervisors:          "Superviseurs",
    sa_vendors_count:        "livreurs",
    sa_clients_count:        "clients",
    sa_zones_count:          "zones",
    sa_events_count:         "événements",
    sa_expires:              "Expire :",
    sa_company_gps_warning:  "Sociétés — Aucune activité GPS depuis 7+ jours",
    sa_gps_warning_sub:      "Ces sociétés peuvent nécessiter un suivi.",
    sa_all_companies_count:  "Toutes les sociétés",
    sa_platform_visits_7d:   "Visites — 7 derniers jours",
    sa_loading_health:       "Chargement des données...",
    sa_retry:                "Réessayer",
    sa_view:                 "Voir",
    sa_last_activity:        "Dernière activité :",
    sa_no_activity:          "Aucune activité",
    sa_today:                "Aujourd'hui",
    sa_yesterday:            "Hier",
    sa_days_ago:             "jours",
    sa_loading:              "Chargement...",
    sa_expired:              "Expiré",
    sa_balance_zero:         "Solde 0",

    // ── GlobalSettings ───────────────────────────────────────────────────────
    lbl_working_hours:         "Heures de travail",
    lbl_wh_start:              "Début",
    lbl_wh_end:                "Fin",
    lbl_new_company_defaults:  "Paramètres par défaut",
    lbl_default_max_vendors:   "Vendeurs max par défaut",
    lbl_default_max_clients:   "Clients max par défaut",
    lbl_default_ooz_alerts:    "Alertes hors zone par défaut",
    lbl_tracking:              "Suivi",
    lbl_nearby_distance_m:     "Distance proche (m)",
    lbl_min_distance_m:        "Distance min autorisée (m)",
    lbl_alert_cooldown_min:    "Délai d'alerte (min)",
    lbl_max_speed_kmh:         "Vitesse max (km/h, 0=désactivé)",
    lbl_offline_threshold_min: "Seuil hors ligne (minutes)",
    lbl_offline_threshold_hint:"Un livreur est marqué hors ligne si aucune donnée GPS n'est reçue pendant ces minutes",
    lbl_auto_checkin:          "Enregistrement auto :",
    lbl_regional:              "Régional",
    lbl_date_format:           "Format de date",
    btn_save_global_settings:  "Enregistrer les paramètres",
    lbl_saving:                "Enregistrement...",
    lbl_resetting:             "Réinitialisation...",

    // ── CreateCompany ────────────────────────────────────────────────────────
    create_company_title:      "Créer une nouvelle société",
    create_company_desc:       "Crée la société et le compte administrateur automatiquement.",
    lbl_company_info:          "Informations sur la société",
    lbl_admin_account_section: "Compte administrateur",
    lbl_tier:                  "Niveau",
    lbl_out_of_zone_alerts:    "Alertes hors zone",
    lbl_max_vendors:           "Vendeurs max",
    lbl_max_clients:           "Clients max",
    lbl_first_name:            "Prénom",
    lbl_last_name:             "Nom de famille",
    lbl_admin_email:           "Email administrateur",
    lbl_admin_password:        "Mot de passe administrateur",
    btn_create_company:        "Créer la société",
    lbl_creating:              "Création en cours...",

    // ── EditTab ──────────────────────────────────────────────────────────────
    lbl_company_details:       "Détails de la société",
    lbl_company_logo:          "Logo de la société",
    lbl_choose_image:          "Choisir une image",
    lbl_upload_logo:           "Télécharger le logo",
    btn_save_details:          "Enregistrer les détails",
    btn_save_feature_settings: "Enregistrer les fonctionnalités",
    lbl_change_admin_email:    "Changer l'email admin",
    lbl_change_email_desc:     "Modifie l'email de connexion du compte admin.",
    lbl_current_email:         "Email actuel :",
    btn_change_email:          "Changer l'email",
    lbl_reset_admin_password:  "Réinitialiser le mot de passe admin",
    lbl_reset_password_desc:   "Modifie le mot de passe du compte admin.",
    btn_reset_password:        "Réinitialiser",
    lbl_feature_controls_desc: "Activez ou désactivez les fonctionnalités. Les changements prennent effet immédiatement.",
    lbl_stock_pos:             "Stock et PDV",
    lbl_stock_pos_desc:        "Les livreurs peuvent gérer le stock et vendre aux clients",
    lbl_route_optimization:    "Optimisation de route",
    lbl_route_optimization_desc:"Les livreurs peuvent optimiser leur route quotidienne",
    lbl_route_basic:           "Basique (Gratuit)",
    lbl_route_google:          "Google Routes (Premium)",
    lbl_anomaly_detection:     "Détection d'anomalies",
    lbl_anomaly_detection_desc:"Détection automatique des comportements suspects",
    lbl_api_access:            "Accès API",
    lbl_api_access_desc:       "L'admin peut générer des clés API pour l'intégration",

    // ── SubscriptionTab ──────────────────────────────────────────────────────
    lbl_account_suspended:     "Compte suspendu",
    lbl_balance_zero_suspended:"Solde à 0. Ajoutez un dépôt pour réactiver.",
    lbl_company_disabled_msg:  "Cette société est désactivée. Réactivez-la manuellement.",
    lbl_plan_settings:         "Plan et paramètres",
    lbl_add_deposit_tab:       "Ajouter un dépôt",
    lbl_deposit_history:       "Historique des dépôts",
    lbl_subscription_plan:     "Plan d'abonnement",
    lbl_monthly_billing:       "Facturation mensuelle",
    lbl_monthly_billing_desc:  "Le client paie un dépôt. Le système déduit les frais mensuels ÷ 30 chaque jour. Compte bloqué à solde zéro.",
    lbl_active_forever:        "Actif pour toujours",
    lbl_active_forever_desc:   "Pas de suivi de paiement. Le compte reste actif jusqu'à désactivation manuelle.",
    lbl_expiry_by_date:        "Expiration par date",
    lbl_expiry_by_date_desc:   "Le compte est actif jusqu'à une date fixée. Désactivé automatiquement à l'expiration.",
    lbl_initial_deposit_aed:   "Dépôt initial (AED)",
    lbl_monthly_fee_aed:       "Frais mensuels (AED)",
    lbl_current_balance_aed:   "Solde actuel (AED)",
    lbl_months_remaining:      "Mois restants :",
    lbl_notes:                 "Notes",
    lbl_expiry_date_req:       "Date d'expiration *",
    btn_save_plan:             "Enregistrer le plan",
    lbl_current_status:        "Statut actuel",
    lbl_plan_type_label:       "Type de plan",
    lbl_monthly_fee_label:     "Frais mensuels",
    lbl_current_balance_display:"Solde actuel :",
    lbl_deposit_amount_aed:    "Montant du dépôt (AED) *",
    lbl_note_optional:         "Note (optionnelle)",
    lbl_new_balance_after:     "Nouveau solde après dépôt :",
    btn_add_deposit:           "Ajouter un dépôt",
    lbl_adding:                "Ajout en cours...",
    lbl_no_deposits:           "Aucun dépôt enregistré",
    th_date:                   "Date",
    th_amount:                 "Montant",
    th_balance_after:          "Solde après",
    th_type:                   "Type",
    th_note:                   "Note",
    lbl_monthly_charge:        "Frais mensuel",
    lbl_deposit_label:         "Dépôt",
    lbl_days_remaining_label:  "Jours restants",
    lbl_daily_rate:            "Taux journalier",
    lbl_per_day:               "/ jour",
    // ── Subscription Panel (admin overview — read-only) ──────────────────────
    lbl_subscription_billing:       "Abonnement & Facturation",
    lbl_last_deduction:             "Dernière déduction",
    lbl_not_yet:                    "Pas encore",
    lbl_days_remaining_approx:      "jours restants",
    lbl_active_forever_billing_msg: "Ce compte est actif pour toujours — aucun suivi de solde ou d'expiration.",
    lbl_active_until:               "Actif jusqu'au",
    lbl_subscription_expired_title: "Abonnement expiré",
    lbl_low_balance_warning:        "Solde faible — votre abonnement sera suspendu dans environ {days} jour(s). Veuillez contacter votre administrateur.",
    lbl_suspended_balance_warning:  "Votre abonnement a été suspendu en raison d'un solde insuffisant. Veuillez contacter votre administrateur.",
    lbl_h_ago:                      "il y a {n}h",
    lbl_d_ago:                      "il y a {n}j",

    // ── VendorsTab ───────────────────────────────────────────────────────────
    lbl_no_vendors_yet:        "Aucun livreur pour l'instant",

    // ── ClientsTab ───────────────────────────────────────────────────────────
    lbl_with_gps:              "Avec GPS",
    lbl_assigned_zone:         "Assigné à une zone",
    lbl_visited_stat:          "Visité",
    lbl_client_import_info:    "Les détails des clients sont gérés depuis le tableau de bord admin. Le Super Admin peut voir les statistiques ici seulement.",
    lbl_import_export_clients: "Importer / Exporter les clients",
    btn_import_clients:        "Importer les clients",
    btn_download_all:          "Tout télécharger",
    btn_delete_all_clients:    "Supprimer tous les clients",
    lbl_will_be_uploaded:      "Sera téléversé",
    lbl_duplicates_skipped:    "Doublons ignorés",
    lbl_no_coordinates:        "Sans coordonnées",
    lbl_all_duplicates_msg:    "Tous les clients existent déjà — rien à téléverser",
    lbl_delete_all_clients_title:"Supprimer tous les clients",

    // ── ResetCheckinsTab ─────────────────────────────────────────────────────
    lbl_select_scope:          "Sélectionner la portée",
    lbl_all_zones_company:     "Toutes les zones (entreprise entière)",
    lbl_loading_checked_in:    "Chargement des clients pointés...",
    lbl_currently_checked_in:  "clients actuellement pointés",
    lbl_visited_badge:         "● Visité",
    lbl_confirm_reset_title:   "Confirmer la réinitialisation",
    btn_confirm_reset:         "Confirmer",
    lbl_reset_complete_msg:    "Réinitialisation terminée",
    lbl_tab_reset_desc:        "Réinitialise le statut visité pour que les livreurs puissent pointer à nouveau",

    // ── ZonesTab ─────────────────────────────────────────────────────────────
    btn_import:                "Importer",
    btn_export:                "Exporter",
    lbl_no_zones_yet:          "Aucune zone définie. Importez un fichier GeoJSON ou KML pour ajouter des zones.",
    lbl_polygon_points:        "points de polygone",
    lbl_no_polygon_defined:    "Aucun polygone défini",

    // ── CompanyAnalytics ─────────────────────────────────────────────────────
    lbl_usage_analytics:       "Analytiques d'utilisation",
    lbl_7_days:                "7 jours",
    lbl_30_days:               "30 jours",
    lbl_90_days:               "90 jours",
    lbl_total_checkins:        "Total pointages",
    lbl_avg_visits_day:        "Visites moyennes / jour",
    lbl_active_vendors_stat:   "Livreurs actifs",
    lbl_total_alerts_stat:     "Total alertes",
    lbl_speed_alerts_stat:     "Alertes vitesse",
    lbl_long_stop_alerts_stat: "Alertes arrêt long",
    lbl_clients_visited:       "Clients visités",
    lbl_total_events:          "Total événements",
    lbl_daily_activity:        "Activité quotidienne — Derniers",
    lbl_days:                  "jours",
    lbl_top_vendors_visits:    "Meilleurs livreurs par visites",
    lbl_most_visited_clients:  "Clients les plus visités",
    lbl_alert_breakdown:       "Répartition des alertes",
    lbl_no_visits_recorded:    "Aucune visite enregistrée",
    lbl_no_alerts_period:      "Aucune alerte dans cette période — excellentes performances !",
    lbl_loading_analytics:     "Chargement des analytiques...",
    lbl_zone_alerts:           "Alertes de zone",
    lbl_outside_hours_alerts:  "Alertes hors heures",

    // SuperAdmin My Settings — 2FA
    lbl_two_factor_auth:       "Authentification à deux facteurs",
    lbl_2fa_enabled:           "2FA activé",
    lbl_2fa_disabled:          "2FA désactivé",
    btn_enable_2fa:            "Activer le 2FA",
    btn_disable_2fa:           "Désactiver le 2FA",
    lbl_2fa_scan_qr:           "Scannez ce QR code avec Google Authenticator ou Authy :",
    lbl_2fa_enter_code:        "Après le scan, entrez le code à 6 chiffres :",
    lbl_2fa_enter_to_disable:  "Entrez le code pour désactiver le 2FA :",
    btn_verify_enable:         "Vérifier et activer",
    btn_confirm_disable:       "Confirmer la désactivation",
    lbl_verifying:             "Vérification...",
    lbl_disabling:             "Désactivation...",
    err_2fa_code_length:       "Veuillez entrer le code à 6 chiffres.",

    // SuperAdmin My Settings — Change Email
    lbl_change_email:          "Changer l'email",
    lbl_new_email:             "Nouvel email",
    lbl_confirm_with_password: "Confirmer avec le mot de passe",
    btn_update_email:          "Mettre à jour l'email",
    lbl_updating:              "Mise à jour...",
    err_email_required:        "Veuillez entrer un nouvel email.",
    err_email_invalid:         "Veuillez entrer un email valide.",
    err_email_same:            "Le nouvel email est identique.",
    err_password_required:     "Veuillez entrer votre mot de passe.",
    err_wrong_password:        "Mot de passe incorrect.",
    err_email_in_use:          "Email déjà utilisé.",
    err_reauth_required:       "Veuillez vous reconnecter d'abord.",
    success_email_updated:     "Email mis à jour avec succès.",

    // Login — 2FA verification step
    lbl_2fa_verification:      "Vérification en deux étapes",
    lbl_2fa_open_app:          "Ouvrez votre application d'authentification et entrez le code à 6 chiffres.",
    btn_verify:                "Vérifier",
    btn_back_to_login:         "Retour à la connexion",
    err_2fa_invalid:           "Code invalide ou expiré. Réessayez.",

    // SuperAdmin My Settings — Active Sessions
    lbl_active_sessions:             "Sessions actives",
    lbl_no_sessions:                 "Aucune session active",
    lbl_current_session:             "Actuelle",
    lbl_logged_in:                   "Connecté",
    lbl_last_active:                 "Dernière activité",
    lbl_revoking:                    "Révocation...",
    btn_revoke:                      "Révoquer",
    lbl_multiple_sessions_warning:   "Plusieurs sessions actives détectées. Révoquez celles que vous ne reconnaissez pas.",
    lbl_ip_address:                  "Adresse IP",
    lbl_connection_history:          "Historique de connexion",
    lbl_from_date:                   "Du",
    lbl_to_date:                     "Au",
    btn_load_history:                "Charger",
    lbl_select_dates:                "Sélectionnez une période et cliquez sur Charger.",
    lbl_no_history:                  "Aucune session trouvée pour cette période.",
    lbl_session_ended:               "Terminée",
    lbl_session_revoked:             "Révoquée",
    lbl_active:                      "Active",
    lbl_device:                      "Appareil",
    lbl_default_timezone:            "Fuseau horaire par défaut",
    lbl_default_timezone_desc:       "Utilisé pour vos rapports, horodatages et analyses.",
    btn_save_timezone:               "Enregistrer le fuseau",
    success_saved:                   "Enregistré avec succès.",
    lbl_never:                       "Jamais",
    lbl_platform_branding:           "Image de marque",
    lbl_platform_name:               "Nom de la plateforme",
    lbl_platform_name_desc:          "Affiché sur la page de connexion et les rapports.",
    lbl_primary_color:               "Couleur principale",
    lbl_primary_color_desc:          "Affecte les boutons et la barre latérale.",
    lbl_platform_logo:               "Logo de la plateforme",
    lbl_logo_desc:                   "PNG ou JPG, max 2 Mo. Recommandé: 200x200px",
    btn_upload_logo:                 "Télécharger le logo",
    btn_remove_logo:                 "Supprimer",
    btn_save_branding:               "Enregistrer l'image",
    lbl_preview_button:              "Aperçu bouton",
    lbl_preview_badge:               "Aperçu badge",
    success_branding_saved:          "Image de marque enregistrée. Changements immédiats.",
    err_logo_type:                   "Veuillez sélectionner une image.",
    err_logo_size:                   "Le logo doit être inférieur à 2 Mo.",

    btn_save:                        "Enregistrer",

    // ── Data & Maintenance ───────────────────────────────────────────────────
    lbl_data_maintenance:            "Données et maintenance",
    lbl_auto_backup:                 "Sauvegarde automatique",
    lbl_enable_backup:               "Activer la sauvegarde automatique",
    lbl_backup_desc:                 "Exporter les données Firestore vers Google Cloud Storage",
    lbl_backup_frequency:            "Fréquence de sauvegarde",
    opt_daily:                       "Chaque jour",
    opt_weekly:                      "Chaque semaine",
    opt_every_10:                    "Tous les 10 jours",
    opt_monthly:                     "Chaque mois",
    opt_custom_days:                 "Personnalisé (tous les N jours)",
    lbl_every_n_days:                "Tous les combien de jours?",
    lbl_backup_time:                 "Lancer la sauvegarde à (heure)",
    lbl_retain_backups:              "Conserver les sauvegardes (jours)",
    opt_7_days:                      "7 jours",
    opt_14_days:                     "14 jours",
    opt_30_days:                     "30 jours",
    opt_60_days:                     "60 jours",
    opt_90_days:                     "90 jours",
    opt_1_year:                      "1 an",
    lbl_recent_backups:              "Sauvegardes récentes",
    btn_backup_now:                  "Lancer la sauvegarde maintenant",
    lbl_backup_running:              "Sauvegarde en cours...",
    success_backup_started:          "Sauvegarde démarrée. Vérifiez les journaux.",
    lbl_data_retention:              "Rétention des données",
    lbl_data_retention_desc:         "Les anciens événements GPS sont supprimés automatiquement. Les données clients ne sont jamais supprimées.",
    lbl_keep_events_for:             "Conserver les événements pendant",
    opt_keep_forever:                "Conserver indéfiniment",
    opt_3_months:                    "3 mois",
    opt_6_months:                    "6 mois",
    opt_12_months:                   "12 mois (recommandé)",
    opt_24_months:                   "24 mois",
    opt_36_months:                   "36 mois",
    lbl_retention_warning:           "Les événements plus anciens seront supprimés définitivement le 1er de chaque mois.",
    lbl_api_rate_limit:              "Limite de débit API (requêtes par minute)",
    opt_per_minute:                  "requêtes / minute",
    opt_unlimited:                   "Illimité",
    lbl_rate_limit_desc:             "Requêtes API maximum par minute. Les requêtes en excès retournent une erreur 429.",

    // ── Reports Page (FR) ────────────────────────────────────────────────────
    reports_title:                   "Rapports",
    reports_subtitle:                "Générez et exportez des rapports pour n'importe quelle période",
    reports_step1:                   "Étape 1 — Sélectionnez le type de rapport",
    reports_step2:                   "Étape 2 — Définissez les filtres",
    reports_type_visits:             "Visites clients",
    reports_type_visits_desc:        "Clients visités, quand, par qui",
    reports_type_zone_coverage:      "Couverture de zone",
    reports_type_zone_coverage_desc: "Clients visités vs non visités par zone",
    reports_type_activity:           "Activité livreur",
    reports_type_activity_desc:      "Heures en ligne/hors ligne",
    reports_type_alerts:             "Historique hors zone",
    reports_type_alerts_desc:        "Chaque alerte : qui, quelle zone, quand",
    reports_type_unauth_zone:        "Zone non autorisée",
    reports_type_unauth_zone_desc:   "Livreurs entrés dans des zones non assignées",
    reports_type_zone:               "Zone / Géofence",
    reports_type_zone_desc:          "Quels livreurs ont visité chaque zone",
    reports_type_daily:              "Résumé quotidien",
    reports_type_daily_desc:         "Journée complète : livreurs, visites, alertes",
    reports_type_client_creation:    "Création de clients",
    reports_type_client_creation_desc:"Clients ajoutés par chaque opérateur",
    reports_type_custom:             "Rapport personnalisé",
    reports_type_custom_desc:        "Choisissez n'importe quelle combinaison de filtres",
    reports_period_today:            "Aujourd'hui",
    reports_period_week:             "Cette semaine",
    reports_period_month:            "Ce mois",
    reports_period_last_month:       "Mois dernier",
    reports_period_custom:           "Personnalisé",
    reports_period_yesterday:        "Hier",
    reports_period_this_week:        "Cette semaine",
    reports_period_this_month:       "Ce mois",
    reports_from_date:               "Date de début",
    reports_from_time:               "Heure de début",
    reports_to_date:                 "Date de fin",
    reports_to_time:                 "Heure de fin",
    reports_vendor_filter:           "Livreur",
    reports_all_vendors:             "Tous les livreurs",
    reports_zone_filter:             "Zone / Section",
    reports_all_zones:               "Toutes les zones",
    reports_search_vendors:          "Rechercher livreurs...",
    reports_search_zones:            "Rechercher zones...",
    reports_no_vendors_found:        "Aucun livreur trouvé",
    reports_no_zones_found:          "Aucune zone trouvée",
    reports_event_types:             "Types d'événements à inclure",
    reports_group_by:                "Grouper les résultats par",
    reports_group_vendor:            "Livreur",
    reports_group_zone:              "Zone",
    reports_group_day:               "Jour",
    reports_group_client:            "Client",
    reports_select_event_type:       "Sélectionnez au moins un type d'événement.",
    reports_generating:              "Génération en cours...",
    reports_generate:                "Générer le rapport",
    reports_report_label:            "Rapport",
    reports_zones_count:             "zone(s)",
    reports_events_count:            "événement(s)",
    reports_vendors_count:           "livreur(s)",
    reports_export_excel:            "Excel",
    reports_export_csv:              "CSV",
    reports_export_pdf:              "PDF",
    reports_no_events:               "Aucun événement trouvé",
    reports_no_events_sub:           "Essayez une autre plage de dates ou des filtres différents",
    reports_no_clients_zone:         "Aucun client trouvé dans aucune zone",
    reports_no_clients_zone_sub:     "Ajoutez des clients et assignez-les à des zones",
    reports_no_zone_visits:          "Aucune visite de zone trouvée",
    reports_no_zone_visits_sub:      "Essayez une autre plage de dates ou des filtres différents",
    reports_no_unauth:               "Aucune entrée non autorisée trouvée",
    reports_no_unauth_sub:           "Aucun livreur n'est entré dans des zones non assignées sur cette période",
    reports_anomaly_disabled:        "Les alertes hors zone sont actuellement désactivées. Activez la détection d'anomalies dans les paramètres.",
    reports_overall_coverage:        "Couverture globale",
    reports_visited:                 "Visité",
    reports_not_visited:             "Non visité",
    reports_none_visited:            "Aucun visité",
    reports_all_visited:             "Tous visités !",
    reports_covered:                 "couvert",
    reports_clients_count:           "clients",
    reports_col_vendor:              "Livreur",
    reports_col_total_visits:        "Total visites",
    reports_col_unique_clients:      "Clients uniques",
    reports_col_last_visit:          "Dernière visite",
    reports_col_check_ins:           "Pointages",
    reports_col_clients_visited:     "Clients visités",
    reports_col_type:                "Type",
    reports_col_client_zone:         "Client / Zone",
    reports_col_timestamp:           "Horodatage",
    reports_col_duration:            "Durée",
    reports_col_zone:                "Zone",
    reports_col_total_clients:       "Total clients",
    reports_col_coverage:            "Couverture %",
    reports_speed_alerts:            "Alertes vitesse",
    reports_zone_alerts:             "Alertes zone",
    reports_long_stop_alerts:        "Alertes arrêt long",
    reports_check_ins:               "Pointages",
    reports_op_step2:                "Étape 2 — Définissez les filtres",
    reports_op_from:                 "Du",
    reports_op_to:                   "Au",
    reports_op_operator:             "Opérateur",
    reports_op_search:               "Rechercher opérateurs...",
    reports_op_all_operators:        "Tous les opérateurs",
    reports_op_loading:              "Chargement des opérateurs...",
    reports_op_generate:             "Générer le rapport",
    reports_op_generating:           "Génération en cours...",
    reports_op_report_title:         "Rapport de création de clients",
    reports_op_export:               "Exporter vers Excel",
    reports_op_by_operator:          "Par opérateur",
    reports_op_no_operators:         "Aucun opérateur trouvé.",
    reports_op_today:                "Aujourd'hui",
    reports_op_this_week:            "Cette semaine",
    reports_op_this_month:           "Ce mois",
    reports_op_in_period:            "Dans la période",
    reports_op_total_all_time:       "Total depuis toujours",
    reports_op_all_clients:          "Tous les clients dans la période",
    reports_op_search_clients:       "Rechercher par nom, téléphone ou opérateur...",
    reports_op_no_clients:           "Aucun client trouvé pour cette période.",
    reports_op_col_name:             "Nom",
    reports_op_col_phone:            "Téléphone",
    reports_op_col_created_by:       "Créé par",
    reports_op_col_date_added:       "Date d'ajout",
    reports_custom_checkins:         "Pointages (GPS + Manuel)",
    reports_custom_zone_alert:       "Alertes de zone",
    reports_custom_speed_alert:      "Alertes de vitesse",
    reports_custom_long_stop:        "Alertes d'arrêt long",
    reports_custom_outside_hours:    "Alertes hors horaires",
    reports_custom_no_visits:        "Alertes sans visites",

    // ── Statistics Page (FR extra) ───────────────────────────────────────────
    stats_title:                     "Statistiques",
    stats_subtitle:                  "Suivez les visites, alertes et performances des livreurs",

    // ── Company Settings (FR) ─────────────────────────────────────────────────
    cs_title:                        "Paramètres de l'entreprise",
    cs_subtitle:                     "Configurez les préférences de votre entreprise",
    cs_saving:                       "Enregistrement...",
    cs_uploading:                    "Téléchargement...",
    cs_save_changes:                 "Enregistrer",
    cs_loading:                      "Chargement des paramètres...",
    cs_load_error:                   "Impossible de charger les paramètres. Actualisez la page.",
    cs_tab_general:                  "Général",
    cs_tab_tracking:                 "Suivi",
    cs_tab_hours:                    "Heures de travail",
    cs_tab_alerts:                   "Alertes",
    cs_tab_appearance:               "Apparence",
    cs_tab_client_types:             "Types de clients",
    cs_regional:                     "Paramètres régionaux",
    cs_timezone:                     "Fuseau horaire",
    cs_language:                     "Langue",
    cs_date_format:                  "Format de date",
    cs_behaviour:                    "Comportement",
    cs_auto_checkin:                 "Pointage automatique",
    cs_auto_checkin_desc:            "Enregistrer automatiquement une visite à l'arrivée du livreur",
    cs_manual_checkin:               "Autoriser le pointage manuel",
    cs_manual_checkin_desc:          "Les livreurs peuvent marquer une visite manuellement",
    cs_require_notes:                "Notes obligatoires lors d'une visite",
    cs_require_notes_desc:           "Les livreurs doivent ajouter une note lors d'une visite",
    cs_notif_sound:                  "Son de notification",
    cs_notif_sound_desc:             "Jouer un son lors de nouvelles alertes",
    cs_gps_tracking:                 "GPS et détection d'arrivée",
    cs_nearby_distance:              "Distance de proximité (mètres)",
    cs_nearby_hint:                  "Distance pour détecter l'arrivée du livreur",
    cs_gps_interval:                 "Intervalle GPS (secondes)",
    cs_gps_interval_hint:            "Fréquence d'envoi des mises à jour de position",
    cs_min_arrival:                  "Distance min d'arrivée (m)",
    cs_max_arrival:                  "Distance max d'arrivée (m)",
    cs_visit_reset:                  "Réinitialisation des visites (jours)",
    cs_visit_reset_hint:             "Après combien de jours un client visité redevient non visité",
    cs_working_hours:                "Heures de travail",
    cs_hours_start:                  "Début de travail",
    cs_hours_end:                    "Fin de travail",
    cs_track_outside:                "Suivre hors des heures de travail",
    cs_track_outside_desc:           "Enregistrer les positions GPS en dehors des heures de travail",
    cs_alerts_section:               "Alertes et notifications",
    cs_out_of_zone:                  "Alertes hors zone",
    cs_out_of_zone_desc:             "Alerter quand un livreur visite un client hors de sa zone",
    cs_unauth_zone:                  "Alertes zone non autorisée",
    cs_unauth_zone_desc:             "Alerter quand un livreur entre dans une zone qui ne lui est pas assignée",
    cs_cooldown:                     "Délai entre alertes (minutes)",
    cs_cooldown_hint:                "Temps minimum entre deux alertes pour le même livreur",
    cs_max_speed:                    "Vitesse max (km/h)",
    cs_max_speed_hint:               "Alerter si le livreur dépasse cette vitesse. 0 = désactivé",
    cs_appearance:                   "Apparence",
    cs_company_name:                 "Nom de l'entreprise",
    cs_company_phone:                "Téléphone",
    cs_company_email:                "Email",
    cs_company_address:              "Adresse",
    cs_primary_color:                "Couleur principale",
    cs_logo:                         "Logo de l'entreprise",
    cs_logo_hint:                    "PNG ou JPG, max 2 Mo",
    cs_choose_logo:                  "Choisir un logo",
    cs_client_types:                 "Types de clients",
    cs_client_types_hint:            "Définissez les types de clients de votre entreprise",
    cs_add_type:                     "Ajouter un type",
    cs_new_type_ph:                  "Nom du nouveau type...",
    cs_no_types:                     "Aucun type de client défini",
    cs_success:                      "Paramètres enregistrés avec succès !",
    cs_logo_type_err:                "Veuillez sélectionner un fichier image.",
    cs_logo_size_err:                "Le logo doit faire moins de 2 Mo.",
    cs_notif_checkin:                "Afficher les notifications de pointage",
    cs_notif_checkin_desc:           "Afficher les pointages des livreurs (GPS et manuels) dans la page Notifications",
    cs_visit_alerts:                 "Alertes de visite",
    cs_missed_visit:                 "Alerte visite manquée",
    cs_missed_visit_desc:            "Notifier si un livreur n'a fait aucune visite durant la période de réinitialisation",
    cs_long_stop:                    "Alerte arrêt long",
    cs_long_stop_desc:               "Notifier si un livreur reste trop longtemps au même endroit",
    cs_long_stop_min:                "Seuil d'arrêt long (minutes)",
    cs_long_stop_hint:               "Alerter si le livreur reste au même endroit plus longtemps que cette durée pendant les heures de travail",

    // ── Stock Manager (FR extra) ─────────────────────────────────────────────
    stock_subtitle:                  "Gérez le catalogue, le stock des livreurs, les ventes et les mouvements",
    stock_search_products:           "Rechercher produits...",
    stock_all_categories:            "Toutes catégories",
    stock_add_product:               "+ Ajouter un produit",
    stock_refresh:                   "Actualiser",
    stock_export_excel:              "Excel",
    stock_no_products:               "Aucun produit trouvé",
    stock_col_product:               "Produit",
    stock_col_sku:                   "SKU",
    stock_col_category:              "Catégorie",
    stock_col_unit:                  "Unité",
    stock_col_sell_price:            "Prix de vente",
    stock_col_cost:                  "Coût",
    stock_col_total_stock:           "Stock total",
    stock_col_status:                "Statut",
    stock_col_actions:               "Actions",
    stock_low:                       "Bas",
    stock_active:                    "Actif",
    stock_inactive:                  "Inactif",
    stock_edit_product:              "Modifier le produit",
    stock_add_product_modal:         "Ajouter un produit",
    stock_product_name:              "Nom du produit",
    stock_sku_label:                 "SKU",
    stock_sku_hint:                  "(auto si vide)",
    stock_category:                  "Catégorie",
    stock_unit:                      "Unité",
    stock_initial_qty:               "Quantité initiale",
    stock_low_threshold:             "Seuil de stock bas",
    stock_sell_price:                "Prix de vente",
    stock_cost_price:                "Prix de revient",
    stock_active_visible:            "Actif (visible par les livreurs)",
    stock_save_changes:              "Enregistrer les modifications",
    stock_create_product:            "Créer le produit",
    stock_saving:                    "Enregistrement...",
    stock_cancel:                    "Annuler",
    stock_delete_product:            "Supprimer le produit",
    stock_delete_confirm:            "Cette action est irréversible.",
    stock_deleting:                  "Suppression...",
    stock_name_required:             "Le nom de l'article est requis.",
    stock_product_updated:           "Produit mis à jour.",
    stock_product_created:           "Produit créé.",

    // ── Notes Inbox (FR) ─────────────────────────────────────────────────────
    notes_title:                     "Boîte de réception des notes",
    notes_subtitle:                  "Notes envoyées par le personnel terrain",
    notes_refresh:                   "Actualiser",
    notes_loading:                   "Chargement des notes...",
    notes_date_label:                "Date :",
    notes_all_time:                  "Tout le temps",
    notes_today:                     "Aujourd'hui",
    notes_yesterday:                 "Hier",
    notes_this_week:                 "Cette semaine",
    notes_this_month:                "Ce mois",
    notes_custom:                    "Personnalisé",
    notes_from:                      "Du :",
    notes_to:                        "Au :",
    notes_priority_label:            "Priorité :",
    notes_all_notes:                 "Toutes les notes",
    notes_urgent:                    "Urgent",
    notes_normal:                    "Normal",
    notes_sender_label:              "Expéditeur :",
    notes_all_senders:               "Tous les expéditeurs",
    notes_vendors:                   "Livreurs",
    notes_operators:                 "Opérateurs",
    notes_supervisors:               "Superviseurs",
    notes_showing:                   "Affichage de",
    notes_of:                        "sur",
    notes_loaded:                    "notes chargées",
    notes_empty:                     "Aucune note",
    notes_no_match:                  "Aucune note ne correspond aux filtres",
    notes_badge_urgent:              "Urgent",
    notes_badge_normal:              "Normal",
    notes_badge_unread:              "Non lu",
    notes_badge_read:                "Lu",
    notes_badge_replied:             "Répondu",
    notes_show_map:                  "Voir sur la carte",
    notes_admin_reply:               "Réponse admin",
    notes_reply_ph:                  "Rédigez votre réponse...",
    notes_cancel_reply:              "Annuler",
    notes_send:                      "Envoyer",
    notes_sending:                   "Envoi...",
    notes_mark_read:                 "Marquer comme lu",
    notes_reply_btn:                 "Répondre",
    notes_edit_reply:                "Modifier la réponse",
    notes_print_restock:             "Imprimer le bon de réapprovisionnement",
    notes_load_more:                 "Charger plus",
    notes_role_operator:             "Opérateur",
    notes_role_vendor:               "Livreur",
    notes_role_supervisor:           "Superviseur",
    notes_role_staff:                "Personnel",
    notes_all_loaded:                "Toutes les notes chargées",
    notes_load_more_btn:             "Charger plus de notes",
    notes_loading_more:              "Chargement...",

    // ── Coverage Map (FR) ─────────────────────────────────────────────────────
    cmap_title:                      "Carte de couverture",
    cmap_heat_map:                   "Carte de chaleur",
    cmap_client_pins:                "Épingles clients",
    cmap_coverage:                   "Couverture",
    cmap_show_zones:                 "Afficher les zones",
    cmap_show_vendors:               "Afficher les livreurs",
    cmap_clients_on_map:             "Clients sur la carte",
    cmap_with_zone:                  "Avec zone",
    cmap_no_zone:                    "Sans zone",
    cmap_visited:                    "Visité",
    cmap_coverage_pct:               "Couverture",
    cmap_clients_by_zone:            "Clients par zone",
    cmap_no_zones_defined:           "Aucune zone définie",
    cmap_vendors:                    "Livreurs",
    cmap_search_vendor:              "Rechercher livreur...",
    cmap_visit_coverage:             "Couverture des visites par zone",
    cmap_loading_map:                "Chargement de la carte...",
    cmap_loading_data:               "Chargement des données...",
    cmap_retry:                      "Réessayer",
    cmap_total:                      "Total",
    cmap_remaining:                  "Restant",
    cmap_progress:                   "Progression",
    cmap_close:                      "Fermer",
    cmap_last_visit:                 "Dernière visite :",
    cmap_never_visited:              "Jamais visité",
    cmap_no_data:                    "Pas de données",
    cmap_live:                       "En direct",
    cmap_online:                     "En ligne",
    cmap_idle:                       "Inactif",
    cmap_offline:                    "Hors ligne",

    // ── Supervisor Dashboard (FR) ─────────────────────────────────────────────
    sup_dash_my_vendors:             "Mes livreurs",
    sup_dash_my_clients:             "Mes clients",
    sup_dash_clients_today:          "Clients visités aujourd'hui",
    sup_dash_zone_alerts:            "Alertes de zone",
    sup_dash_assigned_zones:         "Mes zones assignées",
    sup_dash_recent_activity:        "Activité récente",
    sup_dash_no_events:              "Aucun événement dans vos zones.",
    sup_dash_live_map:               "Carte en direct",
    sup_dash_online:                 "en ligne",
    sup_dash_show_clients:           "Afficher les clients",
    sup_dash_satellite:              "Satellite",
    sup_dash_map:                    "Carte",
    sup_dash_send_note:              "Envoyer une note",
    sup_dash_vendor_page:            "Livreurs",
    sup_dash_client_page:            "Clients",
    sup_dash_search_clients:         "Rechercher clients...",
    sup_dash_no_clients:             "Aucun client dans vos zones.",
    sup_dash_section:                "Section",
    sup_dash_last_visit:             "Dernière visite",
    sup_dash_never:                  "Jamais",
    sup_dash_status:                 "Statut",
    sup_dash_search_vendors:         "Rechercher livreurs...",
    sup_dash_no_vendors:             "Aucun livreur dans vos zones.",
    sup_dash_last_seen:              "Vu récemment",
    sup_dash_events:                 "Événements",
    sup_dash_search_events:          "Rechercher événements...",
    sup_dash_no_events_found:        "Aucun événement trouvé.",
    sup_dash_event_vendor:           "Livreur",
    sup_dash_event_client:           "Client",
    sup_dash_event_type:             "Type",
    sup_dash_event_time:             "Heure",
    sup_dash_profile:                "Mon profil",
    sup_dash_dark_mode:              "Mode sombre",
    sup_dash_change_pw:              "Changer le mot de passe",
    sup_dash_current_pw:             "Mot de passe actuel",
    sup_dash_new_pw:                 "Nouveau mot de passe",
    sup_dash_confirm_pw:             "Confirmer le nouveau mot de passe",
    sup_dash_pw_saved:               "Mot de passe modifié avec succès.",
    sup_dash_pw_mismatch:            "Les mots de passe ne correspondent pas.",
    sup_dash_pw_short:               "Le mot de passe doit contenir au moins 6 caractères.",
    sup_dash_pw_wrong:               "Le mot de passe actuel est incorrect.",
    sup_dash_saving_pw:              "Enregistrement...",
    sup_dash_save_pw:                "Enregistrer le mot de passe",
    sup_dash_note_message:           "Message",
    sup_dash_note_priority:          "Priorité",
    sup_dash_note_normal:            "Normal",
    sup_dash_note_urgent:            "Urgent",
    sup_dash_note_send:              "Envoyer la note",
    sup_dash_note_sending:           "Envoi...",
    sup_dash_note_sent:              "Note envoyée à l'administrateur.",
    sup_dash_note_error:             "Veuillez entrer un message.",
    sup_dash_plate:                  "Plaque :",
    sup_dash_speed:                  "km/h",
    sup_dash_loading_too_long:       "Chargement trop long. Actualisez la page.",

    // ── Operator Dashboard (FR) ───────────────────────────────────────────────
    op_dash_map:                     "Carte",
    op_dash_add_client:              "Ajouter un client",
    op_dash_edit_client:             "Modifier le client",
    op_dash_first_name:              "Prénom",
    op_dash_last_name:               "Nom",
    op_dash_phone:                   "Téléphone",
    op_dash_address:                 "Adresse",
    op_dash_client_type:             "Type de client",
    op_dash_notes_label:             "Notes",
    op_dash_save:                    "Enregistrer",
    op_dash_saving:                  "Enregistrement...",
    op_dash_cancel:                  "Annuler",
    op_dash_use_my_location:         "Ma position",
    op_dash_locating:                "Localisation...",
    op_dash_pin_map:                 "Touchez la carte pour placer l'épingle",
    op_dash_search_clients:          "Rechercher clients...",
    op_dash_no_clients:              "Aucun client. Ajoutez votre premier client !",
    op_dash_total_clients:           "Total clients",
    op_dash_visited_today:           "Visités aujourd'hui",
    op_dash_pending:                 "En attente",
    op_dash_dark_mode:               "Mode sombre",
    op_dash_change_pw:               "Changer le mot de passe",
    op_dash_current_pw:              "Mot de passe actuel",
    op_dash_new_pw:                  "Nouveau mot de passe",
    op_dash_confirm_pw:              "Confirmer le mot de passe",
    op_dash_pw_saved:                "Mot de passe modifié avec succès.",
    op_dash_pw_mismatch:             "Les mots de passe ne correspondent pas.",
    op_dash_pw_short:                "Le mot de passe doit contenir au moins 6 caractères.",
    op_dash_pw_wrong:                "Le mot de passe actuel est incorrect.",
    op_dash_saving_pw:               "Enregistrement...",
    op_dash_save_pw:                 "Enregistrer le mot de passe",
    op_dash_send_note:               "Envoyer une note",
    op_dash_note_message:            "Message",
    op_dash_note_priority:           "Priorité",
    op_dash_note_normal:             "Normal",
    op_dash_note_urgent:             "Urgent",
    op_dash_note_send:               "Envoyer",
    op_dash_note_sending:            "Envoi...",
    op_dash_note_sent:               "Note envoyée à l'administrateur.",
    op_dash_note_error:              "Veuillez entrer un message.",
    op_dash_navigate:                "Naviguer",
    op_dash_edit:                    "Modifier",
    op_dash_delete:                  "Supprimer",
    op_dash_delete_confirm:          "Êtes-vous sûr de vouloir supprimer ce client ?",
    op_dash_deleting:                "Suppression...",
    op_dash_gps_error:               "Impossible d'obtenir votre position.",
    op_dash_stats_title:             "Statistiques",
    op_dash_stats_subtitle:          "Aperçu de vos performances",
    op_dash_today:                   "Aujourd'hui",
    op_dash_this_week:               "Cette semaine",
    op_dash_this_month:              "Ce mois",

    // ── Vendor Dashboard (FR) ─────────────────────────────────────────────────
    vendor_badge:                    "Livreur",
    vendor_offline_banner:           "Vous êtes hors ligne — les pointages et notes seront synchronisés à la reconnexion.",
    vendor_pending_sync:             "en attente de synchronisation.",
    vendor_sync_now:                 "Synchroniser",
    vendor_syncing:                  "Synchronisation...",
    vendor_route:                    "Itinéraire",
    vendor_map:                      "Carte",
    vendor_stats:                    "Stats",
    vendor_stock:                    "Stock",
    vendor_profile:                  "Profil",
    vendor_note_enter_msg:           "Veuillez entrer un message.",
    vendor_note_saved_offline:       "Note sauvegardée hors ligne — sera synchronisée à la reconnexion.",
    vendor_note_sent:                "Note envoyée.",
    vendor_send_note_title:          "Envoyer une note à l'admin",
    vendor_general_note:             "Note générale",
    vendor_note_message:             "Message",
    vendor_note_priority:            "Priorité",
    vendor_note_normal:              "Normal",
    vendor_note_urgent:              "Urgent",
    vendor_note_cancel:              "Annuler",
    vendor_note_sending:             "Envoi...",
    vendor_note_send:                "Envoyer",
    vendor_route_total:              "Total",
    vendor_route_visited:            "Visité",
    vendor_route_remaining:          "Restant",
    vendor_route_getting_location:   "Localisation en cours...",
    vendor_route_showing_clients:    "Affichage des clients",
    vendor_route_away:               "à proximité",
    vendor_route_found:              "trouvé(s)",
    vendor_route_refresh:            "Actualiser",
    vendor_route_locating:           "Localisation...",
    vendor_route_no_zone:            "Aucune zone assignée. Contactez votre administrateur.",
    vendor_route_no_nearby:          "Aucun client à proximité — approchez-vous de votre itinéraire",
    vendor_route_no_clients:         "Aucun client à afficher",
    vendor_route_navigate:           "Naviguer",
    vendor_route_check_in:           "Pointer",
    vendor_route_auto_only:          "Pointage automatique uniquement",
    vendor_route_note:               "Note",
    vendor_route_sell:               "Vendre",
    vendor_route_receipt:            "Voir reçu",
    vendor_route_loading_receipt:    "Chargement...",
    vendor_route_no_receipt:         "Aucun reçu trouvé pour ce client.",
    vendor_route_pending:            "En attente",
    vendor_route_visited_label:      "Visité",
    vendor_route_from_prev:          "de l'arrêt précédent",
    vendor_route_no_zone_label:      "Sans zone",
    vendor_route_all:                "Tous",
    vendor_route_search_ph:          "Rechercher des clients...",
    vendor_route_optimized:          "Itinéraire optimisé",
    vendor_route_optimization:       "Optimisation d'itinéraire",
    vendor_route_optimizing:         "Optimisation...",
    vendor_route_reset_order:        "Réinitialiser",
    vendor_route_optimize:           "Optimiser l'itinéraire",
    vendor_route_saves:              "économise",
    vendor_route_km:                 "km",
    vendor_route_min:                "min",
    vendor_route_checkin_note_title: "Note requise",
    vendor_route_checkin_note_hint:  "Ajoutez une note de visite avant de pointer chez",
    vendor_route_checkin_note_ph:    "Que s'est-il passé lors de cette visite ?",
    vendor_route_checkin_note_error: "Veuillez ajouter une note avant de pointer.",
    vendor_route_confirm_checkin:    "Confirmer le pointage",
    vendor_map_view:                 "Vue carte",
    vendor_map_satellite:            "Satellite",
    vendor_stats_title:              "Mes statistiques",
    vendor_stats_today:              "Aujourd'hui",
    vendor_stats_week:               "Cette semaine",
    vendor_stats_total:              "Total visites",
    vendor_stats_avg:                "Moy. / Jour",
    vendor_stats_breakdown:          "Répartition des visites",
    vendor_stats_manual:             "Manuel :",
    vendor_stats_auto:               "GPS auto :",
    vendor_stats_last7:              "7 derniers jours",
    vendor_stats_last4w:             "4 dernières semaines",
    vendor_stats_recent:             "Pointages récents",
    vendor_stats_no_checkins:        "Aucun pointage encore",
    vendor_stats_away:               "à proximité",
    vendor_stock_products:           "Produits",
    vendor_stock_units:              "unités au total",
    vendor_stock_sales_today:        "Ventes aujourd'hui",
    vendor_stock_this_week:          "cette semaine",
    vendor_stock_current:            "Stock actuel",
    vendor_stock_request_restock:    "Demander réapprovisionnement",
    vendor_stock_no_items:           "Aucun article de stock assigné",
    vendor_stock_low:                "Bas",
    vendor_stock_recent_sales:       "Ventes récentes",
    vendor_stock_today_revenue:      "Aujourd'hui :",
    vendor_stock_no_sales:           "Aucune vente encore",
    vendor_stock_pending_sync:       "Sync en attente",
    vendor_stock_print:              "Imprimer",
    vendor_profile_appearance:       "Apparence",
    vendor_profile_dark_mode:        "Mode sombre",
    vendor_profile_dark_hint:        "Basculer vers le thème sombre",
    vendor_profile_send_note:        "Envoyer une note générale",
    vendor_profile_sync_status:      "État de synchronisation",
    vendor_profile_online:           "En ligne",
    vendor_profile_offline_msg:      "Hors ligne — données en cache",
    vendor_profile_last_sync:        "Dernière sync :",
    vendor_profile_never:            "Jamais",
    vendor_profile_pending:          "en attente",
    vendor_profile_change_pw:        "Changer le mot de passe",
    vendor_profile_current_pw:       "Mot de passe actuel",
    vendor_profile_new_pw:           "Nouveau mot de passe",
    vendor_profile_confirm_pw:       "Confirmer le nouveau mot de passe",
    vendor_profile_pw_mismatch:      "Les nouveaux mots de passe ne correspondent pas.",
    vendor_profile_pw_short:         "Le mot de passe doit contenir au moins 6 caractères.",
    vendor_profile_pw_wrong:         "Mot de passe actuel incorrect.",
    vendor_profile_pw_saved:         "Mot de passe mis à jour avec succès.",
    vendor_profile_updating:         "Mise à jour...",
    vendor_profile_update_pw:        "Mettre à jour le mot de passe",
    vendor_note_describe_ph:         "Décrivez le problème ou l'observation...",
    sup_dash_appearance:             "Apparence",
    sup_dash_dark_mode:              "Mode sombre",
    sup_dash_dark_hint:              "Basculer vers le thème sombre",
    sup_dash_send_note_title:        "Envoyer une note à l'admin",
    sup_dash_note_describe_ph:       "Décrivez le problème ou l'observation...",
    sup_dash_cancel:                 "Annuler",
    sup_dash_online_vendor:          "Livreur en ligne",
    sup_dash_offline_vendor:         "Livreur hors ligne",
    sup_dash_client_label:           "Client",
    sup_dash_zones_legend:           "Zones ombrées = vos zones",
    sup_dash_total_clients:          "Total clients",
    sup_dash_read_only:              "Lecture seule",
    sup_dash_all_zones:              "Toutes les zones",
    sup_dash_no_clients_found:       "Aucun client trouvé.",
    sup_dash_no_vendors_yet:         "Aucun livreur assigné.",
    sup_dash_events_history:         "Événements & Historique",
    sup_dash_events_zones:           "événements totaux dans vos zones",
    sup_dash_all:                    "Tous",
    sup_dash_visits:                 "Visites",
    sup_dash_zone_enter:             "Entrée zone",
    sup_dash_zone_exit:              "Sortie zone",
    sup_dash_session_start:          "Début session",
    sup_dash_session_end:            "Fin session",
    sup_dash_all_vendors:            "Tous les livreurs",
    sup_dash_no_events_filter:       "Aucun événement correspondant.",
    sup_dash_clients_in_zones:       "clients dans vos zones",
    sup_dash_vendors_assigned:       "livreur(s) qui vous sont assignés",

    // ── SuperAdmin Dashboard (FR) ─────────────────────────────────────────────
    sa_companies_count:              "entreprises",
    sa_active_companies:             "Actives",
    sa_total_vendors:                "Total livreurs",
    sa_total_clients:                "Total clients",
    sa_expired_subs:                 "Abonnements expirés",
    sa_search_companies:             "Rechercher des entreprises...",
    sa_no_companies:                 "Aucune entreprise trouvée.",
    sa_last_activity:                "Dernière activité",
    sa_vendors:                      "livreurs",
    sa_clients:                      "clients",
    sa_zones:                        "zones",
    sa_events:                       "événements",
    sa_status_paid:                  "payé",
    sa_status_trial:                 "essai",
    sa_status_unpaid:                "impayé",
    sa_status_expired:               "expiré",
    sa_view_details:                 "Voir les détails",
    sa_disable:                      "Désactiver",
    sa_enable:                       "Activer",
    sa_delete:                       "Supprimer",
    sa_confirm_disable:              "Désactiver l'entreprise",
    sa_confirm_enable:               "Activer l'entreprise",
    sa_confirm_delete:               "Supprimer l'entreprise",
    sa_disable_msg:                  "Cela empêchera tous les utilisateurs de cette entreprise de se connecter.",
    sa_enable_msg:                   "Cela rétablira l'accès pour tous les utilisateurs de cette entreprise.",
    sa_delete_msg:                   "Tous les utilisateurs, clients, livreurs, zones et événements seront définitivement supprimés. Cette action est irréversible.",
    sa_deleting:                     "Suppression...",
  },

  // ══════════════════════════════════════════════════════════════════════════
  // ARABIC
  // ══════════════════════════════════════════════════════════════════════════
  ar: {
    app_name:        "بينبوينت",
    logout:          "تسجيل الخروج",
    save_changes:    "حفظ التغييرات",
    saving:          "جارٍ الحفظ...",
    cancel:          "إلغاء",
    close:           "إغلاق",
    edit:            "تعديل",
    delete:          "حذف",
    create:          "إنشاء",
    search:          "بحث",
    loading:         "جارٍ التحميل...",
    yes_delete:      "نعم، احذف",
    deleting:        "جارٍ الحذف...",
    uploading:       "جارٍ الرفع...",
    add:             "إضافة",
    select:          "تحديد",
    select_all:      "تحديد الكل",
    confirm:         "تأكيد",
    back:            "رجوع",
    actions:         "إجراءات",
    no_data:         "لا توجد بيانات",
    read_only:       "للقراءة فقط",
    coming_soon:     "قريباً",

    role_admin:      "مدير",
    role_supervisor: "مشرف",
    role_operator:   "مشغّل",
    role_vendor:     "موزّع",

    active:          "نشط",
    inactive:        "غير نشط",
    disabled:        "معطّل",
    online:          "متصل",
    offline:         "غير متصل",
    enabled:         "مفعّل",

    nav_overview:       "نظرة عامة",
    nav_live_map:       "الخريطة المباشرة",
    nav_users:          "المستخدمون",
    nav_supervisors:    "المشرفون",
    nav_operators:      "المشغّلون",
    nav_vendors:        "الموزّعون",
    nav_sections:       "الأقسام",
    nav_clients:        "العملاء",
    nav_reports:        "التقارير",
    nav_statistics:     "الإحصائيات",
    nav_notifications:  "الإشعارات",
    nav_notes:          "صندوق الملاحظات",
    nav_stock:          "إدارة المخزون",
    nav_competitor_map: "خريطة التغطية",
    nav_api_access:     "واجهة برمجة التطبيقات",
    nav_settings:       "الإعدادات",
    nav_events:         "الأحداث",
    nav_profile:        "الملف الشخصي",
    nav_companies:      "الشركات",

    overview_title:         "نظرة عامة",
    overview_active_vendors:"الموزّعون النشطون",
    overview_total_clients: "إجمالي العملاء",
    overview_events_today:  "أحداث اليوم",
    overview_alerts_today:  "تنبيهات اليوم",
    overview_recent_activity:"النشاط الأخير",
    overview_no_events:     "لا توجد أحداث في مناطقك.",
    overview_my_zones:      "مناطقي المخصصة",
    overview_my_vendors:    "موزّعيّ",
    overview_my_clients:    "عملائي",
    overview_total_visits:  "إجمالي الزيارات",
    overview_zone_alerts:   "تنبيهات المنطقة",
    overview_loading:        "جارٍ تحميل النظرة العامة...",
    overview_total_users:    "إجمالي المستخدمين",
    overview_zones:          "المناطق",
    overview_active_today:   "نشط اليوم",
    overview_registered_vendors: "موزّع مسجّل",
    overview_in_database:    "في قاعدة البيانات",
    overview_geofences:      "حدود جغرافية محددة",
    overview_vendors_on_field:"موزّع في الميدان",
    overview_clients_visited_today: "عملاء تمت زيارتهم اليوم",
    overview_visits_this_week: "زيارات هذا الأسبوع",
    overview_last_10_events: "آخر 10 أحداث",
    overview_no_activity:    "لا يوجد نشاط بعد",
    overview_unknown_vendor: "موزّع غير معروف",
    overview_visited:        "زار",
    overview_checked_in_at:  "سجّل حضوراً في",
    overview_triggered_alert:"أطلق تنبيهاً في",
    overview_started_session:"بدأ جلسته",
    overview_ended_session:  "أنهى جلسته",
    overview_entered_zone:   "دخل",
    overview_exited_zone:    "غادر",
    overview_unauth_zone:    "دخل منطقة غير مصرح بها",

    map_title:          "الخريطة المباشرة",
    map_show_clients:   "إظهار العملاء",
    map_satellite:      "الأقمار الصناعية",
    map_roadmap:        "الخريطة",
    map_legend_online:  "موزّع متصل",
    map_legend_offline: "موزّع غير متصل",
    map_legend_client:  "عميل",
    map_legend_zones:   "المناطق المظللة = مناطقك",
    map_vendor_status:  "حالة الموزّعين",
    map_loading:        "جارٍ تحميل الخريطة...",
    map_last_seen:      "آخر ظهور",
    map_speed:          "السرعة",
    map_plate:          "لوحة السيارة",

    users_title:        "المستخدمون",
    users_total:        "مستخدم إجمالاً",
    users_add:          "+ إضافة مستخدم",
    users_new:          "مستخدم جديد",
    users_create:       "إنشاء المستخدم",
    users_creating:     "جارٍ الإنشاء...",
    users_no_users:     "لا يوجد مستخدمون بعد",
    users_no_users_sub: "أنشئ أول مستخدم للبدء",
    users_firebase_hint:"سيتم إنشاء حساب تسجيل دخول Firebase تلقائياً.",
    users_delete_title: "حذف المستخدم",
    users_delete_msg:   "سيُحذف حساب تسجيل الدخول أيضاً. لا يمكن التراجع عن هذا.",
    users_bulk_delete:  "حذف عدة مستخدمين",
    users_bulk_msg:     "سيُحذف حساباتهم أيضاً. لا يمكن التراجع عن هذا.",
    users_admins_hint:  "(لا يمكن تحديد المديرين)",

    sup_title:          "المشرفون",
    sup_add:            "+ إضافة مشرف",
    sup_new:            "مشرف جديد",
    sup_create:         "إنشاء المشرف",
    sup_access_hint:    "يملك المشرفون لوحة تحكم للقراءة فقط مقيدة بمناطقهم المخصصة.",
    sup_no_zones:       "لا توجد مناطق مخصصة",
    sup_no_vendors:     "لا يوجد موزّعون مخصصون",
    sup_assigned_zones: "المناطق المخصصة",
    sup_zones_hint:     "يرى المشرف العملاء والأحداث في هذه المناطق فقط",
    sup_assigned_vendors:"الموزّعون المخصصون",
    sup_vendors_hint:   "يراقب المشرف هؤلاء الموزّعين على الخريطة",
    sup_search_vendors: "البحث بالاسم أو اللوحة أو البريد الإلكتروني...",
    sup_no_zones_defined:"لا توجد مناطق محددة. أنشئ مناطق في الأقسام أولاً.",
    sup_no_vendors_exist:"لا يوجد موزّعون. أنشئ موزّعين أولاً.",
    sup_delete_title:   "حذف المشرف",
    sup_delete_msg:     "سيُحذف حسابه أيضاً. لا يمكن التراجع عن هذا.",
    sup_bulk_delete:    "حذف عدة مشرفين",
    sup_notes:          "ملاحظات",
    sup_notes_ph:       "ملاحظات اختيارية عن هذا المشرف...",
    sup_my_zones:       "مناطقي",

    vendors_title:      "الموزّعون",
    vendors_add:        "+ إضافة موزّع",
    vendors_new:        "موزّع جديد",
    vendors_no_vendors: "لا يوجد موزّعون بعد",
    vendors_delete_title:"حذف الموزّع",
    vendors_delete_msg: "سيُحذف هذا الموزّع نهائياً.",
    vendors_bulk_delete:"حذف عدة موزّعين",
    vendors_plate:      "لوحة السيارة",
    vendors_vehicle:    "نوع المركبة",

    clients_title:      "العملاء",
    clients_add:        "+ إضافة عميل",
    clients_new:        "عميل جديد",
    clients_no_clients: "لا يوجد عملاء بعد",
    clients_delete_title:"حذف العميل",
    clients_delete_msg: "سيُحذف هذا العميل نهائياً.",
    clients_bulk_delete:"حذف عدة عملاء",
    clients_zone:       "المنطقة",
    clients_all_zones:  "جميع المناطق",
    clients_in_zones:   "عملاء في مناطقك",
    clients_import:     "استيراد",
    clients_export:     "تصدير",

    sections_title:     "الأقسام / المناطق",
    sections_add:       "+ إضافة قسم",
    sections_new:       "قسم جديد",
    sections_no_sections:"لا توجد أقسام بعد",
    sections_delete_msg:"سيُحذف هذا القسم نهائياً.",
    sections_draw_hint: "ارسم مضلعاً على الخريطة لتحديد هذه المنطقة",
    sections_zone_name: "اسم المنطقة",
    sections_zone_color:"لون المنطقة",

    events_title:       "الأحداث والسجل",
    events_total:       "حدث إجمالاً في مناطقك",
    events_all:         "الكل",
    events_visits:      "الزيارات",
    events_zone_enter:  "دخول المنطقة",
    events_zone_exit:   "خروج المنطقة",
    events_session_start:"بدء الجلسة",
    events_session_end: "نهاية الجلسة",
    events_no_events:   "لا توجد أحداث تطابق الفلاتر.",
    events_all_vendors: "جميع الموزّعين",
    events_search_ph:   "البحث باسم الموزّع أو العميل...",

    // ── Clients Manager extra keys (AR) ───────────────────────────────────────
    clients_loading:         "جارٍ تحميل العملاء...",
    clients_select:          "تحديد",
    clients_cancel:          "✕ إلغاء",
    clients_select_for_bulk: "حدد العملاء للإجراءات الجماعية",
    clients_selected_count:  "عميل محدد",
    clients_delete_selected: "حذف المحدد",
    clients_search_ph:       "بحث بالاسم أو الهاتف أو العنوان...",
    clients_no_results:      "لا توجد نتائج",
    clients_try_search:      "جرّب مصطلح بحث آخر",
    clients_add_manually:    "أضف عميلاً يدوياً",
    clients_showing:         "عرض",
    clients_of:              "من",
    clients_previous:        "السابق",
    clients_next:            "التالي",
    clients_page:            "صفحة",
    clients_zone_auto:       "المنطقة",
    clients_auto_from_gps:   "(تلقائي من GPS)",
    clients_auto_detect:     "كشف تلقائي من GPS",
    clients_type_category:   "النوع / الفئة",
    clients_latitude:        "خط العرض",
    clients_longitude:       "خط الطول",
    clients_notes_ph:        "ملاحظات للموزّعين...",
    clients_status:          "الحالة:",
    clients_zone_hint:       "🎯 يتم كشف المنطقة تلقائياً من GPS إذا كان داخل منطقة محددة.",
    clients_created_by:      "أنشأه",
    clients_cannot_undo_full: "لا يمكن التراجع عن هذا الإجراء. سيُحذف العميل نهائياً.",

    // ── Vendors Manager extra keys (AR) ───────────────────────────────────────
    vendors_loading:         "جارٍ تحميل الموزّعين...",
    vendors_total:           "إجمالي",
    vendors_active:          "نشط",
    vendors_online:          "متصل",
    vendors_select:          "تحديد",
    vendors_cancel:          "✕ إلغاء",
    vendors_live_map:        "الخريطة المباشرة",
    vendors_select_for_bulk: "حدد الموزّعين للإجراءات الجماعية",
    vendors_selected_count:  "موزّع محدد",
    vendors_auto_account:    "إعداد الحساب التلقائي",
    vendors_auto_account_msg:"عند إنشاء موزّع، يُنشأ حساب تسجيل دخول تلقائياً بالبريد وكلمة المرور.",
    vendors_locations:       "مواقع الموزّعين",
    vendors_with_location:   "موزّع بموقع معروف",
    vendors_online_10min:    "متصل (آخر 10 دقائق)",
    vendors_search_ph:       "بحث بالاسم أو الهاتف أو IMEI أو اللوحة...",
    vendors_imei:            "IMEI",
    vendors_imei_hint:       "معرّف جهاز تتبع GPS",
    vendors_assigned_zones:  "المناطق المخصصة",
    vendors_no_zones:        "لا توجد مناطق محددة بعد.",
    vendors_days_off:        "أيام الإجازة",
    vendors_days_off_hint:   "الأيام المحددة ستُستثنى من تنبيهات عدم الزيارة",
    vendors_status:          "الحالة:",
    vendors_cannot_undo_full:"سيُحذف حساباتهم أيضاً. لا يمكن التراجع عن هذا.",
    vendors_create_vendor:   "إنشاء موزّع",
    vendors_save_changes:    "حفظ التغييرات",

    // ── Users Manager extra keys (AR) ─────────────────────────────────────────
    users_loading:           "جارٍ تحميل المستخدمين...",
    users_select:            "تحديد",
    users_cancel:            "✕ إلغاء",
    users_select_for_bulk:   "حدد المستخدمين للإجراءات الجماعية",
    users_selected_count:    "مستخدم محدد",
    users_filter_all:        "الكل",
    users_filter_admins:     "المديرون",
    users_filter_supervisors:"المشرفون",
    users_filter_operators:  "المشغّلون",
    users_filter_vendors:    "الموزّعون",
    users_active:            "نشط",
    users_disabled:          "معطّل",
    users_admin_badge:       "👑 مدير",
    users_role_supervisor_desc: "المشرف — يمكنه عرض جميع الموزّعين والعملاء في المناطق المخصصة",
    users_role_operator_desc:   "المشغّل — يمكنه إدارة العملاء وعرض حالة التوصيل",
    users_role_vendor_desc:     "الموزّع — مستخدم تطبيق الهاتف الذي يقوم بعمليات التوصيل",
    users_delete_selected:   "حذف المحدد",

    // ── Sections Manager extra keys (AR) ──────────────────────────────────────
    sections_loading:        "جارٍ التحميل...",
    sections_map_loading:    "جارٍ تحميل الخريطة...",
    sections_geofences:      "الأقسام والحدود الجغرافية",
    sections_satellite:      "الأقمار الصناعية",
    sections_map:            "الخريطة",
    sections_importing:      "جارٍ الاستيراد...",
    sections_import:         "استيراد",
    sections_export:         "تصدير",
    sections_draw_new_zone:  "+ رسم منطقة جديدة",
    sections_cancel_drawing: "إلغاء الرسم",
    sections_draw_hint_msg:  "انقر لإضافة نقاط · انقر مرتين لإكمال المنطقة",
    sections_edit_zone:      "تعديل المنطقة",
    sections_new_zone:       "منطقة جديدة",
    sections_zone_name_label:"اسم المنطقة *",
    sections_color_label:    "اللون",
    sections_custom_color:   "مخصص",
    sections_description:    "الوصف",
    sections_optional:       "اختياري",
    sections_save_changes:   "حفظ التغييرات",
    sections_create_zone:    "إنشاء المنطقة",
    sections_zones_label:    "المناطق",
    sections_search_zones:   "بحث في المناطق...",
    sections_no_zones:       "لا توجد مناطق بعد",
    sections_draw_first:     "ارسم أول منطقة على الخريطة",
    sections_draw_first_btn: "رسم أول منطقة",
    sections_pts:            "نقاط",
    sections_zones_total:    "مناطق إجمالاً",
    sections_delete_zone:    "حذف المنطقة",
    sections_delete_confirm: "هل أنت متأكد من حذف هذه المنطقة؟ لا يمكن التراجع عن هذا.",

    // ── Supervisors Manager extra keys (AR) ───────────────────────────────────
    sup_loading:             "جارٍ تحميل المشرفين...",
    sup_select:              "تحديد",
    sup_cancel:              "✕ إلغاء",
    sup_supervisor_access:   "صلاحية المشرف",
    sup_select_for_bulk:     "حدد المشرفين للإجراءات الجماعية",
    sup_selected_count:      "مشرف محدد",
    sup_active:              "نشط",
    sup_no_supervisors:      "لا يوجد مشرفون بعد",
    sup_create_assign_hint:  "أنشئ مشرفاً وخصّص له مناطق وموزّعين للمراقبة",
    sup_zones_label:         "المناطق:",
    sup_vendors_label:       "الموزّعون:",
    sup_supervisor_badge:    "🔭 مشرف",
    sup_basic_info:          "المعلومات الأساسية",
    sup_login_auto:          "سيُنشأ حساب تسجيل دخول تلقائياً لهذا المشرف.",
    sup_new_supervisor:      "مشرف جديد",
    sup_assigned_zones_label:"المناطق المخصصة",
    sup_assigned_vendors_label:"الموزّعون المخصصون",
    sup_status_label:        "الحالة:",

    // ── Operators Manager extra keys (AR) ─────────────────────────────────────
    op_select_for_bulk:      "حدد المشغّلين للإجراءات الجماعية",
    op_selected_count:       "مشغّل محدد",
    op_no_match:             "لا يوجد مشغّلون يطابقون بحثك.",
    op_active:               "نشط",

    // ── Notifications Page (AR) ───────────────────────────────────────────────
    notif_loading:           "جارٍ تحميل الإشعارات...",
    notif_filter_all:        "الكل",
    notif_filter_alerts:     "التنبيهات",
    notif_filter_visits:     "الزيارات",
    notif_filter_sessions:   "الجلسات",
    notif_clear_all:         "مسح الكل",
    notif_confirm_clear:     "مسح جميع الإشعارات",
    notif_confirm_clear_msg: "سيُحذف جميع الإشعارات نهائياً. لا يمكن التراجع عن هذا.",
    notif_clearing:          "جارٍ المسح...",
    notif_cleared:           "✅ تم مسح جميع الإشعارات.",
    notif_empty:             "لا توجد إشعارات",
    notif_speed:             "تجاوز السرعة",
    notif_long_stop:         "توقف طويل",
    notif_no_visits:         "لا زيارات",
    notif_outside_hours:     "خارج ساعات العمل",
    notif_wrong_zone:        "منطقة خاطئة",
    notif_checkin:           "تسجيل وصول",
    notif_visit:             "زيارة",

    // ── Reports Page (AR) ────────────────────────────────────────────────────
    reports_loading:         "جارٍ إنشاء التقرير...",
    reports_select_type:     "اختر نوع التقرير",
    reports_select_hint:     "اختر نوع تقرير من اليسار للبدء",
    reports_date_from:       "من تاريخ",
    reports_date_to:         "إلى تاريخ",
    reports_time_from:       "من وقت",
    reports_time_to:         "إلى وقت",
    reports_all_vendors:     "جميع الموزّعين",
    reports_all_zones:       "جميع المناطق",
    reports_generate_btn:    "إنشاء التقرير",
    reports_download_pdf:    "تحميل PDF",
    reports_no_data:         "لا توجد بيانات لهذه الفترة",
    reports_client_visits:   "زيارات العملاء",
    reports_zone_coverage:   "تغطية المنطقة",
    reports_vendor_activity: "نشاط الموزّعين",
    reports_out_of_zone:     "سجل خارج المنطقة",
    reports_unauth_zone:     "منطقة غير مصرح بها",
    reports_zone_geofence:   "منطقة / حدود جغرافية",
    reports_daily_summary:   "ملخص يومي",
    reports_client_creation: "إنشاء العملاء",
    reports_custom:          "تقرير مخصص",

    // ── Statistics Page (AR) ─────────────────────────────────────────────────
    stats_analytics:         "الإحصائيات والتحليلات",
    stats_track_hint:        "تتبع الزيارات والتنبيهات وأداء الموزّعين بمرور الوقت",

    // ── Stock Manager (AR) ───────────────────────────────────────────────────
    stock_title:             "إدارة المخزون",
    stock_desc:              "إدارة كتالوج المنتجات ومخزون الموزّعين والمبيعات والحركات",
    stock_tab_catalog:       "كتالوج المنتجات",
    stock_tab_vendor:        "مخزون الموزّع",
    stock_tab_sales:         "سجل المبيعات",
    stock_tab_movements:     "حركات المخزون",
    stock_tab_requests:      "طلبات إعادة التخزين",

    reports_title:      "التقارير",
    reports_generate:   "إنشاء تقرير",
    reports_download:   "تحميل",

    stats_title:        "الإحصائيات",

    notif_title:        "الإشعارات",
    notif_no_notif:     "لا توجد إشعارات",
    notif_mark_read:    "تحديد الكل كمقروء",

    settings_title:     "إعدادات الشركة",
    settings_subtitle:  "ضبط تفضيلات شركتك",
    settings_general:   "عام",
    settings_tracking:  "التتبع",
    settings_hours:     "ساعات العمل",
    settings_alerts:    "التنبيهات",
    settings_appearance:"المظهر",
    settings_saved:     "✅ تم حفظ الإعدادات!",
    settings_timezone:  "المنطقة الزمنية",
    settings_language:  "اللغة",
    settings_date_format:"تنسيق التاريخ",
    settings_nearby_dist:"مسافة الاقتراب (بالأمتار)",
    settings_nearby_hint:"المسافة للكشف عن وصول الموزّع للعميل",
    settings_gps_interval:"فاصل تحديث GPS (ثانية)",
    settings_gps_hint:  "عدد مرات إرسال التطبيق لتحديثات الموقع",
    settings_max_speed: "تنبيه السرعة القصوى (كم/س)",
    settings_max_speed_hint:"اضبط على 0 لتعطيل تنبيهات السرعة",
    settings_auto_checkin:"تسجيل وصول تلقائي",
    settings_auto_checkin_desc:"تسجيل الزيارة تلقائياً عند وصول الموزّع للعميل",
    settings_manual_checkin:"السماح بتسجيل وصول يدوي",
    settings_manual_checkin_desc:"يستطيع الموزّعون تسجيل الزيارة يدوياً من التطبيق",
    settings_require_notes:"إلزامية الملاحظات عند الزيارة",
    settings_require_notes_desc:"يجب على الموزّعين إضافة ملاحظة عند تسجيل الزيارة",
    settings_notif_sound:"صوت الإشعارات",
    settings_notif_sound_desc:"تشغيل صوت عند وصول تنبيهات جديدة",
    settings_work_start:"وقت البداية",
    settings_work_end:  "وقت النهاية",
    settings_track_outside:"التتبع خارج ساعات العمل",
    settings_track_outside_desc:"الاستمرار في تسجيل مواقع GPS بعد ساعات العمل",
    settings_working_days:"أيام العمل",
    settings_working_days_hint:"حدد الأيام التي يعمل فيها الموزّعون",
    settings_out_of_zone:"تنبيهات خارج المنطقة",
    settings_out_of_zone_desc:"إرسال تنبيه عند مغادرة الموزّع لمنطقته المخصصة",
    settings_cooldown:  "فترة الهدوء بين التنبيهات (دقيقة)",
    settings_cooldown_hint:"الحد الأدنى للوقت بين تنبيهين للموزّع نفسه",
    settings_missed_visit:"تنبيه زيارة مفقودة",
    settings_missed_visit_desc:"إشعار إذا لم تتم زيارة عميل مجدول في نهاية اليوم",
    settings_long_stop: "تنبيه توقف طويل",
    settings_long_stop_desc:"إشعار إذا بقي الموزّع في نفس الموقع طويلاً",
    settings_long_stop_min:"حد التوقف الطويل (دقيقة)",
    settings_long_stop_hint:"تنبيه إذا بقي الموزّع في نفس النقطة أطول من هذا",
    settings_company_name:"اسم الشركة",
    settings_company_ph:"اسم شركتك",
    settings_phone:     "الهاتف",
    settings_email:     "البريد الإلكتروني",
    settings_address:   "العنوان",
    settings_logo:      "شعار الشركة",
    settings_logo_change:"تغيير الشعار",
    settings_logo_upload:"رفع الشعار",
    settings_logo_remove:"إزالة",
    settings_logo_hint: "PNG أو JPG بحجم أقصى 2 ميغابايت",
    settings_color:     "اللون الرئيسي",
    settings_color_hint:"يُستخدم للعلامة التجارية في التقارير والتصدير",

    form_first_name:    "الاسم الأول",
    form_last_name:     "اسم العائلة",
    form_email:         "البريد الإلكتروني",
    form_email_login:   "(تسجيل الدخول)",
    form_phone:         "الهاتف",
    form_password:      "كلمة المرور",
    form_password_keep: "(اتركه فارغاً للاحتفاظ بالحالي)",
    form_password_min:  "6 أحرف على الأقل",
    form_role:          "الدور",
    form_status:        "الحالة",
    form_show:          "إظهار",
    form_hide:          "إخفاء",
    form_required:      "مطلوب",
    form_notes:         "ملاحظات",
    form_name:          "الاسم",
    form_address:       "العنوان",

    delete_cannot_undo: "لا يمكن التراجع عن هذا الإجراء.",
    delete_selected:    "محدد",
    delete_all:         "حذف الكل",

    company_id:         "الشركة",
    super_admin_badge:  "مدير النظام",
    // ── Operator Dashboard ───────────────────────────────────────────────────
    op_dash_my_clients:   "عملائي",
    op_dash_statistics:   "الإحصائيات",
    op_dash_profile:      "الملف الشخصي",

    // ── Operator — Add/Edit Client ───────────────────────────────────────────
    op_client_title:      "إضافة عميل",
    op_client_edit_title: "تعديل العميل",
    op_client_first_name: "الاسم الأول",
    op_client_last_name:  "اسم العائلة",
    op_client_phone:      "الهاتف",
    op_client_address:    "العنوان",
    op_client_notes:      "ملاحظات",
    op_client_notes_ph:   "ملاحظات إضافية...",
    op_client_pin_title:  "تحديد الموقع",
    op_client_pin_hint:   "اضغط على الخريطة أو اسحب الدبوس",
    op_client_use_gps:    "موقعي الحالي",
    op_client_locating:   "جاري التحديد...",
    op_client_gps_error:  "تعذّر الحصول على الموقع",
    op_client_save:       "حفظ العميل",
    op_client_update:     "تحديث العميل",
    op_client_saving:     "جاري الحفظ...",
    op_client_updating:   "جاري التحديث...",
    op_client_saved:      "تم حفظ العميل بنجاح",
    op_client_delete_title: "حذف العميل",
    op_client_delete_msg:   "هل أنت متأكد من حذف هذا العميل؟",

    // ── Operator — My Clients ────────────────────────────────────────────────
    op_my_clients_title:  "عملائي",
    op_my_clients_empty:  "لا يوجد عملاء بعد",
    op_my_clients_search: "بحث...",
    op_my_clients_date:   "أُضيف",

    // ── Operator — Statistics ────────────────────────────────────────────────
    op_stats_title:        "إحصائياتي",
    op_stats_total:        "إجمالي العملاء",
    op_stats_today:        "أُضيفوا اليوم",
    op_stats_week:         "هذا الأسبوع",
    op_stats_deleted:      "محذوفون",
    op_stats_daily_chart:  "آخر 7 أيام",
    op_stats_weekly_chart: "آخر 4 أسابيع",
    op_stats_week_label:   "أسبوع",
    op_stats_count:        "عملاء",

    // ── Operator — Profile ───────────────────────────────────────────────────
    op_profile_title:      "ملفي الشخصي",
    op_profile_change_pw:  "تغيير كلمة المرور",
    op_profile_current_pw: "كلمة المرور الحالية",
    op_profile_new_pw:     "كلمة المرور الجديدة",
    op_profile_confirm_pw: "تأكيد كلمة المرور",
    op_profile_pw_mismatch:"كلمتا المرور غير متطابقتين",
    op_profile_pw_updated: "تم تحديث كلمة المرور",
    op_profile_updating:   "جاري التحديث...",

    // ── Operators Manager ────────────────────────────────────────────────────
    op_title:           "المشغّلون",
    op_add:             "+ إضافة مشغّل",
    op_new:             "مشغّل جديد",
    op_create:          "إنشاء مشغّل",
    op_edit:            "تعديل المشغّل",
    op_access_hint:     "يمكن للمشغّلين إضافة عملاء من تطبيق الهاتف",
    op_clients_count:   "عملاء",
    op_bulk_delete:     "حذف المحدد",
    op_delete_title:    "حذف المشغّل",
    op_delete_msg:      "هل أنت متأكد من حذف هذا المشغّل؟",
    op_no_operators:    "لا يوجد مشغّلون بعد",
    op_search_ph:       "بحث بالاسم أو البريد...",
    op_notes:           "ملاحظات",
    op_notes_ph:        "ملاحظات داخلية عن هذا المشغّل...",
    op_new_password:    "كلمة المرور الجديدة",
    op_new_password_ph: "اتركه فارغاً للإبقاء على كلمة المرور الحالية",

    // ── Login page ───────────────────────────────────────────────────────────
    login_email:        "البريد الإلكتروني",
    login_password:     "كلمة المرور",
    login_submit:       "تسجيل الدخول",
    login_signing_in:           "جارٍ تسجيل الدخول...",
    login_welcome:              "تسجيل الدخول إلى",
    login_subtitle:             "أدخل بياناتك للوصول إلى لوحة التحكم.",
    login_eyebrow:              "منصة إدارة العمليات الميدانية",
    login_tagline:              "عمليات ميدانية احترافية.",
    login_tagline_sub:          "رؤية فورية على موظفيك وعملائك ومناطق التوصيل — في منصة واحدة.",
    login_feature_tracking:     "تتبع الموظفين مباشرةً",
    login_feature_tracking_sub: "اعرف موقع كل موظف ميداني في الوقت الحقيقي.",
    login_feature_visits:       "إدارة زيارات العملاء",
    login_feature_visits_sub:   "تتبع تسجيل الحضور ومعدلات التغطية وتاريخ الزيارات.",
    login_feature_coverage:     "تحليلات التغطية الجغرافية",
    login_feature_coverage_sub: "راقب أداء التوصيل عبر جميع المناطق المحددة.",
    login_suspended_msg:        "تم تعليق حساب شركتك بسبب مشكلة في الدفع أو انتهاء صلاحية الاشتراك.",
    login_suspended_contact:    "تحتاج مساعدة؟ تواصل مع الدعم:",
    login_suspended_back:       "العودة لتسجيل الدخول",
    login_error_disabled:       "تم تعطيل حسابك. تواصل مع المسؤول.",
    login_error_generic:        "البريد الإلكتروني أو كلمة المرور غير صحيحة. حاول مرة أخرى.",

    // ── SuperAdmin ───────────────────────────────────────────────────────────
    nav_all_companies:       "جميع الشركات",
    nav_create_company:      "إنشاء شركة",
    nav_global_settings:     "الإعدادات العامة",
    nav_health:              "صحة المنصة",
    nav_sa_settings:         "إعداداتي",

    tab_overview:            "نظرة عامة",
    tab_edit:                "تعديل",
    tab_subscription:        "الاشتراك",
    tab_vendors:             "الموزعون",
    tab_clients:             "العملاء",
    tab_zones:               "المناطق",
    tab_reset_checkins:      "إعادة تعيين",
    tab_analytics:           "التحليلات",
    tab_sessions:            "الجلسات",

    btn_refresh:             "تحديث",
    btn_login_as_admin:      "تسجيل كمدير",
    btn_view_details:        "عرض التفاصيل",
    btn_disable:             "تعطيل",
    btn_enable:              "تفعيل",
    btn_yes_disable:         "نعم، تعطيل",
    btn_yes_enable:          "نعم، تفعيل",
    btn_yes_delete_all:      "نعم، حذف الكل",

    lbl_company_name:        "اسم الشركة",
    lbl_billing_plan:        "الخطة",
    lbl_balance:             "الرصيد",
    lbl_status:              "الحالة",
    lbl_suspended:           "موقوف",
    lbl_total_companies:     "إجمالي الشركات",
    lbl_total_vendors:       "إجمالي الموزعين",
    lbl_total_clients:       "إجمالي العملاء",
    lbl_visits_today:        "زيارات اليوم",
    lbl_last_activity:       "آخر نشاط",
    lbl_expiring_soon:       "تنتهي خلال 7 أيام",
    lbl_gps_live:            "مباشر",
    lbl_language:            "اللغة",
    lbl_appearance:          "المظهر",
    lbl_dark_mode:           "الوضع الداكن",
    lbl_dark_mode_hint:      "التبديل إلى الوضع الداكن",
    lbl_change_password:     "تغيير كلمة المرور",
    lbl_current_password:    "كلمة المرور الحالية",
    lbl_new_password:        "كلمة المرور الجديدة",
    lbl_confirm_password:    "تأكيد كلمة المرور الجديدة",
    lbl_feature_controls:    "التحكم في الميزات",
    lbl_usage_limits:        "حدود الاستخدام",

    sa_viewing:              "عرض:",
    sa_back_all:             "→ العودة للكل",
    sa_back:                 "→ رجوع",
    sa_settings_sub:         "اللغة والمظهر وأمان الحساب",
    sa_dark_mode_hint:       "التبديل إلى الوضع الداكن",
    sa_platform_health_sub:  "نظرة عامة مباشرة على جميع الشركات",
    sa_login_blocked:        "تسجيل الدخول محظور",
    sa_getting_access:       "جارٍ الحصول على الصلاحية...",
    sa_company_disabled:     "الشركة معطّلة",
    sa_disable_company:      "تعطيل الشركة",
    sa_enable_company:       "تفعيل الشركة",
    sa_delete_company:       "حذف الشركة",
    sa_usage_limits:         "حدود الاستخدام",
    sa_platform_visits:      "زيارات المنصة — آخر 7 أيام",
    sa_global_settings:      "الإعدادات الافتراضية العامة",
    sa_global_settings_sub:  "الإعدادات الافتراضية للشركات الجديدة.",
    sa_changing_password:    "جارٍ التغيير...",
    sa_super_admin_badge:    "مدير عام",
    sa_updated:              "محدّث",
    sa_admins:               "المديرون",
    sa_supervisors:          "المشرفون",
    sa_vendors_count:        "موزع",
    sa_clients_count:        "عميل",
    sa_zones_count:          "منطقة",
    sa_events_count:         "حدث",
    sa_expires:              "تنتهي:",
    sa_company_gps_warning:  "شركات — لا نشاط GPS منذ 7+ أيام",
    sa_gps_warning_sub:      "قد تحتاج هذه الشركات إلى متابعة.",
    sa_all_companies_count:  "جميع الشركات",
    sa_platform_visits_7d:   "زيارات — آخر 7 أيام",
    sa_loading_health:       "جارٍ التحميل...",
    sa_retry:                "إعادة المحاولة",
    sa_view:                 "عرض",
    sa_last_activity:        "آخر نشاط:",
    sa_no_activity:          "لا نشاط",
    sa_today:                "اليوم",
    sa_yesterday:            "أمس",
    sa_days_ago:             "أيام",
    sa_loading:              "جارٍ التحميل...",
    sa_expired:              "منتهي",
    sa_balance_zero:         "رصيد 0",

    // ── GlobalSettings ───────────────────────────────────────────────────────
    lbl_working_hours:         "ساعات العمل",
    lbl_wh_start:              "بداية",
    lbl_wh_end:                "نهاية",
    lbl_new_company_defaults:  "إعدادات الشركة الجديدة",
    lbl_default_max_vendors:   "الحد الأقصى للموزعين",
    lbl_default_max_clients:   "الحد الأقصى للعملاء",
    lbl_default_ooz_alerts:    "تنبيهات خارج المنطقة",
    lbl_tracking:              "التتبع",
    lbl_nearby_distance_m:     "المسافة القريبة (م)",
    lbl_min_distance_m:        "الحد الأدنى للمسافة (م)",
    lbl_alert_cooldown_min:    "فترة التبريد (دقائق)",
    lbl_max_speed_kmh:         "تنبيه السرعة القصوى (0=إيقاف)",
    lbl_offline_threshold_min: "عتبة عدم الاتصال (دقائق)",
    lbl_offline_threshold_hint:"يُعدّ الموزع غير متصل إذا لم تُستقبل بيانات GPS لهذه المدة",
    lbl_auto_checkin:          "تسجيل وصول تلقائي:",
    lbl_regional:              "إقليمي",
    lbl_date_format:           "تنسيق التاريخ",
    btn_save_global_settings:  "حفظ الإعدادات العامة",
    lbl_saving:                "جارٍ الحفظ...",
    lbl_resetting:             "جارٍ الإعادة...",

    // ── CreateCompany ────────────────────────────────────────────────────────
    create_company_title:      "إنشاء شركة جديدة",
    create_company_desc:       "إنشاء الشركة وحساب المدير تلقائياً.",
    lbl_company_info:          "معلومات الشركة",
    lbl_admin_account_section: "حساب مدير الشركة",
    lbl_tier:                  "المستوى",
    lbl_out_of_zone_alerts:    "تنبيهات خارج المنطقة",
    lbl_max_vendors:           "الحد الأقصى للموزعين",
    lbl_max_clients:           "الحد الأقصى للعملاء",
    lbl_first_name:            "الاسم الأول",
    lbl_last_name:             "اسم العائلة",
    lbl_admin_email:           "البريد الإلكتروني للمدير",
    lbl_admin_password:        "كلمة مرور المدير",
    btn_create_company:        "إنشاء الشركة",
    lbl_creating:              "جارٍ الإنشاء...",

    // ── EditTab ──────────────────────────────────────────────────────────────
    lbl_company_details:       "تفاصيل الشركة",
    lbl_company_logo:          "شعار الشركة",
    lbl_choose_image:          "اختر صورة",
    lbl_upload_logo:           "رفع الشعار",
    btn_save_details:          "حفظ التفاصيل",
    btn_save_feature_settings: "حفظ إعدادات الميزات",
    lbl_change_admin_email:    "تغيير البريد الإلكتروني للمدير",
    lbl_change_email_desc:     "يغيّر البريد الإلكتروني لحساب مدير الشركة.",
    lbl_current_email:         "البريد الحالي:",
    btn_change_email:          "تغيير البريد",
    lbl_reset_admin_password:  "إعادة تعيين كلمة مرور المدير",
    lbl_reset_password_desc:   "يغيّر كلمة مرور حساب مدير الشركة.",
    btn_reset_password:        "إعادة تعيين",
    lbl_feature_controls_desc: "تفعيل أو تعطيل الميزات. التغييرات تسري فوراً.",
    lbl_stock_pos:             "نظام المخزون ونقطة البيع",
    lbl_stock_pos_desc:        "يمكن للموزعين إدارة المخزون وبيع العناصر للعملاء",
    lbl_route_optimization:    "تحسين المسار",
    lbl_route_optimization_desc:"يمكن للموزعين تحسين مسارهم اليومي تلقائياً",
    lbl_route_basic:           "أساسي (مجاني)",
    lbl_route_google:          "مسارات Google (مميز)",
    lbl_anomaly_detection:     "كشف الشذوذ",
    lbl_anomaly_detection_desc:"الكشف التلقائي عن الأنماط المشبوهة: السرعة، التوقف الطويل، عدم الزيارة",
    lbl_api_access:            "الوصول للواجهة البرمجية",
    lbl_api_access_desc:       "يمكن للمدير توليد مفاتيح API للتكامل مع الأنظمة الخارجية",

    // ── SubscriptionTab ──────────────────────────────────────────────────────
    lbl_account_suspended:     "الحساب موقوف",
    lbl_balance_zero_suspended:"وصل الرصيد إلى صفر. أضف إيداعاً لإعادة التفعيل.",
    lbl_company_disabled_msg:  "هذه الشركة معطّلة. أعد تفعيلها يدوياً.",
    lbl_plan_settings:         "الخطة والإعدادات",
    lbl_add_deposit_tab:       "إضافة إيداع",
    lbl_deposit_history:       "سجل الإيداعات",
    lbl_subscription_plan:     "خطة الاشتراك",
    lbl_monthly_billing:       "فوترة شهرية",
    lbl_monthly_billing_desc:  "يدفع العميل وديعة. يخصم النظام الرسوم الشهرية ÷ 30 يومياً. يُوقف الحساب عند الرصيد صفر.",
    lbl_active_forever:        "نشط للأبد",
    lbl_active_forever_desc:   "لا تتبع للمدفوعات. الحساب نشط حتى تعطيله يدوياً.",
    lbl_expiry_by_date:        "انتهاء بتاريخ",
    lbl_expiry_by_date_desc:   "الحساب نشط حتى تاريخ محدد. يُعطّل تلقائياً عند انتهاء التاريخ.",
    lbl_initial_deposit_aed:   "الإيداع الأولي (درهم)",
    lbl_monthly_fee_aed:       "الرسوم الشهرية (درهم)",
    lbl_current_balance_aed:   "الرصيد الحالي (درهم)",
    lbl_months_remaining:      "الأشهر المتبقية:",
    lbl_notes:                 "ملاحظات",
    lbl_expiry_date_req:       "تاريخ الانتهاء *",
    btn_save_plan:             "حفظ الخطة",
    lbl_current_status:        "الحالة الحالية",
    lbl_plan_type_label:       "نوع الخطة",
    lbl_monthly_fee_label:     "الرسوم الشهرية",
    lbl_current_balance_display:"الرصيد الحالي:",
    lbl_deposit_amount_aed:    "مبلغ الإيداع (درهم) *",
    lbl_note_optional:         "ملاحظة (اختياري)",
    lbl_new_balance_after:     "الرصيد الجديد بعد الإيداع:",
    btn_add_deposit:           "إضافة إيداع",
    lbl_adding:                "جارٍ الإضافة...",
    lbl_no_deposits:           "لا توجد إيداعات مسجلة بعد",
    th_date:                   "التاريخ",
    th_amount:                 "المبلغ",
    th_balance_after:          "الرصيد بعد",
    th_type:                   "النوع",
    th_note:                   "ملاحظة",
    lbl_monthly_charge:        "رسوم شهرية",
    lbl_deposit_label:         "إيداع",
    lbl_days_remaining_label:  "الأيام المتبقية",
    lbl_daily_rate:            "السعر اليومي",
    lbl_per_day:               "/ يوم",
    // ── Subscription Panel (admin overview — read-only) ──────────────────────
    lbl_subscription_billing:       "الاشتراك والفوترة",
    lbl_last_deduction:             "آخر خصم",
    lbl_not_yet:                    "لم يتم بعد",
    lbl_days_remaining_approx:      "يوم متبقٍ",
    lbl_active_forever_billing_msg: "هذا الحساب نشط للأبد — لا تتبع للرصيد أو انتهاء الصلاحية.",
    lbl_active_until:               "نشط حتى",
    lbl_subscription_expired_title: "انتهى الاشتراك",
    lbl_low_balance_warning:        "رصيد منخفض — سيتم تعليق اشتراكك خلال {days} يوم تقريباً. يرجى التواصل مع مسؤولك لإضافة رصيد.",
    lbl_suspended_balance_warning:  "تم تعليق اشتراكك بسبب رصيد غير كافٍ. يرجى التواصل مع المسؤول.",
    lbl_h_ago:                      "منذ {n} ساعة",
    lbl_d_ago:                      "منذ {n} يوم",

    // ── VendorsTab ───────────────────────────────────────────────────────────
    lbl_no_vendors_yet:        "لا يوجد موزعون بعد",

    // ── ClientsTab ───────────────────────────────────────────────────────────
    lbl_with_gps:              "مع GPS",
    lbl_assigned_zone:         "مخصص لمنطقة",
    lbl_visited_stat:          "تمت الزيارة",
    lbl_client_import_info:    "تفاصيل العملاء تُدار من لوحة تحكم المدير. يمكن للمدير العام رؤية الإحصائيات فقط.",
    lbl_import_export_clients: "استيراد / تصدير العملاء",
    btn_import_clients:        "استيراد العملاء",
    btn_download_all:          "تنزيل الكل",
    btn_delete_all_clients:    "حذف جميع العملاء",
    lbl_will_be_uploaded:      "سيتم رفعه",
    lbl_duplicates_skipped:    "تم تخطي المكررات",
    lbl_no_coordinates:        "بدون إحداثيات",
    lbl_all_duplicates_msg:    "جميع العملاء في هذا الملف موجودون بالفعل — لا يوجد شيء للرفع",
    lbl_delete_all_clients_title:"حذف جميع العملاء",

    // ── ResetCheckinsTab ─────────────────────────────────────────────────────
    lbl_select_scope:          "اختر النطاق",
    lbl_all_zones_company:     "جميع المناطق (الشركة بأكملها)",
    lbl_loading_checked_in:    "جارٍ تحميل العملاء المسجّلين...",
    lbl_currently_checked_in:  "عملاء مسجّلون حالياً",
    lbl_visited_badge:         "● تمت الزيارة",
    lbl_confirm_reset_title:   "تأكيد إعادة التعيين",
    btn_confirm_reset:         "تأكيد إعادة التعيين",
    lbl_reset_complete_msg:    "اكتملت إعادة التعيين",
    lbl_tab_reset_desc:        "يمسح حالة الزيارة حتى يتمكن الموزعون من تسجيل الوصول مجدداً",

    // ── ZonesTab ─────────────────────────────────────────────────────────────
    btn_import:                "استيراد",
    btn_export:                "تصدير",
    lbl_no_zones_yet:          "لا توجد مناطق بعد. استورد ملف GeoJSON أو KML لإضافة مناطق.",
    lbl_polygon_points:        "نقاط المضلع",
    lbl_no_polygon_defined:    "لا يوجد مضلع محدد",

    // ── CompanyAnalytics ─────────────────────────────────────────────────────
    lbl_usage_analytics:       "تحليلات الاستخدام",
    lbl_7_days:                "7 أيام",
    lbl_30_days:               "30 يوماً",
    lbl_90_days:               "90 يوماً",
    lbl_total_checkins:        "إجمالي تسجيلات الوصول",
    lbl_avg_visits_day:        "متوسط الزيارات / يوم",
    lbl_active_vendors_stat:   "الموزعون النشطون",
    lbl_total_alerts_stat:     "إجمالي التنبيهات",
    lbl_speed_alerts_stat:     "تنبيهات السرعة",
    lbl_long_stop_alerts_stat: "تنبيهات التوقف الطويل",
    lbl_clients_visited:       "العملاء الذين تمت زيارتهم",
    lbl_total_events:          "إجمالي الأحداث",
    lbl_daily_activity:        "النشاط اليومي — آخر",
    lbl_days:                  "يوم",
    lbl_top_vendors_visits:    "أفضل الموزعين حسب الزيارات",
    lbl_most_visited_clients:  "أكثر العملاء زيارةً",
    lbl_alert_breakdown:       "تفصيل التنبيهات",
    lbl_no_visits_recorded:    "لا توجد زيارات مسجلة",
    lbl_no_alerts_period:      "لا تنبيهات في هذه الفترة — أداء ممتاز!",
    lbl_loading_analytics:     "جارٍ تحميل التحليلات...",
    lbl_zone_alerts:           "تنبيهات المنطقة",
    lbl_outside_hours_alerts:  "تنبيهات خارج ساعات العمل",

    // SuperAdmin My Settings — 2FA
    lbl_two_factor_auth:       "المصادقة الثنائية",
    lbl_2fa_enabled:           "المصادقة الثنائية مفعّلة",
    lbl_2fa_disabled:          "المصادقة الثنائية معطّلة",
    btn_enable_2fa:            "تفعيل المصادقة الثنائية",
    btn_disable_2fa:           "تعطيل المصادقة الثنائية",
    lbl_2fa_scan_qr:           "امسح رمز QR باستخدام Google Authenticator أو Authy:",
    lbl_2fa_enter_code:        "بعد المسح، أدخل الرمز المكون من 6 أرقام:",
    lbl_2fa_enter_to_disable:  "أدخل الرمز لتعطيل المصادقة الثنائية:",
    btn_verify_enable:         "تحقق وتفعيل",
    btn_confirm_disable:       "تأكيد التعطيل",
    lbl_verifying:             "جاري التحقق...",
    lbl_disabling:             "جاري التعطيل...",
    err_2fa_code_length:       "الرجاء إدخال الرمز المكون من 6 أرقام.",

    // SuperAdmin My Settings — Change Email
    lbl_change_email:          "تغيير البريد الإلكتروني",
    lbl_new_email:             "البريد الإلكتروني الجديد",
    lbl_confirm_with_password: "تأكيد بكلمة المرور الحالية",
    btn_update_email:          "تحديث البريد الإلكتروني",
    lbl_updating:              "جارٍ التحديث...",
    err_email_required:        "الرجاء إدخال بريد إلكتروني جديد.",
    err_email_invalid:         "الرجاء إدخال بريد إلكتروني صالح.",
    err_email_same:            "البريد الجديد مطابق للحالي.",
    err_password_required:     "الرجاء إدخال كلمة المرور.",
    err_wrong_password:        "كلمة المرور غير صحيحة.",
    err_email_in_use:          "البريد الإلكتروني مستخدم بالفعل.",
    err_reauth_required:       "الرجاء تسجيل الخروج وإعادة الدخول.",
    success_email_updated:     "تم تحديث البريد الإلكتروني بنجاح.",

    // Login — 2FA verification step
    lbl_2fa_verification:      "التحقق بخطوتين",
    lbl_2fa_open_app:          "افتح تطبيق المصادقة وأدخل الرمز المكوّن من 6 أرقام.",
    btn_verify:                "تحقق",
    btn_back_to_login:         "العودة لتسجيل الدخول",
    err_2fa_invalid:           "رمز غير صالح أو منتهي الصلاحية. حاول مرة أخرى.",

    // SuperAdmin My Settings — Active Sessions
    lbl_active_sessions:             "الجلسات النشطة",
    lbl_no_sessions:                 "لا توجد جلسات نشطة",
    lbl_current_session:             "الحالية",
    lbl_logged_in:                   "تسجيل الدخول",
    lbl_last_active:                 "آخر نشاط",
    lbl_revoking:                    "جاري الإلغاء...",
    btn_revoke:                      "إلغاء",
    lbl_multiple_sessions_warning:   "تم اكتشاف جلسات متعددة. قم بإلغاء أي جلسة لا تتعرف عليها.",
    lbl_ip_address:                  "عنوان IP",
    lbl_connection_history:          "سجل الاتصالات",
    lbl_from_date:                   "من",
    lbl_to_date:                     "إلى",
    btn_load_history:                "تحميل",
    lbl_select_dates:                "حدد نطاق التاريخ واضغط تحميل.",
    lbl_no_history:                  "لا توجد جلسات في هذه الفترة.",
    lbl_session_ended:               "منتهية",
    lbl_session_revoked:             "ملغاة",
    lbl_active:                      "نشطة",
    lbl_device:                      "الجهاز",
    lbl_default_timezone:            "المنطقة الزمنية الافتراضية",
    lbl_default_timezone_desc:       "يُستخدم لتقاريرك وطوابع الوقت وتحليلات المنصة.",
    btn_save_timezone:               "حفظ المنطقة الزمنية",
    success_saved:                   "تم الحفظ بنجاح.",
    lbl_never:                       "أبداً",
    lbl_platform_branding:           "هوية المنصة",
    lbl_platform_name:               "اسم المنصة",
    lbl_platform_name_desc:          "يظهر في صفحة تسجيل الدخول والتقارير.",
    lbl_primary_color:               "اللون الرئيسي",
    lbl_primary_color_desc:          "يؤثر على الأزرار والشريط الجانبي.",
    lbl_platform_logo:               "شعار المنصة",
    lbl_logo_desc:                   "PNG أو JPG، بحد أقصى 2 ميجابايت.",
    btn_upload_logo:                 "رفع الشعار",
    btn_remove_logo:                 "إزالة",
    btn_save_branding:               "حفظ الهوية",
    lbl_preview_button:              "معاينة الزر",
    lbl_preview_badge:               "معاينة الشارة",
    success_branding_saved:          "تم حفظ الهوية. التغييرات تُطبق فوراً.",
    err_logo_type:                   "الرجاء اختيار ملف صورة.",
    err_logo_size:                   "يجب أن يكون الشعار أقل من 2 ميجابايت.",

    btn_save:                        "حفظ",

    // ── Data & Maintenance ───────────────────────────────────────────────────
    lbl_data_maintenance:            "البيانات والصيانة",
    lbl_auto_backup:                 "النسخ الاحتياطي التلقائي",
    lbl_enable_backup:               "تفعيل النسخ الاحتياطي التلقائي",
    lbl_backup_desc:                 "تصدير بيانات Firestore إلى Google Cloud Storage",
    lbl_backup_frequency:            "تكرار النسخ الاحتياطي",
    opt_daily:                       "كل يوم",
    opt_weekly:                      "كل أسبوع",
    opt_every_10:                    "كل 10 أيام",
    opt_monthly:                     "كل شهر",
    opt_custom_days:                 "مخصص (كل N أيام)",
    lbl_every_n_days:                "كل كم يوم؟",
    lbl_backup_time:                 "تشغيل النسخ الاحتياطي في الساعة",
    lbl_retain_backups:              "الاحتفاظ بالنسخ الاحتياطية (أيام)",
    opt_7_days:                      "7 أيام",
    opt_14_days:                     "14 يوماً",
    opt_30_days:                     "30 يوماً",
    opt_60_days:                     "60 يوماً",
    opt_90_days:                     "90 يوماً",
    opt_1_year:                      "سنة واحدة",
    lbl_recent_backups:              "النسخ الاحتياطية الأخيرة",
    btn_backup_now:                  "تشغيل النسخ الاحتياطي الآن",
    lbl_backup_running:              "جاري النسخ الاحتياطي...",
    success_backup_started:          "بدأ النسخ الاحتياطي. تحقق من السجلات.",
    lbl_data_retention:              "الاحتفاظ بالبيانات",
    lbl_data_retention_desc:         "يتم حذف أحداث GPS القديمة تلقائياً. بيانات العملاء لا تُحذف أبداً.",
    lbl_keep_events_for:             "الاحتفاظ بالأحداث والتنبيهات لمدة",
    opt_keep_forever:                "الاحتفاظ للأبد (بدون حذف)",
    opt_3_months:                    "3 أشهر",
    opt_6_months:                    "6 أشهر",
    opt_12_months:                   "12 شهراً (موصى به)",
    opt_24_months:                   "24 شهراً",
    opt_36_months:                   "36 شهراً",
    lbl_retention_warning:           "سيتم حذف الأحداث الأقدم من الفترة المحددة نهائياً في الأول من كل شهر.",
    lbl_api_rate_limit:              "حد معدل API (طلبات في الدقيقة)",
    opt_per_minute:                  "طلب / دقيقة",
    opt_unlimited:                   "غير محدود",
    lbl_rate_limit_desc:             "الحد الأقصى لطلبات API في الدقيقة. الطلبات الزائدة ترجع خطأ 429.",

    // ── Reports Page (AR) ────────────────────────────────────────────────────
    reports_title:                   "التقارير",
    reports_subtitle:                "إنشاء وتصدير التقارير لأي فترة زمنية",
    reports_step1:                   "الخطوة 1 — اختر نوع التقرير",
    reports_step2:                   "الخطوة 2 — حدد الفلاتر",
    reports_type_visits:             "زيارات العملاء",
    reports_type_visits_desc:        "العملاء الذين تمت زيارتهم، متى، ومن قِبَل من",
    reports_type_zone_coverage:      "تغطية المنطقة",
    reports_type_zone_coverage_desc: "العملاء الذين تمت زيارتهم مقابل غير المزارين لكل منطقة",
    reports_type_activity:           "نشاط الموزع",
    reports_type_activity_desc:      "أوقات الاتصال وانقطاعه وعدد الساعات",
    reports_type_alerts:             "سجل خارج المنطقة",
    reports_type_alerts_desc:        "كل تنبيه: من، أي منطقة، الوقت",
    reports_type_unauth_zone:        "منطقة غير مصرح بها",
    reports_type_unauth_zone_desc:   "الموزعون الذين دخلوا مناطق غير مخصصة لهم",
    reports_type_zone:               "المنطقة / السياج الجغرافي",
    reports_type_zone_desc:          "أي الموزعين دخل كل منطقة",
    reports_type_daily:              "ملخص يومي",
    reports_type_daily_desc:         "يوم كامل: الموزعون، الزيارات، التنبيهات",
    reports_type_client_creation:    "إنشاء العملاء",
    reports_type_client_creation_desc:"العملاء المضافون من قِبَل كل مشغّل",
    reports_type_custom:             "تقرير مخصص",
    reports_type_custom_desc:        "اختر أي مجموعة من الفلاتر",
    reports_period_today:            "اليوم",
    reports_period_week:             "هذا الأسبوع",
    reports_period_month:            "هذا الشهر",
    reports_period_last_month:       "الشهر الماضي",
    reports_period_custom:           "مخصص",
    reports_period_yesterday:        "أمس",
    reports_period_this_week:        "هذا الأسبوع",
    reports_period_this_month:       "هذا الشهر",
    reports_from_date:               "تاريخ البداية",
    reports_from_time:               "وقت البداية",
    reports_to_date:                 "تاريخ النهاية",
    reports_to_time:                 "وقت النهاية",
    reports_vendor_filter:           "الموزع",
    reports_all_vendors:             "جميع الموزعين",
    reports_zone_filter:             "المنطقة / القسم",
    reports_all_zones:               "جميع المناطق",
    reports_search_vendors:          "البحث عن الموزعين...",
    reports_search_zones:            "البحث عن المناطق...",
    reports_no_vendors_found:        "لم يُعثر على موزعين",
    reports_no_zones_found:          "لم يُعثر على مناطق",
    reports_event_types:             "أنواع الأحداث المراد تضمينها",
    reports_group_by:                "تجميع النتائج حسب",
    reports_group_vendor:            "الموزع",
    reports_group_zone:              "المنطقة",
    reports_group_day:               "اليوم",
    reports_group_client:            "العميل",
    reports_select_event_type:       "اختر نوع حدث واحداً على الأقل.",
    reports_generating:              "جارٍ الإنشاء...",
    reports_generate:                "إنشاء التقرير",
    reports_report_label:            "تقرير",
    reports_zones_count:             "منطقة(مناطق)",
    reports_events_count:            "حدث(أحداث)",
    reports_vendors_count:           "موزع(موزعون)",
    reports_export_excel:            "إكسيل",
    reports_export_csv:              "CSV",
    reports_export_pdf:              "PDF",
    reports_no_events:               "لم يُعثر على أحداث",
    reports_no_events_sub:           "جرب نطاقاً زمنياً مختلفاً أو فلاتر أخرى",
    reports_no_clients_zone:         "لم يُعثر على عملاء في أي منطقة",
    reports_no_clients_zone_sub:     "أضف عملاء وخصّص لهم مناطق أولاً",
    reports_no_zone_visits:          "لم يُعثر على زيارات للمناطق",
    reports_no_zone_visits_sub:      "جرب نطاقاً زمنياً مختلفاً أو فلاتر أخرى",
    reports_no_unauth:               "لم يُعثر على دخول غير مصرح به",
    reports_no_unauth_sub:           "لم يدخل أي موزع مناطق غير مخصصة في هذه الفترة",
    reports_anomaly_disabled:        "⚠️ تنبيهات خارج المنطقة معطّلة حالياً لهذه الشركة. فعّل كشف الشذوذ في إعدادات الشركة.",
    reports_overall_coverage:        "التغطية الإجمالية",
    reports_visited:                 "تمت الزيارة",
    reports_not_visited:             "لم تتم الزيارة",
    reports_none_visited:            "لا يوجد أي زيارات",
    reports_all_visited:             "تمت زيارة الجميع! 🎉",
    reports_covered:                 "مغطى",
    reports_clients_count:           "عملاء",
    reports_col_vendor:              "الموزع",
    reports_col_total_visits:        "إجمالي الزيارات",
    reports_col_unique_clients:      "العملاء الفريدون",
    reports_col_last_visit:          "آخر زيارة",
    reports_col_check_ins:           "تسجيلات الوصول",
    reports_col_clients_visited:     "العملاء المزارون",
    reports_col_type:                "النوع",
    reports_col_client_zone:         "العميل / المنطقة",
    reports_col_timestamp:           "الطابع الزمني",
    reports_col_duration:            "المدة",
    reports_col_zone:                "المنطقة",
    reports_col_total_clients:       "إجمالي العملاء",
    reports_col_coverage:            "نسبة التغطية",
    reports_speed_alerts:            "تنبيهات السرعة",
    reports_zone_alerts:             "تنبيهات المنطقة",
    reports_long_stop_alerts:        "تنبيهات التوقف الطويل",
    reports_check_ins:               "تسجيلات الوصول",
    reports_op_step2:                "الخطوة 2 — حدد الفلاتر",
    reports_op_from:                 "من",
    reports_op_to:                   "إلى",
    reports_op_operator:             "المشغّل",
    reports_op_search:               "البحث عن المشغّلين...",
    reports_op_all_operators:        "جميع المشغّلين",
    reports_op_loading:              "جارٍ تحميل المشغّلين...",
    reports_op_generate:             "إنشاء التقرير",
    reports_op_generating:           "جارٍ الإنشاء...",
    reports_op_report_title:         "تقرير إنشاء العملاء",
    reports_op_export:               "تصدير إلى إكسيل",
    reports_op_by_operator:          "حسب المشغّل",
    reports_op_no_operators:         "لم يُعثر على مشغّلين.",
    reports_op_today:                "اليوم",
    reports_op_this_week:            "هذا الأسبوع",
    reports_op_this_month:           "هذا الشهر",
    reports_op_in_period:            "في الفترة",
    reports_op_total_all_time:       "الإجمالي الكلي",
    reports_op_all_clients:          "جميع العملاء في الفترة",
    reports_op_search_clients:       "البحث بالاسم أو الهاتف أو المشغّل...",
    reports_op_no_clients:           "لم يُعثر على عملاء في هذه الفترة.",
    reports_op_col_name:             "الاسم",
    reports_op_col_phone:            "الهاتف",
    reports_op_col_created_by:       "أنشأه",
    reports_op_col_date_added:       "تاريخ الإضافة",
    reports_custom_checkins:         "تسجيلات الوصول (GPS + يدوي)",
    reports_custom_zone_alert:       "تنبيهات المنطقة",
    reports_custom_speed_alert:      "تنبيهات السرعة",
    reports_custom_long_stop:        "تنبيهات التوقف الطويل",
    reports_custom_outside_hours:    "تنبيهات خارج ساعات العمل",
    reports_custom_no_visits:        "تنبيهات عدم الزيارة",

    // ── Statistics Page (AR) ─────────────────────────────────────────────────
    stats_title:                     "الإحصاءات والتحليلات",
    stats_subtitle:                  "تتبع الزيارات والتنبيهات وأداء الموزعين عبر الزمن",

    // ── Company Settings (AR) ─────────────────────────────────────────────────
    cs_title:                        "إعدادات الشركة",
    cs_subtitle:                     "إعداد تفضيلات شركتك",
    cs_saving:                       "جارٍ الحفظ...",
    cs_uploading:                    "جارٍ الرفع...",
    cs_save_changes:                 "حفظ التغييرات",
    cs_loading:                      "جارٍ تحميل الإعدادات...",
    cs_load_error:                   "فشل تحميل الإعدادات. يُرجى تحديث الصفحة.",
    cs_tab_general:                  "عام",
    cs_tab_tracking:                 "التتبع",
    cs_tab_hours:                    "ساعات العمل",
    cs_tab_alerts:                   "التنبيهات",
    cs_tab_appearance:               "المظهر",
    cs_tab_client_types:             "أنواع العملاء",
    cs_regional:                     "الإعدادات الإقليمية",
    cs_timezone:                     "المنطقة الزمنية",
    cs_language:                     "اللغة",
    cs_date_format:                  "صيغة التاريخ",
    cs_behaviour:                    "السلوك",
    cs_auto_checkin:                 "تسجيل الوصول التلقائي",
    cs_auto_checkin_desc:            "تسجيل الزيارة تلقائياً عند وصول الموزع إلى موقع العميل",
    cs_manual_checkin:               "السماح بتسجيل الوصول اليدوي",
    cs_manual_checkin_desc:          "يمكن للموزعين تسجيل الزيارة يدوياً من التطبيق",
    cs_require_notes:                "إلزام الملاحظات عند الزيارة",
    cs_require_notes_desc:           "يجب على الموزعين إضافة ملاحظة عند تسجيل الزيارة",
    cs_notif_sound:                  "صوت الإشعارات",
    cs_notif_sound_desc:             "تشغيل صوت عند وصول تنبيهات جديدة",
    cs_gps_tracking:                 "GPS وكشف الوصول",
    cs_nearby_distance:              "مسافة القرب (متر)",
    cs_nearby_hint:                  "مدى قرب الموزع المطلوب لتسجيل الوصول",
    cs_gps_interval:                 "فترة تحديث GPS (ثانية)",
    cs_gps_interval_hint:            "عدد مرات إرسال تطبيق الموزع لتحديثات الموقع",
    cs_min_arrival:                  "أدنى مسافة وصول (م)",
    cs_max_arrival:                  "أقصى مسافة وصول (م)",
    cs_visit_reset:                  "إعادة تعيين الزيارة (أيام)",
    cs_visit_reset_hint:             "بعد كم من الأيام يعود العميل المزار إلى حالة غير مزار",
    cs_working_hours:                "ساعات العمل",
    cs_hours_start:                  "وقت بدء العمل",
    cs_hours_end:                    "وقت انتهاء العمل",
    cs_track_outside:                "التتبع خارج ساعات العمل",
    cs_track_outside_desc:           "تسجيل أحداث GPS المرسلة خارج ساعات العمل",
    cs_alerts_section:               "التنبيهات والإشعارات",
    cs_out_of_zone:                  "تنبيهات خارج المنطقة",
    cs_out_of_zone_desc:             "تنبيه عندما يزور موزع عميلاً خارج منطقته المخصصة",
    cs_unauth_zone:                  "تنبيهات المنطقة غير المصرح بها",
    cs_unauth_zone_desc:             "تنبيه عندما يدخل موزع منطقة غير مخصصة له",
    cs_cooldown:                     "فترة هدوء التنبيه (دقائق)",
    cs_cooldown_hint:                "الحد الأدنى للوقت بين تنبيهين للموزع نفسه",
    cs_max_speed:                    "تنبيه الحد الأقصى للسرعة (كم/س)",
    cs_max_speed_hint:               "تنبيه عند تجاوز هذه السرعة. 0 = معطّل",
    cs_appearance:                   "المظهر",
    cs_company_name:                 "اسم الشركة",
    cs_company_phone:                "الهاتف",
    cs_company_email:                "البريد الإلكتروني",
    cs_company_address:              "العنوان",
    cs_primary_color:                "اللون الرئيسي",
    cs_logo:                         "شعار الشركة",
    cs_logo_hint:                    "PNG أو JPG، بحد أقصى 2 ميجابايت",
    cs_choose_logo:                  "اختر الشعار",
    cs_client_types:                 "أنواع العملاء",
    cs_client_types_hint:            "حدد أنواع العملاء لشركتك",
    cs_add_type:                     "إضافة نوع",
    cs_new_type_ph:                  "اسم النوع الجديد...",
    cs_no_types:                     "لم تُحدَّد أنواع عملاء بعد",
    cs_success:                      "✅ تم حفظ الإعدادات بنجاح!",
    cs_logo_type_err:                "الرجاء اختيار ملف صورة.",
    cs_logo_size_err:                "يجب أن يكون الشعار أقل من 2 ميجابايت.",
    cs_notif_checkin:                "عرض إشعارات تسجيل الوصول",
    cs_notif_checkin_desc:           "عرض تسجيلات وصول الموزعين (GPS ويدوي) في صفحة الإشعارات",
    cs_visit_alerts:                 "تنبيهات الزيارة",
    cs_missed_visit:                 "تنبيه الزيارة الفائتة",
    cs_missed_visit_desc:            "إشعار إذا لم يقم الموزع بأي زيارة خلال فترة إعادة التعيين",
    cs_long_stop:                    "تنبيه التوقف الطويل",
    cs_long_stop_desc:               "إشعار عندما يبقى الموزع في نفس الموقع لفترة طويلة",
    cs_long_stop_min:                "حد التوقف الطويل (دقائق)",
    cs_long_stop_hint:               "تنبيه إذا بقي الموزع في نفس الموقع أكثر من هذه المدة خلال ساعات العمل",

    // ── Stock Manager (AR) ───────────────────────────────────────────────────
    stock_title:                     "مدير المخزون",
    stock_subtitle:                  "إدارة كتالوج المنتجات ومخزون الموزعين والمبيعات والحركات",
    stock_tab_catalog:               "كتالوج المنتجات",
    stock_tab_vendor:                "مخزون الموزع",
    stock_tab_sales:                 "سجل المبيعات",
    stock_tab_movements:             "حركات المخزون",
    stock_tab_requests:              "طلبات إعادة التخزين",
    stock_search_products:           "البحث عن المنتجات...",
    stock_all_categories:            "جميع الفئات",
    stock_add_product:               "+ إضافة منتج",
    stock_refresh:                   "تحديث",
    stock_export_excel:              "إكسيل",
    stock_no_products:               "لم يُعثر على منتجات",
    stock_col_product:               "المنتج",
    stock_col_sku:                   "الرمز التعريفي",
    stock_col_category:              "الفئة",
    stock_col_unit:                  "الوحدة",
    stock_col_sell_price:            "سعر البيع",
    stock_col_cost:                  "التكلفة",
    stock_col_total_stock:           "إجمالي المخزون",
    stock_col_status:                "الحالة",
    stock_col_actions:               "الإجراءات",
    stock_low:                       "منخفض",
    stock_active:                    "نشط",
    stock_inactive:                  "غير نشط",
    stock_edit_product:              "تعديل المنتج",
    stock_add_product_modal:         "إضافة منتج",
    stock_product_name:              "اسم المنتج",
    stock_sku_label:                 "الرمز التعريفي",
    stock_sku_hint:                  "(تلقائي إذا كان فارغاً)",
    stock_category:                  "الفئة",
    stock_unit:                      "الوحدة",
    stock_initial_qty:               "الكمية الأولية",
    stock_low_threshold:             "عتبة المخزون المنخفض",
    stock_sell_price:                "سعر البيع",
    stock_cost_price:                "سعر التكلفة",
    stock_active_visible:            "نشط (مرئي للموزعين)",
    stock_save_changes:              "حفظ التغييرات",
    stock_create_product:            "إنشاء المنتج",
    stock_saving:                    "جارٍ الحفظ...",
    stock_cancel:                    "إلغاء",
    stock_delete_product:            "حذف المنتج",
    stock_delete_confirm:            "لا يمكن التراجع عن هذا الإجراء.",
    stock_deleting:                  "جارٍ الحذف...",
    stock_name_required:             "اسم الصنف مطلوب.",
    stock_product_updated:           "تم تحديث المنتج.",
    stock_product_created:           "تم إنشاء المنتج.",

    // ── Notes Inbox (AR) ─────────────────────────────────────────────────────
    notes_title:                     "صندوق الملاحظات",
    notes_subtitle:                  "الملاحظات المرسلة من الموظفين الميدانيين عن العملاء",
    notes_refresh:                   "تحديث",
    notes_loading:                   "جارٍ تحميل الملاحظات...",
    notes_date_label:                "التاريخ:",
    notes_all_time:                  "كل الأوقات",
    notes_today:                     "اليوم",
    notes_yesterday:                 "أمس",
    notes_this_week:                 "هذا الأسبوع",
    notes_this_month:                "هذا الشهر",
    notes_custom:                    "مخصص",
    notes_from:                      "من:",
    notes_to:                        "إلى:",
    notes_priority_label:            "الأولوية:",
    notes_all_notes:                 "جميع الملاحظات",
    notes_urgent:                    "عاجل",
    notes_normal:                    "عادي",
    notes_sender_label:              "المرسل:",
    notes_all_senders:               "جميع المرسلين",
    notes_vendors:                   "الموزعون",
    notes_operators:                 "المشغّلون",
    notes_supervisors:               "المشرفون",
    notes_showing:                   "عرض",
    notes_of:                        "من",
    notes_loaded:                    "ملاحظة محمّلة",
    notes_empty:                     "لا توجد ملاحظات",
    notes_no_match:                  "لا توجد ملاحظات تطابق الفلاتر المحددة",
    notes_badge_urgent:              "عاجل",
    notes_badge_normal:              "عادي",
    notes_badge_unread:              "غير مقروء",
    notes_badge_read:                "مقروء",
    notes_badge_replied:             "تم الرد",
    notes_show_map:                  "عرض على الخريطة",
    notes_admin_reply:               "رد المسؤول",
    notes_reply_ph:                  "اكتب ردك هنا...",
    notes_cancel_reply:              "إلغاء",
    notes_send:                      "إرسال",
    notes_sending:                   "جارٍ الإرسال...",
    notes_mark_read:                 "وضع علامة مقروء",
    notes_reply_btn:                 "رد",
    notes_edit_reply:                "تعديل الرد",
    notes_print_restock:             "طباعة نموذج إعادة التخزين",
    notes_load_more:                 "تحميل المزيد",
    notes_role_operator:             "مشغّل",
    notes_role_vendor:               "موزع",
    notes_role_supervisor:           "مشرف",
    notes_role_staff:                "موظف",
    notes_all_loaded:                "تم تحميل جميع الملاحظات",
    notes_load_more_btn:             "تحميل المزيد من الملاحظات",
    notes_loading_more:              "جارٍ التحميل...",

    // ── Coverage Map (AR) ────────────────────────────────────────────────────
    cmap_title:                      "خريطة التغطية",
    cmap_heat_map:                   "خريطة الحرارة",
    cmap_client_pins:                "دبابيس العملاء",
    cmap_coverage:                   "التغطية",
    cmap_show_zones:                 "إظهار المناطق",
    cmap_show_vendors:               "إظهار الموزعين",
    cmap_clients_on_map:             "العملاء على الخريطة",
    cmap_with_zone:                  "ضمن منطقة",
    cmap_no_zone:                    "بدون منطقة",
    cmap_visited:                    "تمت الزيارة",
    cmap_coverage_pct:               "التغطية",
    cmap_clients_by_zone:            "العملاء حسب المنطقة",
    cmap_no_zones_defined:           "لا توجد مناطق محددة",
    cmap_vendors:                    "الموزعون",
    cmap_search_vendor:              "البحث عن موزع...",
    cmap_visit_coverage:             "تغطية الزيارات حسب المنطقة",
    cmap_loading_map:                "جارٍ تحميل الخريطة...",
    cmap_loading_data:               "جارٍ تحميل بيانات الخريطة...",
    cmap_retry:                      "إعادة المحاولة",
    cmap_total:                      "الإجمالي",
    cmap_remaining:                  "المتبقي",
    cmap_progress:                   "التقدم",
    cmap_close:                      "إغلاق",
    cmap_last_visit:                 "آخر زيارة:",
    cmap_never_visited:              "لم تتم الزيارة قط",
    cmap_no_data:                    "لا بيانات",
    cmap_live:                       "مباشر",
    cmap_online:                     "متصل",
    cmap_idle:                       "خامل",
    cmap_offline:                    "غير متصل",

    // ── Supervisor Dashboard (AR) ─────────────────────────────────────────────
    sup_dash_my_vendors:             "موزعيّ",
    sup_dash_my_clients:             "عملائي",
    sup_dash_clients_today:          "العملاء المزارون اليوم",
    sup_dash_zone_alerts:            "تنبيهات المناطق",
    sup_dash_assigned_zones:         "مناطقي المخصصة",
    sup_dash_recent_activity:        "النشاط الأخير",
    sup_dash_no_events:              "لا توجد أحداث في مناطقك بعد.",
    sup_dash_live_map:               "الخريطة المباشرة",
    sup_dash_online:                 "متصل",
    sup_dash_show_clients:           "إظهار العملاء",
    sup_dash_satellite:              "صور الأقمار الصناعية",
    sup_dash_map:                    "خريطة",
    sup_dash_send_note:              "إرسال ملاحظة",
    sup_dash_vendor_page:            "الموزعون",
    sup_dash_client_page:            "العملاء",
    sup_dash_search_clients:         "البحث عن العملاء...",
    sup_dash_no_clients:             "لا يوجد عملاء في مناطقك.",
    sup_dash_section:                "القسم",
    sup_dash_last_visit:             "آخر زيارة",
    sup_dash_never:                  "أبداً",
    sup_dash_status:                 "الحالة",
    sup_dash_search_vendors:         "البحث عن الموزعين...",
    sup_dash_no_vendors:             "لا يوجد موزعون في مناطقك.",
    sup_dash_last_seen:              "آخر ظهور",
    sup_dash_events:                 "الأحداث",
    sup_dash_search_events:          "البحث في الأحداث...",
    sup_dash_no_events_found:        "لم يُعثر على أحداث.",
    sup_dash_event_vendor:           "الموزع",
    sup_dash_event_client:           "العميل",
    sup_dash_event_type:             "النوع",
    sup_dash_event_time:             "الوقت",
    sup_dash_profile:                "ملفي الشخصي",
    sup_dash_dark_mode:              "الوضع الداكن",
    sup_dash_change_pw:              "تغيير كلمة المرور",
    sup_dash_current_pw:             "كلمة المرور الحالية",
    sup_dash_new_pw:                 "كلمة المرور الجديدة",
    sup_dash_confirm_pw:             "تأكيد كلمة المرور الجديدة",
    sup_dash_pw_saved:               "تم تغيير كلمة المرور بنجاح.",
    sup_dash_pw_mismatch:            "كلمتا المرور غير متطابقتين.",
    sup_dash_pw_short:               "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل.",
    sup_dash_pw_wrong:               "كلمة المرور الحالية غير صحيحة.",
    sup_dash_saving_pw:              "جارٍ الحفظ...",
    sup_dash_save_pw:                "حفظ كلمة المرور",
    sup_dash_note_message:           "الرسالة",
    sup_dash_note_priority:          "الأولوية",
    sup_dash_note_normal:            "عادي",
    sup_dash_note_urgent:            "عاجل",
    sup_dash_note_send:              "إرسال الملاحظة",
    sup_dash_note_sending:           "جارٍ الإرسال...",
    sup_dash_note_sent:              "تم إرسال الملاحظة إلى المسؤول.",
    sup_dash_note_error:             "الرجاء إدخال رسالة.",
    sup_dash_plate:                  "اللوحة:",
    sup_dash_speed:                  "كم/س",
    sup_dash_loading_too_long:       "استغرق التحميل وقتاً طويلاً. يُرجى تحديث الصفحة.",

    // ── Operator Dashboard (AR) ───────────────────────────────────────────────
    op_dash_my_clients:              "عملائي",
    op_dash_statistics:              "الإحصاءات",
    op_dash_profile:                 "الملف الشخصي",
    op_dash_map:                     "الخريطة",
    op_dash_add_client:              "إضافة عميل",
    op_dash_edit_client:             "تعديل العميل",
    op_dash_first_name:              "الاسم الأول",
    op_dash_last_name:               "اسم العائلة",
    op_dash_phone:                   "الهاتف",
    op_dash_address:                 "العنوان",
    op_dash_client_type:             "نوع العميل",
    op_dash_notes_label:             "ملاحظات",
    op_dash_save:                    "حفظ",
    op_dash_saving:                  "جارٍ الحفظ...",
    op_dash_cancel:                  "إلغاء",
    op_dash_use_my_location:         "استخدام موقعي",
    op_dash_locating:                "جارٍ التحديد...",
    op_dash_pin_map:                 "انقر على الخريطة لوضع الدبوس",
    op_dash_search_clients:          "البحث عن العملاء...",
    op_dash_no_clients:              "لا يوجد عملاء بعد. أضف أول عميل!",
    op_dash_total_clients:           "إجمالي العملاء",
    op_dash_visited_today:           "تمت زيارتهم اليوم",
    op_dash_pending:                 "معلّق",
    op_dash_dark_mode:               "الوضع الداكن",
    op_dash_change_pw:               "تغيير كلمة المرور",
    op_dash_current_pw:              "كلمة المرور الحالية",
    op_dash_new_pw:                  "كلمة المرور الجديدة",
    op_dash_confirm_pw:              "تأكيد كلمة المرور",
    op_dash_pw_saved:                "تم تغيير كلمة المرور بنجاح.",
    op_dash_pw_mismatch:             "كلمتا المرور غير متطابقتين.",
    op_dash_pw_short:                "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل.",
    op_dash_pw_wrong:                "كلمة المرور الحالية غير صحيحة.",
    op_dash_saving_pw:               "جارٍ الحفظ...",
    op_dash_save_pw:                 "حفظ كلمة المرور",
    op_dash_send_note:               "إرسال ملاحظة",
    op_dash_note_message:            "الرسالة",
    op_dash_note_priority:           "الأولوية",
    op_dash_note_normal:             "عادي",
    op_dash_note_urgent:             "عاجل",
    op_dash_note_send:               "إرسال",
    op_dash_note_sending:            "جارٍ الإرسال...",
    op_dash_note_sent:               "تم إرسال الملاحظة إلى المسؤول.",
    op_dash_note_error:              "الرجاء إدخال رسالة.",
    op_dash_navigate:                "التنقل",
    op_dash_edit:                    "تعديل",
    op_dash_delete:                  "حذف",
    op_dash_delete_confirm:          "هل أنت متأكد من حذف هذا العميل؟",
    op_dash_deleting:                "جارٍ الحذف...",
    op_dash_gps_error:               "تعذّر الحصول على موقعك.",
    op_dash_stats_title:             "الإحصاءات",
    op_dash_stats_subtitle:          "نظرة عامة على أدائك",
    op_dash_today:                   "اليوم",
    op_dash_this_week:               "هذا الأسبوع",
    op_dash_this_month:              "هذا الشهر",

    // ── Vendor Dashboard (AR) ─────────────────────────────────────────────────
    vendor_badge:                    "موزع",
    vendor_offline_banner:           "أنت غير متصل — سيتم مزامنة تسجيلات الوصول والملاحظات عند الاتصال.",
    vendor_pending_sync:             "في انتظار المزامنة.",
    vendor_sync_now:                 "مزامنة الآن",
    vendor_syncing:                  "جارٍ المزامنة...",
    vendor_route:                    "المسار",
    vendor_map:                      "الخريطة",
    vendor_stats:                    "الإحصاءات",
    vendor_stock:                    "المخزون",
    vendor_profile:                  "الملف الشخصي",
    vendor_note_enter_msg:           "الرجاء إدخال رسالة.",
    vendor_note_saved_offline:       "تم حفظ الملاحظة بدون اتصال — ستتم المزامنة عند الاتصال.",
    vendor_note_sent:                "تم إرسال الملاحظة.",
    vendor_send_note_title:          "إرسال ملاحظة إلى المسؤول",
    vendor_general_note:             "ملاحظة عامة",
    vendor_note_message:             "الرسالة",
    vendor_note_priority:            "الأولوية",
    vendor_note_normal:              "عادي",
    vendor_note_urgent:              "عاجل",
    vendor_note_cancel:              "إلغاء",
    vendor_note_sending:             "جارٍ الإرسال...",
    vendor_note_send:                "إرسال",
    vendor_route_total:              "الإجمالي",
    vendor_route_visited:            "تمت الزيارة",
    vendor_route_remaining:          "المتبقي",
    vendor_route_getting_location:   "جارٍ تحديد موقعك...",
    vendor_route_showing_clients:    "عرض العملاء",
    vendor_route_away:               "بعيداً",
    vendor_route_found:              "وجد",
    vendor_route_refresh:            "تحديث",
    vendor_route_locating:           "جارٍ التحديد...",
    vendor_route_no_zone:            "لا توجد منطقة مخصصة. تواصل مع مسؤولك لتخصيص منطقة لحسابك.",
    vendor_route_no_nearby:          "لا يوجد عملاء قريبون — اقترب من مسارك",
    vendor_route_no_clients:         "لا يوجد عملاء للعرض",
    vendor_route_navigate:           "التنقل",
    vendor_route_check_in:           "تسجيل الوصول",
    vendor_route_auto_only:          "تسجيل تلقائي فقط",
    vendor_route_note:               "ملاحظة",
    vendor_route_sell:               "بيع صنف",
    vendor_route_receipt:            "عرض الإيصال",
    vendor_route_loading_receipt:    "جارٍ التحميل...",
    vendor_route_no_receipt:         "لم يُعثر على إيصال لهذا العميل.",
    vendor_route_pending:            "معلّق",
    vendor_route_visited_label:      "تمت الزيارة",
    vendor_route_from_prev:          "من المحطة السابقة",
    vendor_route_no_zone_label:      "بدون منطقة",
    vendor_route_all:                "الكل",
    vendor_route_search_ph:          "البحث عن العملاء...",
    vendor_route_optimized:          "تم تحسين المسار",
    vendor_route_optimization:       "تحسين المسار",
    vendor_route_optimizing:         "جارٍ التحسين...",
    vendor_route_reset_order:        "إعادة الترتيب",
    vendor_route_optimize:           "تحسين المسار",
    vendor_route_saves:              "توفير",
    vendor_route_km:                 "كم",
    vendor_route_min:                "دقيقة",
    vendor_route_checkin_note_title: "ملاحظة مطلوبة",
    vendor_route_checkin_note_hint:  "أضف ملاحظة زيارة قبل تسجيل الوصول في",
    vendor_route_checkin_note_ph:    "ماذا حدث في هذه الزيارة؟",
    vendor_route_checkin_note_error: "الرجاء إضافة ملاحظة قبل تسجيل الوصول.",
    vendor_route_confirm_checkin:    "تأكيد تسجيل الوصول",
    vendor_map_view:                 "عرض الخريطة",
    vendor_map_satellite:            "صور الأقمار الصناعية",
    vendor_stats_title:              "إحصاءاتي",
    vendor_stats_today:              "اليوم",
    vendor_stats_week:               "هذا الأسبوع",
    vendor_stats_total:              "إجمالي الزيارات",
    vendor_stats_avg:                "متوسط / يوم",
    vendor_stats_breakdown:          "تفصيل الزيارات",
    vendor_stats_manual:             "يدوي:",
    vendor_stats_auto:               "GPS تلقائي:",
    vendor_stats_last7:              "آخر 7 أيام",
    vendor_stats_last4w:             "آخر 4 أسابيع",
    vendor_stats_recent:             "تسجيلات الوصول الأخيرة",
    vendor_stats_no_checkins:        "لا توجد تسجيلات وصول بعد",
    vendor_stats_away:               "بعيداً",
    vendor_stock_products:           "المنتجات",
    vendor_stock_units:              "وحدات بالمجموع",
    vendor_stock_sales_today:        "مبيعات اليوم",
    vendor_stock_this_week:          "هذا الأسبوع",
    vendor_stock_current:            "المخزون الحالي",
    vendor_stock_request_restock:    "طلب إعادة التخزين",
    vendor_stock_no_items:           "لا توجد أصناف مخزون مخصصة بعد",
    vendor_stock_low:                "منخفض",
    vendor_stock_recent_sales:       "المبيعات الأخيرة",
    vendor_stock_today_revenue:      "اليوم:",
    vendor_stock_no_sales:           "لا توجد مبيعات بعد",
    vendor_stock_pending_sync:       "في انتظار المزامنة",
    vendor_stock_print:              "طباعة",
    vendor_profile_appearance:       "المظهر",
    vendor_profile_dark_mode:        "الوضع الداكن",
    vendor_profile_dark_hint:        "التبديل إلى السمة الداكنة",
    vendor_profile_send_note:        "إرسال ملاحظة عامة",
    vendor_profile_sync_status:      "حالة المزامنة",
    vendor_profile_online:           "متصل",
    vendor_profile_offline_msg:      "غير متصل — البيانات محفوظة محلياً",
    vendor_profile_last_sync:        "آخر مزامنة:",
    vendor_profile_never:            "أبداً",
    vendor_profile_pending:          "معلّق",
    vendor_profile_change_pw:        "تغيير كلمة المرور",
    vendor_profile_current_pw:       "كلمة المرور الحالية",
    vendor_profile_new_pw:           "كلمة المرور الجديدة",
    vendor_profile_confirm_pw:       "تأكيد كلمة المرور الجديدة",
    vendor_profile_pw_mismatch:      "كلمتا المرور الجديدتان غير متطابقتين.",
    vendor_profile_pw_short:         "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل.",
    vendor_profile_pw_wrong:         "كلمة المرور الحالية غير صحيحة.",
    vendor_profile_pw_saved:         "تم تحديث كلمة المرور بنجاح.",
    vendor_profile_updating:         "جارٍ التحديث...",
    vendor_profile_update_pw:        "تحديث كلمة المرور",
    vendor_note_describe_ph:         "صِف المشكلة أو الملاحظة...",
    // Supervisor dashboard sub-components
    sup_dash_appearance:             "المظهر",
    sup_dash_dark_hint:              "التبديل إلى السمة الداكنة",
    sup_dash_send_note_title:        "إرسال ملاحظة إلى المسؤول",
    sup_dash_note_describe_ph:       "صِف المشكلة أو الملاحظة...",
    sup_dash_cancel:                 "إلغاء",
    sup_dash_online_vendor:          "موزع متصل",
    sup_dash_offline_vendor:         "موزع غير متصل",
    sup_dash_client_label:           "عميل",
    sup_dash_zones_legend:           "المناطق المظللة = مناطقك",
    sup_dash_total_clients:          "إجمالي العملاء",
    sup_dash_read_only:              "للقراءة فقط",
    sup_dash_all_zones:              "جميع المناطق",
    sup_dash_no_clients_found:       "لم يُعثر على عملاء.",
    sup_dash_no_vendors_yet:         "لا يوجد موزعون مخصصون بعد.",
    sup_dash_events_history:         "الأحداث والسجل",
    sup_dash_events_zones:           "إجمالي الأحداث في مناطقك",
    sup_dash_all:                    "الكل",
    sup_dash_visits:                 "الزيارات",
    sup_dash_zone_enter:             "دخول المنطقة",
    sup_dash_zone_exit:              "خروج المنطقة",
    sup_dash_session_start:          "بدء الجلسة",
    sup_dash_session_end:            "انتهاء الجلسة",
    sup_dash_all_vendors:            "جميع الموزعين",
    sup_dash_no_events_filter:       "لا توجد أحداث تطابق الفلاتر.",
    sup_dash_clients_in_zones:       "عملاء في مناطقك",
    sup_dash_vendors_assigned:       "موزع (موزعون) مخصصون لك",

    // ── SuperAdmin Dashboard (AR) ─────────────────────────────────────────────
    sa_super_admin_badge:            "المسؤول الأعلى",
    nav_all_companies:               "جميع الشركات",
    nav_create_company:              "إنشاء شركة",
    nav_global_settings:             "الإعدادات العامة",
    nav_health:                      "صحة المنصة",
    nav_sa_settings:                 "إعداداتي",
    sa_viewing:                      "عرض:",
    sa_back_all:                     "← العودة للكل",
    sa_companies_count:              "شركات",
    sa_active_companies:             "نشطة",
    sa_total_vendors:                "إجمالي الموزعين",
    sa_total_clients:                "إجمالي العملاء",
    sa_expired_subs:                 "الاشتراكات المنتهية",
    sa_search_companies:             "البحث عن الشركات...",
    sa_no_companies:                 "لم يُعثر على شركات.",
    sa_last_activity:                "آخر نشاط",
    sa_vendors:                      "موزعون",
    sa_clients:                      "عملاء",
    sa_zones:                        "مناطق",
    sa_events:                       "أحداث",
    sa_status_paid:                  "مدفوع",
    sa_status_trial:                 "تجريبي",
    sa_status_unpaid:                "غير مدفوع",
    sa_status_expired:               "منتهٍ",
    sa_view_details:                 "عرض التفاصيل",
    sa_disable:                      "تعطيل",
    sa_enable:                       "تفعيل",
    sa_delete:                       "حذف",
    sa_confirm_disable:              "تعطيل الشركة",
    sa_confirm_enable:               "تفعيل الشركة",
    sa_confirm_delete:               "حذف الشركة",
    sa_disable_msg:                  "سيمنع هذا جميع مستخدمي الشركة من تسجيل الدخول.",
    sa_enable_msg:                   "سيستعيد هذا الوصول لجميع مستخدمي الشركة.",
    sa_delete_msg:                   "سيتم حذف جميع المستخدمين والعملاء والموزعين والمناطق والأحداث نهائياً. لا يمكن التراجع.",
    sa_deleting:                     "جارٍ الحذف...",
  },
};

export default translations;
